import { api } from "api/api";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
  Time: { input: any; output: any };
  Void: { input: any; output: any };
}

export interface AchievementsType {
  achievements: Array<UserAchievementType>;
  achievementsNew: Array<UserAchievementType>;
  aggregate: Array<AggregateType>;
}

export interface AchievementsTypeAchievementsArgs {
  count?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdmissionTestType {
  date?: Maybe<Scalars["Date"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface AggregateType {
  achievementType: Scalars["String"]["output"];
  countNew?: Maybe<Scalars["Int"]["output"]>;
  countTotal: Scalars["Int"]["output"];
  dateLast?: Maybe<Scalars["Date"]["output"]>;
}

export interface AggregationsType {
  moodOverall?: Maybe<Scalars["Float"]["output"]>;
  user: UserType;
}

export interface AnswerInput {
  autoEval?: InputMaybe<Array<QuestionAutoInput>>;
  selfEval?: InputMaybe<Scalars["Int"]["input"]>;
  timeSolveReal: Scalars["Int"]["input"];
  userAssignmentId: Scalars["String"]["input"];
}

export interface AnswerType {
  attemptNo: Scalars["Int"]["output"];
  correctAnswers?: Maybe<Array<Array<Maybe<Scalars["String"]["output"]>>>>;
  scoreReal: Scalars["Float"]["output"];
  sessionId: Scalars["String"]["output"];
}

export interface AssignmentCloseInput {
  abilityScore: Scalars["Float"]["input"];
  timeLearnReal: Scalars["Int"]["input"];
  tip: Scalars["Boolean"]["input"];
  userAssignmentId: Scalars["String"]["input"];
}

export interface AssignmentImageDimensions {
  height?: Maybe<Scalars["Int"]["output"]>;
  width?: Maybe<Scalars["Int"]["output"]>;
}

export interface AssignmentType {
  Assignment?: Maybe<AssignmentTypeNested>;
  AssignmentIsInitialized: Scalars["Boolean"]["output"];
  General?: Maybe<GeneralType>;
  GeneralIsInitialized: Scalars["Boolean"]["output"];
  analysis?: Maybe<SharedAnalysisType>;
  assignment?: Maybe<AssignmentTypeNested>;
  assignmentBak?: Maybe<AssignmentTypeNested>;
  general?: Maybe<GeneralType>;
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  isOnboarding: Scalars["Boolean"]["output"];
  scoring?: Maybe<ScoringType>;
  selfEvaluation?: Maybe<SharedSelfEvaluationType>;
  successRate?: Maybe<Scalars["Float"]["output"]>;
  testName?: Maybe<Scalars["String"]["output"]>;
}

export interface AssignmentTypeNested {
  AssignmentImageDimensions?: Maybe<AssignmentImageDimensions>;
  Questions?: Maybe<Array<QuestionType>>;
  QuestionsIsInitialized: Scalars["Boolean"]["output"];
  assignmentAudio?: Maybe<Scalars["String"]["output"]>;
  assignmentImage?: Maybe<Scalars["String"]["output"]>;
  assignmentImageThumbHash?: Maybe<Scalars["String"]["output"]>;
  assignmentText?: Maybe<Scalars["String"]["output"]>;
  assignmentType: AssignmentTypeType;
  isAnswerCaseSensitive?: Maybe<Scalars["Boolean"]["output"]>;
  printingAttachment?: Maybe<Scalars["String"]["output"]>;
  questions: Array<QuestionType>;
  questionsText?: Maybe<Scalars["String"]["output"]>;
  transcriptCs?: Maybe<Scalars["String"]["output"]>;
  transcriptEn?: Maybe<Scalars["String"]["output"]>;
}

export interface AssignmentTypeType {
  name?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
}

export interface BlacklistItemInput {
  userAssignmentId: Scalars["String"]["input"];
}

export interface BlacklistItemType {
  id: Scalars["String"]["output"];
  user: UserType;
  userAssignment: UserAssignmentType;
  userId: Scalars["String"]["output"];
  userIdZona: Scalars["String"]["output"];
}

export interface BookCardType {
  bookId: Scalars["String"]["output"];
  cardText?: Maybe<Scalars["String"]["output"]>;
  categoryId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  question?: Maybe<Scalars["String"]["output"]>;
}

export interface BookExamAnswerConfirmInput {
  uploadId: Scalars["String"]["input"];
}

export interface BookExamAnswerType {
  contentType: Scalars["String"]["output"];
  createdAt: Scalars["String"]["output"];
  durationMs: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  playbackUrl: Scalars["String"]["output"];
  questionId: Scalars["String"]["output"];
}

export interface BookExamAnswerUploadInput {
  contentType: Scalars["String"]["input"];
  durationMs: Scalars["Int"]["input"];
  fileExtension: Scalars["String"]["input"];
  fileSize: Scalars["Int"]["input"];
  questionId: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
}

export interface BookType {
  authorBio?: Maybe<Scalars["String"]["output"]>;
  authorCountry?: Maybe<CountryType>;
  authorFullName?: Maybe<Scalars["String"]["output"]>;
  bookDiff?: Maybe<Scalars["String"]["output"]>;
  bookTheme?: Maybe<Scalars["String"]["output"]>;
  cheatSheetLong?: Maybe<Scalars["String"]["output"]>;
  cheatSheetShort?: Maybe<Scalars["String"]["output"]>;
  direction?: Maybe<Scalars["String"]["output"]>;
  emojis?: Maybe<Scalars["String"]["output"]>;
  englishUsage?: Maybe<Scalars["String"]["output"]>;
  firstPublicationYear?: Maybe<Scalars["String"]["output"]>;
  freeStreamingUrl?: Maybe<Scalars["String"]["output"]>;
  genre?: Maybe<GenreType>;
  graduationReadingPeriodId?: Maybe<Scalars["String"]["output"]>;
  graduationReadingTypeId?: Maybe<Scalars["String"]["output"]>;
  hasDetail?: Maybe<Scalars["Boolean"]["output"]>;
  hasEnglishUsage?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  literaryPeriod?: Maybe<Scalars["String"]["output"]>;
  mainCharacters?: Maybe<Scalars["String"]["output"]>;
  mainPicture?: Maybe<Scalars["String"]["output"]>;
  nameCz?: Maybe<Scalars["String"]["output"]>;
  nameOriginal?: Maybe<Scalars["String"]["output"]>;
  narratorAndLanguage?: Maybe<Scalars["String"]["output"]>;
  orderAudioHasDiscount?: Maybe<Scalars["Boolean"]["output"]>;
  orderAudioLink?: Maybe<Scalars["String"]["output"]>;
  orderNewHasDiscount?: Maybe<Scalars["Boolean"]["output"]>;
  orderNewLink?: Maybe<Scalars["String"]["output"]>;
  orderOnlineHasDiscount?: Maybe<Scalars["Boolean"]["output"]>;
  orderOnlineLink?: Maybe<Scalars["String"]["output"]>;
  orderUsedHasDiscount?: Maybe<Scalars["Boolean"]["output"]>;
  orderUsedLink?: Maybe<Scalars["String"]["output"]>;
  pagesCount?: Maybe<Scalars["String"]["output"]>;
  paidStreamingProvider?: Maybe<Scalars["String"]["output"]>;
  paidStreamingUrl?: Maybe<Scalars["String"]["output"]>;
  picture1?: Maybe<Scalars["String"]["output"]>;
  picture1Source?: Maybe<Scalars["String"]["output"]>;
  picture2?: Maybe<Scalars["String"]["output"]>;
  picture2Source?: Maybe<Scalars["String"]["output"]>;
  picture3?: Maybe<Scalars["String"]["output"]>;
  picture3Source?: Maybe<Scalars["String"]["output"]>;
  picture4?: Maybe<Scalars["String"]["output"]>;
  picture4Source?: Maybe<Scalars["String"]["output"]>;
  pictureSource?: Maybe<Scalars["String"]["output"]>;
  plot?: Maybe<Scalars["String"]["output"]>;
  podcastLong?: Maybe<Scalars["String"]["output"]>;
  podcastShort?: Maybe<Scalars["String"]["output"]>;
  readingLength?: Maybe<Scalars["String"]["output"]>;
  spacetime?: Maybe<Scalars["String"]["output"]>;
  summary?: Maybe<Scalars["String"]["output"]>;
  themes?: Maybe<Scalars["String"]["output"]>;
  trailerUrl?: Maybe<Scalars["String"]["output"]>;
  video?: Maybe<Scalars["String"]["output"]>;
  worksheetBlank?: Maybe<Scalars["String"]["output"]>;
  worksheetFilled?: Maybe<Scalars["String"]["output"]>;
}

export interface BookmarkInput {
  userAssignmentId: Scalars["String"]["input"];
}

export interface BookmarkType {
  id: Scalars["String"]["output"];
  user: UserType;
  userAssignment: UserAssignmentType;
  userId: Scalars["String"]["output"];
  userIdZona: Scalars["String"]["output"];
}

export interface CombinedTopicType {
  assignments: Array<AssignmentType>;
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  topics: Array<TopicType>;
}

export interface CommonSelfEvaluationType {
  general?: Maybe<SelfEvalGeneralType>;
  options: Array<SelfEvalOptionType>;
}

export interface ConsolidationCategoryType {
  focus?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  isArtText?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  position?: Maybe<Scalars["Int"]["output"]>;
  textGreen?: Maybe<Scalars["String"]["output"]>;
  textOrange?: Maybe<Scalars["String"]["output"]>;
  textRed?: Maybe<Scalars["String"]["output"]>;
}

export interface CountryType {
  emoji?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface DatetimeType {
  iso: Scalars["DateTime"]["output"];
}

export interface DeletionType {
  collectionName: Scalars["String"]["output"];
  objectsDeleted: Array<Scalars["String"]["output"]>;
}

export interface DifficultyType {
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface EnvelopeMovementType {
  envelopeBefore: Scalars["String"]["output"];
  envelopeNow?: Maybe<Scalars["String"]["output"]>;
  userAssigment: Scalars["String"]["output"];
}

export interface EnvelopesSummaryType {
  green: Scalars["Int"]["output"];
  red: Scalars["Int"]["output"];
  yellow: Scalars["Int"]["output"];
}

export interface EvaluationClaimInput {
  questions: Array<Scalars["Boolean"]["input"]>;
  userAssignmentId: Scalars["String"]["input"];
}

export interface ExamBlockType {
  categoryId: Scalars["String"]["output"];
  index: Scalars["Int"]["output"];
  questionIds: Array<Scalars["String"]["output"]>;
}

export interface ExamCategoryResultType {
  categoryId: Scalars["String"]["output"];
  level: Scalars["String"]["output"];
}

export interface ExamCategoryType {
  focus?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  isArtText?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  position?: Maybe<Scalars["Int"]["output"]>;
  textGreen?: Maybe<Scalars["String"]["output"]>;
  textOrange?: Maybe<Scalars["String"]["output"]>;
  textRed?: Maybe<Scalars["String"]["output"]>;
}

export interface ExamHistoryEntryType {
  bookId: Scalars["String"]["output"];
  bookName: Scalars["String"]["output"];
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  result?: Maybe<ExamResultType>;
  startedAt: Scalars["String"]["output"];
  step: Scalars["String"]["output"];
}

export interface ExamPositionType {
  commissionBlock?: Maybe<Scalars["Int"]["output"]>;
  commissionQuestion?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["String"]["output"];
}

export interface ExamResultType {
  algoVersion?: Maybe<Scalars["String"]["output"]>;
  grade: Scalars["Int"]["output"];
  perCategory: Array<ExamCategoryResultType>;
  pointsToBetter?: Maybe<Scalars["Int"]["output"]>;
  sections: Array<ExamSectionResultType>;
  totalPoints?: Maybe<Scalars["Int"]["output"]>;
}

export interface ExamSectionResultType {
  level: Scalars["String"]["output"];
  points?: Maybe<Scalars["Float"]["output"]>;
  score?: Maybe<Scalars["Float"]["output"]>;
  sectionId: Scalars["String"]["output"];
}

export interface ExamSessionType {
  blocks: Array<ExamBlockType>;
  bookId: Scalars["String"]["output"];
  commissionBlock?: Maybe<Scalars["Int"]["output"]>;
  commissionQuestion?: Maybe<Scalars["Int"]["output"]>;
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  ratings: Scalars["JSON"]["output"];
  reachedCommission?: Maybe<Scalars["Boolean"]["output"]>;
  result?: Maybe<ExamResultType>;
  settings: ExamSettingsType;
  speechClips?: Maybe<ExamSpeechClipsType>;
  speechRating?: Maybe<Scalars["String"]["output"]>;
  speechRatings: Scalars["JSON"]["output"];
  startedAt: Scalars["String"]["output"];
  step: Scalars["String"]["output"];
}

export interface ExamSettingsInput {
  durationMin: Scalars["Int"]["input"];
  hasAmbience: Scalars["Boolean"]["input"];
  isRecording: Scalars["Boolean"]["input"];
}

export interface ExamSettingsType {
  durationMin: Scalars["Int"]["output"];
  hasAmbience: Scalars["Boolean"]["output"];
  isRecording: Scalars["Boolean"]["output"];
}

export interface ExamSpeechClipsInput {
  filler?: InputMaybe<Scalars["String"]["input"]>;
  reasoning: Array<Scalars["String"]["input"]>;
  slang?: InputMaybe<Scalars["String"]["input"]>;
}

export interface ExamSpeechClipsType {
  filler?: Maybe<Scalars["String"]["output"]>;
  reasoning: Array<Scalars["String"]["output"]>;
  slang?: Maybe<Scalars["String"]["output"]>;
}

export interface ExerciseAttemptType {
  abilityScore?: Maybe<Scalars["Float"]["output"]>;
  answered?: Maybe<Scalars["Boolean"]["output"]>;
  attemptNo?: Maybe<Scalars["Int"]["output"]>;
  dateTested?: Maybe<Scalars["String"]["output"]>;
  practiceType?: Maybe<Scalars["String"]["output"]>;
  scoreReal?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  timeLearnReal?: Maybe<Scalars["Int"]["output"]>;
  timeSolveReal?: Maybe<Scalars["Int"]["output"]>;
}

export interface FaqType {
  description?: Maybe<Scalars["String"]["output"]>;
  grade?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
}

export interface GeneralType {
  AdmissionTest?: Maybe<AdmissionTestType>;
  AdmissionTestIsInitialized: Scalars["Boolean"]["output"];
  admissionTest: AdmissionTestType;
  author: TestAuthorType;
  exerciseSource?: Maybe<Scalars["String"]["output"]>;
  mhdFriendly?: Maybe<Scalars["Boolean"]["output"]>;
  testOrder?: Maybe<Scalars["Int"]["output"]>;
}

export interface GenreType {
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface GraduationReadingPeriodType {
  id: Scalars["String"]["output"];
  internalCode?: Maybe<Scalars["String"]["output"]>;
  minBooks?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  shortcut?: Maybe<Scalars["String"]["output"]>;
}

export interface GraduationReadingTypeType {
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  internalCode?: Maybe<Scalars["String"]["output"]>;
  minBooks?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface LearningAttemptType {
  dateTested: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  session?: Maybe<SessionType>;
  tutoringSnapshot?: Maybe<TutoringSnapshotType>;
}

export interface LoginInput {
  handshake: Scalars["String"]["input"];
}

export interface LoginType {
  accessToken?: Maybe<Scalars["String"]["output"]>;
  apiMessage?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
}

export interface MasterclassProgressType {
  completed: Scalars["JSON"]["output"];
  viewed: Scalars["JSON"]["output"];
}

export interface MasterclassSettingsType {
  guideBio?: Maybe<Scalars["String"]["output"]>;
  guideLabel?: Maybe<Scalars["String"]["output"]>;
  guideName?: Maybe<Scalars["String"]["output"]>;
  guidePhoto?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  infoBox?: Maybe<Scalars["String"]["output"]>;
  perex?: Maybe<Scalars["String"]["output"]>;
}

export interface MasterclassType {
  deadline?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  length?: Maybe<Scalars["String"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  order?: Maybe<Scalars["Int"]["output"]>;
  pdf?: Maybe<Scalars["String"]["output"]>;
  pdfDescription?: Maybe<Scalars["String"]["output"]>;
  pdfName?: Maybe<Scalars["String"]["output"]>;
  previewImage?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  video?: Maybe<Scalars["String"]["output"]>;
}

export interface MockExamQuestionType {
  answer?: Maybe<Scalars["String"]["output"]>;
  bookId: Scalars["String"]["output"];
  categoryId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  order?: Maybe<Scalars["Int"]["output"]>;
  question?: Maybe<Scalars["String"]["output"]>;
}

export interface Mutation {
  answer: AnswerType;
  bookExamAnswerConfirm: Scalars["Boolean"]["output"];
  bookExamAnswerUploadUrl: SignedUrlType;
  claimEvaluation: AnswerType;
  claimScoreMax: AnswerType;
  createUnrecognizedAnswer: UnrecognizedAnswerType;
  deleteBlacklistItem: DeletionType;
  deleteBookmark: DeletionType;
  deleteTimetableDay: DeletionType;
  deleteTimetableWeek: DeletionType;
  examAttemptDiscard: Scalars["Boolean"]["output"];
  examAttemptStart: ExamSessionType;
  examFinish: ExamSessionType;
  examPositionSet: ExamPositionType;
  examQuestionRate: ExamSessionType;
  examRateSpeech: ExamSessionType;
  examSpeechClipsSet: ExamSessionType;
  examStepSet: ExamSessionType;
  login: LoginType;
  masterclassVideoCompleted: MasterclassProgressType;
  masterclassVideoViewed: MasterclassProgressType;
  nonfictionCardFlip: NonfictionProgressType;
  nonfictionProgressSet: NonfictionProgressType;
  nonfictionQuizAttemptStart: NonfictionQuizAttemptType;
  nonfictionQuizQuestionRate: NonfictionQuizRateType;
  parentWatchUpdate: ParentWatchType;
  practiceCardFlip: UserBookProgressType;
  practiceQuizAttemptStart: PracticeQuizAttemptType;
  practiceQuizQuestionRate: PracticeQuizAttemptType;
  sessionClose: SessionCloseType;
  sessionCreate: SessionType;
  sessionStart: SessionType;
  setBlacklistItem: BlacklistItemType;
  setBookmark: BookmarkType;
  setTimetable: TimetableType;
  setTimetableGeneric: TimetableGenericType;
  solutionUploadConfirm?: Maybe<Scalars["Void"]["output"]>;
  solutionUploadUrl: SignedUrlType;
  timeTravel: DatetimeType;
  timeTravelReset: DatetimeType;
  tutoringAnswer: TutoringAnswerType;
  tutoringClaimEvaluation: TutoringAnswerType;
  tutoringClose: TutoringCloseType;
  tutoringReset: TutoringResetType;
  tutoringSolutionUploadConfirm?: Maybe<Scalars["Void"]["output"]>;
  tutoringSolutionUploadUrl: SignedUrlType;
  updateOnboarding: OnboardingType;
  updatePhone: PhoneValidationType;
  updateUser: UserType;
  userBookProgressSet: UserBookProgressType;
  userBooksSet: Array<UserBookType>;
  userThemeUpdate: UserThemeType;
  userTopicUpdate: UserTopicType;
  validatePhone: PhoneValidationType;
}

export interface MutationAnswerArgs {
  input: AnswerInput;
}

export interface MutationBookExamAnswerConfirmArgs {
  input: BookExamAnswerConfirmInput;
}

export interface MutationBookExamAnswerUploadUrlArgs {
  input: BookExamAnswerUploadInput;
}

export interface MutationClaimEvaluationArgs {
  claimInput: EvaluationClaimInput;
}

export interface MutationClaimScoreMaxArgs {
  input: ScoreClaimInput;
}

export interface MutationCreateUnrecognizedAnswerArgs {
  input: UnrecognizedAnswerInput;
}

export interface MutationDeleteBlacklistItemArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteBookmarkArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteTimetableDayArgs {
  dayDate: Array<Scalars["Date"]["input"]>;
}

export interface MutationDeleteTimetableWeekArgs {
  weekStr: Array<Scalars["String"]["input"]>;
}

export interface MutationExamAttemptDiscardArgs {
  bookId: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
}

export interface MutationExamAttemptStartArgs {
  bookId: Scalars["String"]["input"];
  settings: ExamSettingsInput;
}

export interface MutationExamFinishArgs {
  bookId: Scalars["String"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface MutationExamPositionSetArgs {
  blockIndex: Scalars["Int"]["input"];
  bookId: Scalars["String"]["input"];
  questionIndex: Scalars["Int"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface MutationExamQuestionRateArgs {
  bookId: Scalars["String"]["input"];
  questionId: Scalars["String"]["input"];
  rating: Scalars["String"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface MutationExamRateSpeechArgs {
  bookId: Scalars["String"]["input"];
  criterion?: InputMaybe<Scalars["String"]["input"]>;
  rating: Scalars["String"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface MutationExamSpeechClipsSetArgs {
  bookId: Scalars["String"]["input"];
  clips: ExamSpeechClipsInput;
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface MutationExamStepSetArgs {
  bookId: Scalars["String"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
  step: Scalars["String"]["input"];
}

export interface MutationLoginArgs {
  loginInput: LoginInput;
}

export interface MutationMasterclassVideoCompletedArgs {
  completed: Scalars["Boolean"]["input"];
  videoId: Scalars["String"]["input"];
}

export interface MutationMasterclassVideoViewedArgs {
  videoId: Scalars["String"]["input"];
}

export interface MutationNonfictionCardFlipArgs {
  cardId: Scalars["String"]["input"];
}

export interface MutationNonfictionProgressSetArgs {
  input: NonfictionProgressInput;
}

export interface MutationNonfictionQuizQuestionRateArgs {
  questionId: Scalars["String"]["input"];
  verdict: Scalars["String"]["input"];
}

export interface MutationParentWatchUpdateArgs {
  inputRewards: ParentWatchInput;
}

export interface MutationPracticeCardFlipArgs {
  bookId: Scalars["String"]["input"];
  cardId: Scalars["String"]["input"];
}

export interface MutationPracticeQuizAttemptStartArgs {
  bookId: Scalars["String"]["input"];
}

export interface MutationPracticeQuizQuestionRateArgs {
  bookId: Scalars["String"]["input"];
  questionId: Scalars["String"]["input"];
  verdict: Scalars["String"]["input"];
}

export interface MutationSessionCloseArgs {
  input: SessionCloseInput;
}

export interface MutationSessionCreateArgs {
  assignmentId?: InputMaybe<Scalars["String"]["input"]>;
  lengthPreference: Scalars["Int"]["input"];
}

export interface MutationSetBlacklistItemArgs {
  input: BlacklistItemInput;
}

export interface MutationSetBookmarkArgs {
  input: BookmarkInput;
}

export interface MutationSetTimetableArgs {
  input: TimetableInput;
}

export interface MutationSetTimetableGenericArgs {
  input: TimetableGenericInput;
}

export interface MutationSolutionUploadConfirmArgs {
  input: SolutionUploadConfirmationInput;
}

export interface MutationSolutionUploadUrlArgs {
  input: SolutionUploadInput;
}

export interface MutationTimeTravelArgs {
  input: TimeMachineInput;
}

export interface MutationTutoringAnswerArgs {
  input: TutoringAnswerInput;
}

export interface MutationTutoringClaimEvaluationArgs {
  claimInput: TutoringEvaluationClaimInput;
}

export interface MutationTutoringCloseArgs {
  input: TutoringCloseInput;
}

export interface MutationTutoringResetArgs {
  input: TutoringResetInput;
}

export interface MutationTutoringSolutionUploadConfirmArgs {
  input: SolutionUploadConfirmationInput;
}

export interface MutationTutoringSolutionUploadUrlArgs {
  input: TutoringSolutionUploadInput;
}

export interface MutationUpdateOnboardingArgs {
  input: OnboardingInput;
}

export interface MutationUpdatePhoneArgs {
  input: PhoneInput;
}

export interface MutationUpdateUserArgs {
  input: UserInput;
}

export interface MutationUserBookProgressSetArgs {
  bookId: Scalars["String"]["input"];
  input: UserBookProgressInput;
}

export interface MutationUserBooksSetArgs {
  input: UserBooksInput;
}

export interface MutationUserThemeUpdateArgs {
  id: Scalars["String"]["input"];
  input: UserThemeInput;
}

export interface MutationUserTopicUpdateArgs {
  id: Scalars["String"]["input"];
  input: UserTopicInput;
}

export interface MutationValidatePhoneArgs {
  input: PhoneValidationInput;
}

export interface NewAssignmentAnnouncementType {
  date?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  grade: Scalars["String"]["output"];
  testType: Scalars["String"]["output"];
}

export interface NonfictionCardType {
  cardText?: Maybe<Scalars["String"]["output"]>;
  categoryId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  position?: Maybe<Scalars["Int"]["output"]>;
  question?: Maybe<Scalars["String"]["output"]>;
}

export interface NonfictionCategoryType {
  heading?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  position?: Maybe<Scalars["Int"]["output"]>;
}

export interface NonfictionProgressInput {
  hasConsolidated?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasLearned?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface NonfictionProgressType {
  flips: Scalars["JSON"]["output"];
  hasConsolidated: Scalars["Boolean"]["output"];
  hasLearned: Scalars["Boolean"]["output"];
  quizPassScore: Scalars["Int"]["output"];
  quizTotal: Scalars["Int"]["output"];
}

export interface NonfictionQaCardType {
  answer?: Maybe<Scalars["String"]["output"]>;
  categoryId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  position?: Maybe<Scalars["Int"]["output"]>;
  question?: Maybe<Scalars["String"]["output"]>;
}

export interface NonfictionQuizAttemptType {
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  startedAt: Scalars["String"]["output"];
  verdicts: Scalars["JSON"]["output"];
}

export interface NonfictionQuizRateType {
  attempt: NonfictionQuizAttemptType;
  progress?: Maybe<NonfictionProgressType>;
}

export interface NonfictionTextType {
  cheatSheet?: Maybe<Scalars["String"]["output"]>;
  cheatSheetName?: Maybe<Scalars["String"]["output"]>;
  cheatSheetNote?: Maybe<Scalars["String"]["output"]>;
  coverArt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  video?: Maybe<Scalars["String"]["output"]>;
}

export interface OnboardingInput {
  finished?: InputMaybe<Scalars["Boolean"]["input"]>;
  introduced?: InputMaybe<Scalars["Boolean"]["input"]>;
  welcome?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface OnboardingType {
  finished: Scalars["Boolean"]["output"];
  introduced: Scalars["Boolean"]["output"];
  welcome: Scalars["Boolean"]["output"];
}

export interface OptionType {
  additionalText?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
}

export interface OutageType {
  endTime?: Maybe<Scalars["Date"]["output"]>;
  grade?: Maybe<Scalars["String"]["output"]>;
  startTime?: Maybe<Scalars["Date"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
}

export interface ParentRewardInput {
  month?: InputMaybe<Scalars["Int"]["input"]>;
  targetScore?: InputMaybe<Scalars["Int"]["input"]>;
  text: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
}

export interface ParentRewardType {
  month?: Maybe<Scalars["Int"]["output"]>;
  targetScore?: Maybe<Scalars["Int"]["output"]>;
  text: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
}

export interface ParentWatchInput {
  message?: InputMaybe<Scalars["String"]["input"]>;
  rewards: Array<ParentRewardInput>;
}

export interface ParentWatchType {
  message?: Maybe<Scalars["String"]["output"]>;
  rewards: Array<ParentRewardType>;
  user: UserType;
}

export interface PhoneInput {
  phoneNumber: Scalars["String"]["input"];
  smsEnabled: Scalars["Boolean"]["input"];
}

export interface PhoneValidationInput {
  validationCode: Scalars["String"]["input"];
}

export interface PhoneValidationType {
  datetimeLast?: Maybe<Scalars["String"]["output"]>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  waiting: Scalars["Boolean"]["output"];
}

export interface PracticeQuizAttemptType {
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  startedAt: Scalars["String"]["output"];
  verdicts: Scalars["JSON"]["output"];
}

export interface ProbingQuestionType {
  answer?: Maybe<Scalars["String"]["output"]>;
  bookId: Scalars["String"]["output"];
  categoryId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  order?: Maybe<Scalars["Int"]["output"]>;
  question?: Maybe<Scalars["String"]["output"]>;
}

export interface QaCardType {
  answer?: Maybe<Scalars["String"]["output"]>;
  bookId: Scalars["String"]["output"];
  categoryId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  order?: Maybe<Scalars["Int"]["output"]>;
  question?: Maybe<Scalars["String"]["output"]>;
}

export interface Query {
  aggregations: AggregationsType;
  assignments: Array<AssignmentType>;
  blacklistItems: Array<BlacklistItemType>;
  blindSpotThemes: Array<UserThemeType>;
  blindSpotTopics: Array<UserTopicType>;
  bookCards: Array<BookCardType>;
  bookExamAnswers: Array<BookExamAnswerType>;
  bookmarks: Array<BookmarkType>;
  bookmarksCached: Array<BookmarkType>;
  books: Array<BookType>;
  checkAchievements: AchievementsType;
  combinedTopics: Array<CombinedTopicType>;
  combinedTopicsCached: Array<CombinedTopicType>;
  consolidationCategories: Array<ConsolidationCategoryType>;
  currentDatetime: DatetimeType;
  currentUser: UserType;
  displayNewAssignmentAnnouncements: Array<NewAssignmentAnnouncementType>;
  displayOutages: Array<OutageType>;
  envelopesSummary: EnvelopesSummaryType;
  examCategories: Array<ExamCategoryType>;
  examHistory: Array<ExamHistoryEntryType>;
  examSession?: Maybe<ExamSessionType>;
  examSessionById?: Maybe<ExamSessionType>;
  faqAll: Array<FaqType>;
  graduationReadingPeriods: Array<GraduationReadingPeriodType>;
  graduationReadingTypes: Array<GraduationReadingTypeType>;
  lastAchievements: Array<UserAchievementType>;
  learningAttempts: Array<LearningAttemptType>;
  masterclassProgress: MasterclassProgressType;
  masterclassSettings?: Maybe<MasterclassSettingsType>;
  masterclasses: Array<MasterclassType>;
  mockExamQuestions: Array<MockExamQuestionType>;
  nonfictionCards: Array<NonfictionCardType>;
  nonfictionCategories: Array<NonfictionCategoryType>;
  nonfictionProgress: NonfictionProgressType;
  nonfictionQaCards: Array<NonfictionQaCardType>;
  nonfictionQuizAttempt?: Maybe<NonfictionQuizAttemptType>;
  nonfictionText?: Maybe<NonfictionTextType>;
  onboarding: OnboardingType;
  onboardingAssignments: Array<AssignmentType>;
  parentWatch: ParentWatchType;
  practiceQuizAttempt?: Maybe<PracticeQuizAttemptType>;
  probingQuestions: Array<ProbingQuestionType>;
  qaCards: Array<QaCardType>;
  schools: Array<SchoolType>;
  stampedFileUrl: Scalars["String"]["output"];
  subjects: Array<SubjectType>;
  subjectsCached: Array<SubjectType>;
  superTopics: Array<SuperTopicType>;
  superTopicsCached: Array<SuperTopicType>;
  systemInfo: SystemInfoType;
  testPresence: Array<TestPresenceType>;
  themes: Array<ThemeType>;
  timetable: TimeWindowType;
  timetableGenericAll: Array<TimetableGenericType>;
  timetableGenericCurrent: TimetableGenericType;
  timetableGenericDate: TimetableGenericType;
  topics: Array<TopicType>;
  training: TrainingType;
  trainingEnvelope: Array<UserAssignmentType>;
  trainingMhd: TrainingType;
  unrecognizedAnswers: UnrecognizedAnswersWindowType;
  userAssignments: UserAssignmentTypePaginationWindowType;
  userAssignmentsCached: UserAssignmentTypePaginationWindowType;
  userAssignmentsFulltext: UserAssignmentTypePaginationWindowType;
  userBookProgress?: Maybe<UserBookProgressType>;
  userBookProgressAll: Array<UserBookProgressType>;
  userBooks: Array<UserBookType>;
  userCombinedTopic: UserCombinedTopicType;
  userCombinedTopics: Array<UserCombinedTopicType>;
  userCombinedTopicsCached: Array<UserCombinedTopicType>;
  userSelectedBooks: Array<BookType>;
  userSessionReview: Array<SessionReviewType>;
  userSubject: UserSubjectType;
  userSubjects: Array<UserSubjectType>;
  userSubjectsCached: Array<UserSubjectType>;
  userSuperTopic: UserSuperTopicType;
  userSuperTopics: Array<UserSuperTopicType>;
  userSuperTopicsCached: Array<UserSuperTopicType>;
  userTheme: UserThemeType;
  userThemes: Array<UserThemeType>;
  userThemesWorst: Array<UserThemeType>;
  userTopic: UserTopicType;
  userTopics: Array<UserTopicType>;
  userTopicsWorst: Array<UserTopicType>;
  userTutoringAll: Array<TutoringType>;
  userTutoringById: TutoringType;
  userTutoringsAndSessions: Array<SessionOrTutoringType>;
  videotipCategories: Array<VideotipCategoryType>;
  videotips: Array<VideotipType>;
  videotipsByCategory: Array<VideotipType>;
  weeklyChallenges: Array<WeeklyChallengeType>;
}

export interface QueryAssignmentsArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryBookCardsArgs {
  bookId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryBookExamAnswersArgs {
  sessionId: Scalars["String"]["input"];
}

export interface QueryBooksArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryCheckAchievementsArgs {
  check?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface QueryCombinedTopicsArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryCombinedTopicsCachedArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryExamHistoryArgs {
  bookId?: InputMaybe<Scalars["String"]["input"]>;
  limit?: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
}

export interface QueryExamSessionArgs {
  bookId: Scalars["String"]["input"];
}

export interface QueryExamSessionByIdArgs {
  sessionId: Scalars["String"]["input"];
}

export interface QueryLastAchievementsArgs {
  count: Scalars["Int"]["input"];
}

export interface QueryLearningAttemptsArgs {
  limit?: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
}

export interface QueryMockExamQuestionsArgs {
  bookId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryPracticeQuizAttemptArgs {
  bookId: Scalars["String"]["input"];
}

export interface QueryProbingQuestionsArgs {
  bookId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryQaCardsArgs {
  bookId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryStampedFileUrlArgs {
  fileName?: InputMaybe<Scalars["String"]["input"]>;
  path: Scalars["String"]["input"];
}

export interface QuerySubjectsArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QuerySubjectsCachedArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QuerySuperTopicsArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QuerySuperTopicsCachedArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryTestPresenceArgs {
  refresh?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface QueryThemesArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryTimetableArgs {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
}

export interface QueryTimetableGenericDateArgs {
  dayDate: Scalars["Date"]["input"];
}

export interface QueryTopicsArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryTrainingArgs {
  lengthPreference: Scalars["Int"]["input"];
}

export interface QueryTrainingEnvelopeArgs {
  envelope: Scalars["String"]["input"];
}

export interface QueryTrainingMhdArgs {
  lengthPreference: Scalars["Int"]["input"];
}

export interface QueryUnrecognizedAnswersArgs {
  filterInput?: InputMaybe<UnrecognizedAnswerFilterInput>;
}

export interface QueryUserAssignmentsArgs {
  filterInput: UserAssignmentFilterInput;
}

export interface QueryUserAssignmentsCachedArgs {
  filterInput: UserAssignmentFilterInput;
}

export interface QueryUserAssignmentsFulltextArgs {
  fulltextInput: UserAssignmentFulltextInput;
}

export interface QueryUserBookProgressArgs {
  bookId: Scalars["String"]["input"];
}

export interface QueryUserCombinedTopicArgs {
  id: Scalars["String"]["input"];
}

export interface QueryUserSessionReviewArgs {
  dateFrom: Scalars["Date"]["input"];
}

export interface QueryUserSubjectArgs {
  id: Scalars["String"]["input"];
}

export interface QueryUserSuperTopicArgs {
  id: Scalars["String"]["input"];
}

export interface QueryUserThemeArgs {
  id: Scalars["String"]["input"];
}

export interface QueryUserTopicArgs {
  id: Scalars["String"]["input"];
}

export interface QueryUserTutoringByIdArgs {
  tutoringId: Scalars["String"]["input"];
}

export interface QueryUserTutoringsAndSessionsArgs {
  assignmentId?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface QueryVideotipCategoriesArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryVideotipsArgs {
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryVideotipsByCategoryArgs {
  categoryId: Scalars["String"]["input"];
}

export interface QuestionAnalysisSharedType {
  explainerVideo?: Maybe<Scalars["String"]["output"]>;
  image?: Maybe<Scalars["String"]["output"]>;
  secondaryExplainerVideo?: Maybe<Scalars["String"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  writtenVideo?: Maybe<Scalars["String"]["output"]>;
}

export interface QuestionAnalysisType {
  explainerVideo?: Maybe<Scalars["String"]["output"]>;
  image?: Maybe<Scalars["String"]["output"]>;
  secondaryExplainerVideo?: Maybe<Scalars["String"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  writtenVideo?: Maybe<Scalars["String"]["output"]>;
}

export interface QuestionAutoInput {
  answers: Array<Scalars["String"]["input"]>;
}

export interface QuestionType {
  correctAnswers: Array<Maybe<Scalars["String"]["output"]>>;
  heading?: Maybe<Scalars["String"]["output"]>;
  options: Array<OptionType>;
  placeholder?: Maybe<Scalars["String"]["output"]>;
  selfEvaluation?: Maybe<CommonSelfEvaluationType>;
  showAbilityScore?: Maybe<Scalars["Boolean"]["output"]>;
  solutionAnalysis?: Maybe<QuestionAnalysisType>;
}

export interface SchoolType {
  name?: Maybe<Scalars["String"]["output"]>;
  pointsForAcceptance?: Maybe<Scalars["Int"]["output"]>;
}

export interface ScoreClaimInput {
  userAssignmentId: Scalars["String"]["input"];
}

export interface ScoringMethodType {
  id: Scalars["String"]["output"];
  scoringMethod?: Maybe<Scalars["String"]["output"]>;
}

export interface ScoringType {
  canTeacherEvaluate?: Maybe<Scalars["Boolean"]["output"]>;
  difficulty: DifficultyType;
  scoreMax?: Maybe<Scalars["Int"]["output"]>;
  scoringMethod: ScoringMethodType;
  selfEvaluation?: Maybe<SelfEvaluationType>;
  timeToSolve?: Maybe<Scalars["Int"]["output"]>;
}

export interface SelfEvalGeneralType {
  image?: Maybe<Scalars["String"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
}

export interface SelfEvalOptionType {
  image?: Maybe<Scalars["String"]["output"]>;
  scoreReal?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
}

export interface SelfEvaluationType {
  id: Scalars["String"]["output"];
  selfEvaluation?: Maybe<Scalars["String"]["output"]>;
}

export interface SessionCloseInput {
  assignmentsClose: Array<AssignmentCloseInput>;
  mood: Scalars["Int"]["input"];
  moodSelfReflection?: InputMaybe<Scalars["String"]["input"]>;
  moodText?: InputMaybe<Scalars["String"]["input"]>;
}

export interface SessionCloseType {
  assignmentsBase?: Maybe<Scalars["Int"]["output"]>;
  assignmentsBonus?: Maybe<Scalars["Int"]["output"]>;
  assignmentsTotal?: Maybe<Scalars["Int"]["output"]>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  finished: Scalars["Boolean"]["output"];
  lengthActual?: Maybe<Scalars["Int"]["output"]>;
  lengthPreference?: Maybe<Scalars["Int"]["output"]>;
  scoreRealTotal?: Maybe<Scalars["Int"]["output"]>;
  sessionId?: Maybe<Scalars["String"]["output"]>;
}

export interface SessionOrTutoringType {
  dateTested: Scalars["String"]["output"];
  session?: Maybe<SessionType>;
  tutoring?: Maybe<TutoringType>;
}

export interface SessionReviewType {
  dateTested: Scalars["Date"]["output"];
  finished: Scalars["Boolean"]["output"];
  scoreMaxTotal?: Maybe<Scalars["Int"]["output"]>;
  scoreRealTotal: Scalars["Int"]["output"];
  sessionId: Scalars["String"]["output"];
}

export interface SessionType {
  alreadyStarted: Scalars["Boolean"]["output"];
  assignmentsBase: Scalars["Int"]["output"];
  assignmentsBonus: Scalars["Int"]["output"];
  assignmentsTotal: Scalars["Int"]["output"];
  envelopeMovements: Array<EnvelopeMovementType>;
  id: Scalars["String"]["output"];
  lastSessionMood?: Maybe<Scalars["Int"]["output"]>;
  lastSessionMoodSelfReflection?: Maybe<Scalars["String"]["output"]>;
  lastSessionMoodText?: Maybe<Scalars["String"]["output"]>;
  lengthActual: Scalars["Int"]["output"];
  lengthPreference: Scalars["Int"]["output"];
  scoreMaxTotal?: Maybe<Scalars["Int"]["output"]>;
  scoreRealTotal?: Maybe<Scalars["Int"]["output"]>;
  userAssignments: Array<UserAssignmentType>;
}

export interface SharedAnalysisType {
  hasSharedAnalysis?: Maybe<Scalars["Boolean"]["output"]>;
  sharedAnalysis?: Maybe<QuestionAnalysisSharedType>;
}

export interface SharedSelfEvaluationType {
  hasSharedSelfEvaluation: Scalars["Boolean"]["output"];
  sharedSelfEvaluation?: Maybe<CommonSelfEvaluationType>;
}

export interface SignedUrlType {
  command: Scalars["String"]["output"];
  uploadId: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
}

export interface SolutionUploadConfirmationInput {
  solutionUploadId: Scalars["String"]["input"];
}

export interface SolutionUploadInput {
  contentType: Scalars["String"]["input"];
  fileExtension: Scalars["String"]["input"];
  fileSize: Scalars["Int"]["input"];
  userAssignmentId: Scalars["String"]["input"];
}

export interface StudyDayGenericInput {
  dayName: Scalars["String"]["input"];
  duration: Scalars["Int"]["input"];
  startAt: Scalars["Time"]["input"];
}

export interface StudyDayGenericType {
  dayName: Scalars["String"]["output"];
  duration?: Maybe<Scalars["Int"]["output"]>;
  startAt?: Maybe<Scalars["Time"]["output"]>;
}

export interface StudyDayInput {
  date?: InputMaybe<Scalars["Date"]["input"]>;
  duration?: InputMaybe<Scalars["Int"]["input"]>;
  startAt?: InputMaybe<Scalars["Time"]["input"]>;
}

export interface StudyDayType {
  date?: Maybe<Scalars["Date"]["output"]>;
  dayIndex?: Maybe<Scalars["Int"]["output"]>;
  dayName?: Maybe<Scalars["String"]["output"]>;
  duration?: Maybe<Scalars["Int"]["output"]>;
  durationReal?: Maybe<Scalars["Int"]["output"]>;
  perfectSession?: Maybe<Scalars["Boolean"]["output"]>;
  sessionFinished?: Maybe<Scalars["Boolean"]["output"]>;
  startAt?: Maybe<Scalars["Time"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  weekStr?: Maybe<Scalars["String"]["output"]>;
}

export interface SubjectType {
  SuperTopics?: Maybe<Array<SuperTopicType>>;
  SuperTopicsIsInitialized: Scalars["Boolean"]["output"];
  abbreviation?: Maybe<Scalars["String"]["output"]>;
  appAbbr?: Maybe<Scalars["String"]["output"]>;
  appName?: Maybe<Scalars["String"]["output"]>;
  assignments: Array<AssignmentType>;
  combinedTopics: Array<CombinedTopicType>;
  id: Scalars["String"]["output"];
  isFavorite?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
  superTopics: Array<SuperTopicType>;
  themes: Array<ThemeType>;
  topics: Array<TopicType>;
}

export interface SuperTopicType {
  CombinedTopics?: Maybe<Array<CombinedTopicType>>;
  CombinedTopicsIsInitialized: Scalars["Boolean"]["output"];
  assignments: Array<AssignmentType>;
  combinedTopics: Array<CombinedTopicType>;
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  topics: Array<TopicType>;
}

export interface SystemInfoType {
  containerId?: Maybe<Scalars["String"]["output"]>;
  dfAlh?: Maybe<Scalars["String"]["output"]>;
  dfH?: Maybe<Scalars["String"]["output"]>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  free?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
}

export interface TestAuthorType {
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface TestPresenceType {
  absolved?: Maybe<Scalars["Boolean"]["output"]>;
  dateTime: Scalars["String"]["output"];
  form?: Maybe<Scalars["String"]["output"]>;
  scoreCzech?: Maybe<Scalars["Int"]["output"]>;
  scoreEnglish?: Maybe<Scalars["Int"]["output"]>;
  scoreMath?: Maybe<Scalars["Int"]["output"]>;
  testId: Scalars["String"]["output"];
}

export interface ThemeType {
  appName?: Maybe<Scalars["String"]["output"]>;
  assignments: Array<AssignmentType>;
  avgTestPoints?: Maybe<Scalars["Int"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  subject?: Maybe<Scalars["String"]["output"]>;
  video?: Maybe<Array<VideoType>>;
}

export interface TimeMachineInput {
  day?: InputMaybe<Scalars["Int"]["input"]>;
  month?: InputMaybe<Scalars["Int"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface TimeWindowType {
  dateFrom: Scalars["Date"]["output"];
  dateTo: Scalars["Date"]["output"];
  daysFulfillsPlan: Scalars["Int"]["output"];
  elixirOfLifeCount: Scalars["Int"]["output"];
  timetable: Array<TimetableType>;
}

export interface TimetableGenericInput {
  plan: Array<StudyDayGenericInput>;
  validFrom: Scalars["Date"]["input"];
  validTo: Scalars["Date"]["input"];
}

export interface TimetableGenericType {
  created: Scalars["DateTime"]["output"];
  plan: Array<StudyDayGenericType>;
  validFrom: Scalars["Date"]["output"];
  validTo: Scalars["Date"]["output"];
}

export interface TimetableInput {
  plan: Array<StudyDayInput>;
}

export interface TimetableType {
  dateEnd?: Maybe<Scalars["Date"]["output"]>;
  dateStart?: Maybe<Scalars["Date"]["output"]>;
  plan: Array<StudyDayType>;
}

export interface TopicType {
  assignments: Array<AssignmentType>;
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface TrainingType {
  assignmentsTotal: Scalars["Int"]["output"];
  lengthActual: Scalars["Int"]["output"];
  lengthPreference: Scalars["Int"]["output"];
  userAssignments: Array<UserAssignmentType>;
}

export interface TutoringAnswerInput {
  autoEval?: InputMaybe<Array<QuestionAutoInput>>;
  selfEval?: InputMaybe<Scalars["Int"]["input"]>;
  timeSolveReal: Scalars["Int"]["input"];
  tutoringId: Scalars["String"]["input"];
  userAssignmentId: Scalars["String"]["input"];
}

export interface TutoringAnswerType {
  questionResults?: Maybe<Array<Scalars["Boolean"]["output"]>>;
  questionsCorrect?: Maybe<Scalars["Int"]["output"]>;
  questionsTotal?: Maybe<Scalars["Int"]["output"]>;
  questionsWrong?: Maybe<Scalars["Int"]["output"]>;
  scoreMax?: Maybe<Scalars["Int"]["output"]>;
  scoreReal?: Maybe<Scalars["Int"]["output"]>;
  tutoringId: Scalars["String"]["output"];
}

export interface TutoringCloseInput {
  tutoringId: Scalars["String"]["input"];
}

export interface TutoringCloseType {
  learningAttemptCreated: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  tutoringId?: Maybe<Scalars["String"]["output"]>;
}

export interface TutoringEvaluationClaimInput {
  questions: Array<Scalars["Boolean"]["input"]>;
  tutoringId: Scalars["String"]["input"];
  userAssignmentId: Scalars["String"]["input"];
}

export interface TutoringResetInput {
  tutoringId: Scalars["String"]["input"];
}

export interface TutoringResetType {
  message?: Maybe<Scalars["String"]["output"]>;
  tutoringId?: Maybe<Scalars["String"]["output"]>;
}

export interface TutoringSnapshotType {
  assignments: Array<TutoringUserAssignmentNested>;
  assignmentsFinished: Scalars["Int"]["output"];
  dateTested: Scalars["String"]["output"];
  themeAssignments: Array<TutoringUserAssignmentNested>;
  themeId: Scalars["String"]["output"];
  tutoringId: Scalars["String"]["output"];
  videotips: Array<Scalars["JSON"]["output"]>;
}

export interface TutoringSolutionUploadInput {
  contentType: Scalars["String"]["input"];
  fileExtension: Scalars["String"]["input"];
  fileSize: Scalars["Int"]["input"];
  tutoringId: Scalars["String"]["input"];
  userAssignmentId: Scalars["String"]["input"];
}

export interface TutoringType {
  assignments: Array<TutoringUserAssignmentNested>;
  assignmentsFinished: Scalars["Int"]["output"];
  dateTested?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  theme: Scalars["String"]["output"];
  themeAssignments: Array<TutoringUserAssignmentNested>;
  themeDetail?: Maybe<ThemeType>;
  user: Scalars["String"]["output"];
  userAchievements: Array<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  userIdZona: Scalars["String"]["output"];
  videotips: Array<VideoType>;
}

export interface TutoringUserAssignmentNested {
  finished: Scalars["Boolean"]["output"];
  ordering: Scalars["Int"]["output"];
  userAssignment?: Maybe<Scalars["String"]["output"]>;
  userAssignmentObject?: Maybe<UserAssignmentType>;
}

export interface UnrecognizedAnswerFilterInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface UnrecognizedAnswerInput {
  assignmentId: Scalars["String"]["input"];
  correctAnswer: Scalars["String"]["input"];
  date: Scalars["DateTime"]["input"];
  points: Scalars["Int"]["input"];
  questionNumber: Scalars["Int"]["input"];
  studentAnswer: Scalars["String"]["input"];
  userAssignmentId: Scalars["String"]["input"];
}

export interface UnrecognizedAnswerType {
  assignmentId?: Maybe<Scalars["String"]["output"]>;
  checked?: Maybe<Scalars["Boolean"]["output"]>;
  cmsLink?: Maybe<Scalars["String"]["output"]>;
  communicated?: Maybe<Scalars["Boolean"]["output"]>;
  correctAnswer?: Maybe<Scalars["String"]["output"]>;
  date?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  points?: Maybe<Scalars["Int"]["output"]>;
  questionNumber?: Maybe<Scalars["Int"]["output"]>;
  studentAnswer?: Maybe<Scalars["String"]["output"]>;
  testName?: Maybe<Scalars["String"]["output"]>;
  testOrder?: Maybe<Scalars["Int"]["output"]>;
  userAssignmentId?: Maybe<Scalars["String"]["output"]>;
  userEmail?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["String"]["output"]>;
  userIdZona?: Maybe<Scalars["String"]["output"]>;
  wasCorrect?: Maybe<Scalars["Boolean"]["output"]>;
}

export interface UnrecognizedAnswersWindowType {
  acceptedCount: Scalars["Int"]["output"];
  items: Array<UnrecognizedAnswerType>;
  rejectedCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
}

export interface UserAchievementType {
  dateAchieved: Scalars["Date"]["output"];
  goal: Scalars["String"]["output"];
  tutoring?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
}

export interface UserAssignmentFilterInput {
  combinedTopicId?: InputMaybe<Scalars["String"]["input"]>;
  envelope?: InputMaybe<Scalars["String"]["input"]>;
  idList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  isOnboarding?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  noPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  superTopicId?: InputMaybe<Scalars["String"]["input"]>;
  themeId?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UserAssignmentFulltextInput {
  fulltext: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface UserAssignmentType {
  Assignment?: Maybe<AssignmentType>;
  AssignmentIsInitialized: Scalars["Boolean"]["output"];
  AssignmentType?: Maybe<AssignmentType>;
  abilityScore?: Maybe<Scalars["Float"]["output"]>;
  assignment?: Maybe<AssignmentType>;
  attempts?: Maybe<Scalars["Int"]["output"]>;
  combinedTopic?: Maybe<CombinedTopicType>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  envelope?: Maybe<Scalars["String"]["output"]>;
  exerciseHistory?: Maybe<Array<ExerciseAttemptType>>;
  id: Scalars["String"]["output"];
  interval?: Maybe<Scalars["Int"]["output"]>;
  isOnboarding?: Maybe<Scalars["Boolean"]["output"]>;
  pastSessions: Array<Scalars["String"]["output"]>;
  scoreMax?: Maybe<Scalars["Int"]["output"]>;
  scoreReal?: Maybe<Scalars["Int"]["output"]>;
  sessionOrder?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  subject?: Maybe<SubjectType>;
  superTopic?: Maybe<SuperTopicType>;
  testLatest?: Maybe<Scalars["Date"]["output"]>;
  testNextDate?: Maybe<Scalars["Date"]["output"]>;
  testNextPriority?: Maybe<Scalars["String"]["output"]>;
  theme?: Maybe<ThemeType>;
  timeToLearn?: Maybe<Scalars["Int"]["output"]>;
  timeToSolve?: Maybe<Scalars["Int"]["output"]>;
  topic?: Maybe<TopicType>;
}

export interface UserAssignmentTypePaginationWindowType {
  items: Array<UserAssignmentType>;
  totalCount: Scalars["Int"]["output"];
}

export interface UserBookProgressInput {
  hasConsolidated?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasLearned?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasTested?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface UserBookProgressType {
  bookId: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["String"]["output"]>;
  flips: Scalars["JSON"]["output"];
  grade?: Maybe<Scalars["Int"]["output"]>;
  hasConsolidated: Scalars["Boolean"]["output"];
  hasLearned: Scalars["Boolean"]["output"];
  hasTested: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
}

export interface UserBookType {
  bookId: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
}

export interface UserBooksInput {
  bookIds: Array<Scalars["String"]["input"]>;
}

export interface UserCombinedTopicType {
  AssignmentsGreen?: Maybe<Scalars["Int"]["output"]>;
  AssignmentsGreenIsInitialized: Scalars["Boolean"]["output"];
  AssignmentsRed?: Maybe<Scalars["Int"]["output"]>;
  AssignmentsRedIsInitialized: Scalars["Boolean"]["output"];
  AssignmentsYellow?: Maybe<Scalars["Int"]["output"]>;
  AssignmentsYellowIsInitialized: Scalars["Boolean"]["output"];
  CombinedTopic?: Maybe<CombinedTopicType>;
  CombinedTopicIsInitialized: Scalars["Boolean"]["output"];
  CombinedTopicType?: Maybe<CombinedTopicType>;
  HasAssignments?: Maybe<Scalars["Boolean"]["output"]>;
  HasAssignmentsIsInitialized: Scalars["Boolean"]["output"];
  ScoreAggregatePercent?: Maybe<Scalars["Int"]["output"]>;
  ScoreAggregatePercentIsInitialized: Scalars["Boolean"]["output"];
  assignments: Scalars["Int"]["output"];
  assignmentsGreen: Scalars["Int"]["output"];
  assignmentsRed: Scalars["Int"]["output"];
  assignmentsYellow: Scalars["Int"]["output"];
  combinedTopic?: Maybe<CombinedTopicType>;
  hasAssignments: Scalars["Boolean"]["output"];
  hasAssignmentsGreen: Scalars["Boolean"]["output"];
  hasAssignmentsRed: Scalars["Boolean"]["output"];
  hasAssignmentsYellow: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  scoreAggregatePercent?: Maybe<Scalars["Int"]["output"]>;
}

export interface UserInput {
  bookmarkedExercisesCount?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  frequency?: InputMaybe<Scalars["String"]["input"]>;
  parentEmail?: InputMaybe<Scalars["String"]["input"]>;
  preferredSubject?: InputMaybe<Scalars["String"]["input"]>;
  withSound?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface UserSubjectType {
  ScoreAggregatePercent?: Maybe<Scalars["Int"]["output"]>;
  ScoreAggregatePercentIsInitialized: Scalars["Boolean"]["output"];
  assignments: Scalars["Int"]["output"];
  assignmentsGreen: Scalars["Int"]["output"];
  assignmentsRed: Scalars["Int"]["output"];
  assignmentsYellow: Scalars["Int"]["output"];
  hasAssignments: Scalars["Boolean"]["output"];
  hasAssignmentsGreen: Scalars["Boolean"]["output"];
  hasAssignmentsRed: Scalars["Boolean"]["output"];
  hasAssignmentsYellow: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  scoreAggregatePercent?: Maybe<Scalars["Int"]["output"]>;
  subject?: Maybe<SubjectType>;
}

export interface UserSuperTopicType {
  HasAssignments?: Maybe<Scalars["Boolean"]["output"]>;
  HasAssignmentsIsInitialized: Scalars["Boolean"]["output"];
  ScoreAggregatePercent?: Maybe<Scalars["Int"]["output"]>;
  ScoreAggregatePercentIsInitialized: Scalars["Boolean"]["output"];
  assignments: Scalars["Int"]["output"];
  assignmentsGreen: Scalars["Int"]["output"];
  assignmentsRed: Scalars["Int"]["output"];
  assignmentsYellow: Scalars["Int"]["output"];
  hasAssignments: Scalars["Boolean"]["output"];
  hasAssignmentsGreen: Scalars["Boolean"]["output"];
  hasAssignmentsRed: Scalars["Boolean"]["output"];
  hasAssignmentsYellow: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  scoreAggregatePercent?: Maybe<Scalars["Int"]["output"]>;
  superTopic?: Maybe<SuperTopicType>;
}

export interface UserThemeInput {
  isBlindSpot: Scalars["Boolean"]["input"];
}

export interface UserThemeType {
  abilityScoreAll?: Maybe<Scalars["Float"]["output"]>;
  abilityScoreLast3?: Maybe<Scalars["Float"]["output"]>;
  assignments: Scalars["Int"]["output"];
  assignmentsGreen: Scalars["Int"]["output"];
  assignmentsRed: Scalars["Int"]["output"];
  assignmentsYellow: Scalars["Int"]["output"];
  hasAssignments: Scalars["Boolean"]["output"];
  hasAssignmentsGreen: Scalars["Boolean"]["output"];
  hasAssignmentsRed: Scalars["Boolean"]["output"];
  hasAssignmentsYellow: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  isBlindSpot: Scalars["Boolean"]["output"];
  isLast3Wrong: Scalars["Boolean"]["output"];
  scoreAggregatePercent?: Maybe<Scalars["Int"]["output"]>;
  theme?: Maybe<ThemeType>;
}

export interface UserTopicInput {
  isBlindSpot: Scalars["Boolean"]["input"];
}

export interface UserTopicType {
  abilityScoreAll?: Maybe<Scalars["Float"]["output"]>;
  abilityScoreLast3?: Maybe<Scalars["Float"]["output"]>;
  assignments: Scalars["Int"]["output"];
  assignmentsGreen: Scalars["Int"]["output"];
  assignmentsRed: Scalars["Int"]["output"];
  assignmentsYellow: Scalars["Int"]["output"];
  combinedTopic?: Maybe<CombinedTopicType>;
  hasAssignments: Scalars["Boolean"]["output"];
  hasAssignmentsGreen: Scalars["Boolean"]["output"];
  hasAssignmentsRed: Scalars["Boolean"]["output"];
  hasAssignmentsYellow: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  isBlindSpot: Scalars["Boolean"]["output"];
  isLast3Wrong: Scalars["Boolean"]["output"];
  scoreAggregatePercent?: Maybe<Scalars["Int"]["output"]>;
  superTopic?: Maybe<SuperTopicType>;
  topic?: Maybe<TopicType>;
}

export interface UserType {
  admissionsDeadline?: Maybe<Scalars["Date"]["output"]>;
  daysFulfillsPlan?: Maybe<Scalars["Int"]["output"]>;
  elixirOfLifeCount?: Maybe<Scalars["Int"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstLogin?: Maybe<Scalars["Date"]["output"]>;
  frequency?: Maybe<Scalars["String"]["output"]>;
  fullAccess?: Maybe<Scalars["Boolean"]["output"]>;
  grade?: Maybe<Scalars["String"]["output"]>;
  idExternalZona?: Maybe<Scalars["String"]["output"]>;
  lastLogin?: Maybe<Scalars["Date"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  onboarding: OnboardingType;
  parentEmail?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  phoneValidationApiErrorMessage?: Maybe<Scalars["String"]["output"]>;
  phoneValidationCode?: Maybe<Scalars["String"]["output"]>;
  phoneValidationDatetimeLast?: Maybe<Scalars["String"]["output"]>;
  phoneValidationPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  phoneValidationRequired: Scalars["Boolean"]["output"];
  phoneValidationStatus?: Maybe<Scalars["String"]["output"]>;
  preferredSchools: Array<SchoolType>;
  preferredSubject?: Maybe<Scalars["String"]["output"]>;
  sessionsAchieved?: Maybe<Scalars["Int"]["output"]>;
  sex?: Maybe<Scalars["String"]["output"]>;
  smsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  testsAbsolved?: Maybe<Scalars["Int"]["output"]>;
  testsToBuy?: Maybe<Scalars["Int"]["output"]>;
  testsToUnlock?: Maybe<Scalars["Int"]["output"]>;
  vocative?: Maybe<Scalars["String"]["output"]>;
  withSound?: Maybe<Scalars["Boolean"]["output"]>;
}

export interface VideoType {
  previewImage?: Maybe<Scalars["String"]["output"]>;
  videoId: Scalars["String"]["output"];
}

export interface VideotipCategoryType {
  appName?: Maybe<Scalars["String"]["output"]>;
  grade?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface VideotipType {
  Category?: Maybe<VideotipCategoryType>;
  id: Scalars["String"]["output"];
  previewImage?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
  videotipCategory?: Maybe<VideotipCategoryType>;
}

export interface WeeklyChallengeType {
  endTime?: Maybe<Scalars["Date"]["output"]>;
  grade?: Maybe<Scalars["String"]["output"]>;
  startTime?: Maybe<Scalars["Date"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  theme: Scalars["String"]["output"];
}

export type HistorySessionFragment = {
  id: string;
  lastSessionMood?: number | null;
  lastSessionMoodText?: string | null;
  lastSessionMoodSelfReflection?: string | null;
  scoreMaxTotal?: number | null;
  scoreRealTotal?: number | null;
  envelopeMovements: Array<{ userAssigment: string; envelopeBefore: string; envelopeNow?: string | null }>;
  userAssignments: Array<{
    id: string;
    scoreReal?: number | null;
    scoreMax?: number | null;
    envelope?: string | null;
    theme?: { id: string } | null;
    assignment?: {
      isActive: boolean;
      assignment?: { assignmentText?: string | null } | null;
      general?: {
        testOrder?: number | null;
        admissionTest: { name?: string | null; displayName?: string | null };
      } | null;
    } | null;
  }>;
};

export type HistorySessionMinimalFragment = {
  id: string;
  envelopeMovements: Array<{ userAssigment: string; envelopeBefore: string; envelopeNow?: string | null }>;
  userAssignments: Array<{ id: string }>;
};

export type HistoryTutoringFragment = {
  id: string;
  assignments: Array<{
    userAssignment?: string | null;
    finished: boolean;
    userAssignmentObject?: {
      id: string;
      envelope?: string | null;
      theme?: { id: string } | null;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentText?: string | null } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
    } | null;
  }>;
  themeAssignments: Array<{
    userAssignment?: string | null;
    finished: boolean;
    userAssignmentObject?: {
      id: string;
      envelope?: string | null;
      theme?: { id: string } | null;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentText?: string | null } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
    } | null;
  }>;
};

export type HistoryTutoringSnapshotFragment = {
  tutoringId: string;
  assignments: Array<{
    userAssignment?: string | null;
    finished: boolean;
    userAssignmentObject?: {
      id: string;
      envelope?: string | null;
      theme?: { id: string } | null;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentText?: string | null } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
    } | null;
  }>;
  themeAssignments: Array<{
    userAssignment?: string | null;
    finished: boolean;
    userAssignmentObject?: {
      id: string;
      envelope?: string | null;
      theme?: { id: string } | null;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentText?: string | null } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
    } | null;
  }>;
};

export type AssignmentDetailFragment = {
  id: string;
  isActive: boolean;
  assignment?: {
    questionsText?: string | null;
    assignmentText?: string | null;
    transcriptCs?: string | null;
    transcriptEn?: string | null;
    assignmentImage?: string | null;
    assignmentImageThumbHash?: string | null;
    assignmentAudio?: string | null;
    printingAttachment?: string | null;
    isAnswerCaseSensitive?: boolean | null;
    AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
    assignmentType: { type?: string | null };
    questions: Array<{
      heading?: string | null;
      placeholder?: string | null;
      showAbilityScore?: boolean | null;
      options: Array<{ value?: string | null; additionalText?: string | null }>;
      solutionAnalysis?: {
        text?: string | null;
        image?: string | null;
        writtenVideo?: string | null;
        explainerVideo?: string | null;
      } | null;
      selfEvaluation?: {
        general?: { text?: string | null; image?: string | null } | null;
        options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
      } | null;
    }>;
  } | null;
  general?: { testOrder?: number | null; admissionTest: { name?: string | null; displayName?: string | null } } | null;
  scoring?: {
    canTeacherEvaluate?: boolean | null;
    scoreMax?: number | null;
    scoringMethod: { scoringMethod?: string | null };
    selfEvaluation?: { selfEvaluation?: string | null } | null;
  } | null;
  analysis?: {
    hasSharedAnalysis?: boolean | null;
    sharedAnalysis?: {
      text?: string | null;
      image?: string | null;
      writtenVideo?: string | null;
      explainerVideo?: string | null;
    } | null;
  } | null;
  selfEvaluation?: {
    hasSharedSelfEvaluation: boolean;
    sharedSelfEvaluation?: {
      general?: { text?: string | null; image?: string | null } | null;
      options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
    } | null;
  } | null;
};

export type AssignmentDetailForOverviewFragment = {
  id: string;
  isActive: boolean;
  assignment?: {
    assignmentText?: string | null;
    questionsText?: string | null;
    questions: Array<{ heading?: string | null }>;
  } | null;
  general?: { testOrder?: number | null; admissionTest: { name?: string | null; displayName?: string | null } } | null;
};

export type AssignmentExerciseFragment = {
  id: string;
  isActive: boolean;
  successRate?: number | null;
  assignment?: {
    questionsText?: string | null;
    assignmentText?: string | null;
    transcriptCs?: string | null;
    transcriptEn?: string | null;
    assignmentImage?: string | null;
    assignmentImageThumbHash?: string | null;
    assignmentAudio?: string | null;
    printingAttachment?: string | null;
    isAnswerCaseSensitive?: boolean | null;
    AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
    questions: Array<{
      heading?: string | null;
      placeholder?: string | null;
      showAbilityScore?: boolean | null;
      options: Array<{ value?: string | null; additionalText?: string | null }>;
      selfEvaluation?: {
        general?: { text?: string | null; image?: string | null } | null;
        options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
      } | null;
      solutionAnalysis?: {
        text?: string | null;
        image?: string | null;
        writtenVideo?: string | null;
        explainerVideo?: string | null;
      } | null;
    }>;
    assignmentType: { type?: string | null };
  } | null;
  scoring?: {
    canTeacherEvaluate?: boolean | null;
    scoreMax?: number | null;
    timeToSolve?: number | null;
    scoringMethod: { scoringMethod?: string | null };
    selfEvaluation?: { selfEvaluation?: string | null } | null;
  } | null;
  analysis?: {
    hasSharedAnalysis?: boolean | null;
    sharedAnalysis?: {
      text?: string | null;
      image?: string | null;
      writtenVideo?: string | null;
      explainerVideo?: string | null;
    } | null;
  } | null;
  selfEvaluation?: {
    hasSharedSelfEvaluation: boolean;
    sharedSelfEvaluation?: {
      general?: { text?: string | null; image?: string | null } | null;
      options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
    } | null;
  } | null;
};

export type AssignmentForBlacklistFragment = {
  userAssignment: {
    id: string;
    envelope?: string | null;
    assignment?: {
      id: string;
      isActive: boolean;
      assignment?: {
        assignmentText?: string | null;
        questionsText?: string | null;
        questions: Array<{ heading?: string | null }>;
      } | null;
      general?: {
        testOrder?: number | null;
        admissionTest: { name?: string | null; displayName?: string | null };
      } | null;
    } | null;
    subject?: { appName?: string | null } | null;
  };
};

export type AssignmentForBookmarkFragment = {
  userAssignment: {
    id: string;
    envelope?: string | null;
    assignment?: {
      id: string;
      isActive: boolean;
      assignment?: {
        assignmentText?: string | null;
        questionsText?: string | null;
        questions: Array<{ heading?: string | null }>;
      } | null;
      general?: {
        testOrder?: number | null;
        admissionTest: { name?: string | null; displayName?: string | null };
      } | null;
    } | null;
    subject?: { appName?: string | null } | null;
  };
};

export type AssignmentForThemeFragment = {
  id: string;
  isActive: boolean;
  assignment?: {
    assignmentText?: string | null;
    questionsText?: string | null;
    questions: Array<{ heading?: string | null }>;
  } | null;
  general?: { testOrder?: number | null; admissionTest: { name?: string | null; displayName?: string | null } } | null;
};

export type AssignmentHistoryMinimumFragment = {
  id: string;
  envelope?: string | null;
  theme?: { id: string } | null;
  assignment?: {
    isActive: boolean;
    assignment?: { assignmentText?: string | null } | null;
    general?: {
      testOrder?: number | null;
      admissionTest: { name?: string | null; displayName?: string | null };
    } | null;
  } | null;
};

export type AssignmentPracticeFragment = {
  id: string;
  isActive: boolean;
  successRate?: number | null;
  assignment?: {
    questionsText?: string | null;
    assignmentText?: string | null;
    transcriptCs?: string | null;
    transcriptEn?: string | null;
    assignmentImage?: string | null;
    assignmentImageThumbHash?: string | null;
    assignmentAudio?: string | null;
    printingAttachment?: string | null;
    isAnswerCaseSensitive?: boolean | null;
    AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
    assignmentType: { type?: string | null };
    questions: Array<{
      heading?: string | null;
      placeholder?: string | null;
      showAbilityScore?: boolean | null;
      options: Array<{ value?: string | null; additionalText?: string | null }>;
      solutionAnalysis?: {
        text?: string | null;
        image?: string | null;
        writtenVideo?: string | null;
        explainerVideo?: string | null;
      } | null;
      selfEvaluation?: {
        general?: { text?: string | null; image?: string | null } | null;
        options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
      } | null;
    }>;
  } | null;
  general?: { testOrder?: number | null; admissionTest: { name?: string | null; displayName?: string | null } } | null;
  scoring?: {
    scoreMax?: number | null;
    scoringMethod: { scoringMethod?: string | null };
    selfEvaluation?: { selfEvaluation?: string | null } | null;
  } | null;
  analysis?: {
    hasSharedAnalysis?: boolean | null;
    sharedAnalysis?: {
      text?: string | null;
      image?: string | null;
      writtenVideo?: string | null;
      explainerVideo?: string | null;
    } | null;
  } | null;
  selfEvaluation?: {
    hasSharedSelfEvaluation: boolean;
    sharedSelfEvaluation?: {
      general?: { text?: string | null; image?: string | null } | null;
      options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
    } | null;
  } | null;
};

export type AssignmentPracticeMinimumFragment = {
  isActive: boolean;
  assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
};

export type AssignmentPracticeMinimumMhdFragment = { isActive: boolean };

export type AssignmentSuperTopicHierarchyFragment = {
  superTopic?: { id: string } | null;
  subject?: { id: string } | null;
};

export type AssignmentTutoringMinimumFragment = {
  id: string;
  envelope?: string | null;
  theme?: { id: string } | null;
  assignment?: { isActive: boolean } | null;
};

export type BadgeFragment = { type: string; dateAchieved: any; goal: string };

export type BlindSpotThemeFragment = {
  id: string;
  theme?: { id: string; name?: string | null; appName?: string | null } | null;
};

export type CheckAchievementsFragment = {
  aggregate: Array<{ achievementType: string; countTotal: number; countNew?: number | null; dateLast?: any | null }>;
  achievementsNew: Array<{ type: string; dateAchieved: any; goal: string }>;
};

export type EnvelopeSummaryFragment = { green: number; yellow: number; red: number };

export type ExamSessionFragment = {
  id: string;
  bookId: string;
  startedAt: string;
  finishedAt?: string | null;
  step: string;
  reachedCommission?: boolean | null;
  commissionBlock?: number | null;
  commissionQuestion?: number | null;
  ratings: any;
  speechRating?: string | null;
  speechRatings: any;
  blocks: Array<{ index: number; categoryId: string; questionIds: Array<string> }>;
  speechClips?: { filler?: string | null; slang?: string | null; reasoning: Array<string> } | null;
  settings: { durationMin: number; hasAmbience: boolean; isRecording: boolean };
  result?: {
    grade: number;
    totalPoints?: number | null;
    pointsToBetter?: number | null;
    algoVersion?: string | null;
    perCategory: Array<{ categoryId: string; level: string }>;
    sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
  } | null;
};

export type LastAchievementFragment = { type: string; dateAchieved: any; goal: string };

export type MasterclassProgressFragment = { viewed: any; completed: any };

export type NonfictionProgressFragment = {
  hasLearned: boolean;
  hasConsolidated: boolean;
  flips: any;
  quizTotal: number;
  quizPassScore: number;
};

export type NonfictionQuizAttemptFragment = {
  id: string;
  startedAt: string;
  finishedAt?: string | null;
  verdicts: any;
};

export type OutageFragment = { startTime?: any | null; endTime?: any | null; text?: string | null };

export type PracticeQuizAttemptFragment = { id: string; startedAt: string; finishedAt?: string | null; verdicts: any };

export type SelfEvaluationFragment = {
  general?: { text?: string | null; image?: string | null } | null;
  options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
};

export type StudyDayFragment = {
  date?: any | null;
  startAt?: any | null;
  duration?: number | null;
  durationReal?: number | null;
  sessionFinished?: boolean | null;
  status?: string | null;
};

export type ThemeFragment = {
  name?: string | null;
  appName?: string | null;
  subject?: string | null;
  video?: Array<{ videoId: string; previewImage?: string | null }> | null;
};

export type UserAssignmentDetailFragment = {
  id: string;
  timeToSolve?: number | null;
  timeToLearn?: number | null;
  assignment?: {
    id: string;
    isActive: boolean;
    successRate?: number | null;
    assignment?: {
      questionsText?: string | null;
      assignmentText?: string | null;
      transcriptCs?: string | null;
      transcriptEn?: string | null;
      assignmentImage?: string | null;
      assignmentImageThumbHash?: string | null;
      assignmentAudio?: string | null;
      printingAttachment?: string | null;
      isAnswerCaseSensitive?: boolean | null;
      AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
      assignmentType: { type?: string | null };
      questions: Array<{
        heading?: string | null;
        placeholder?: string | null;
        showAbilityScore?: boolean | null;
        options: Array<{ value?: string | null; additionalText?: string | null }>;
        solutionAnalysis?: {
          text?: string | null;
          image?: string | null;
          writtenVideo?: string | null;
          explainerVideo?: string | null;
        } | null;
        selfEvaluation?: {
          general?: { text?: string | null; image?: string | null } | null;
          options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
        } | null;
      }>;
    } | null;
    general?: {
      testOrder?: number | null;
      admissionTest: { name?: string | null; displayName?: string | null };
    } | null;
    scoring?: {
      scoreMax?: number | null;
      scoringMethod: { scoringMethod?: string | null };
      selfEvaluation?: { selfEvaluation?: string | null } | null;
    } | null;
    analysis?: {
      hasSharedAnalysis?: boolean | null;
      sharedAnalysis?: {
        text?: string | null;
        image?: string | null;
        writtenVideo?: string | null;
        explainerVideo?: string | null;
      } | null;
    } | null;
    selfEvaluation?: {
      hasSharedSelfEvaluation: boolean;
      sharedSelfEvaluation?: {
        general?: { text?: string | null; image?: string | null } | null;
        options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
      } | null;
    } | null;
  } | null;
  theme?: { appName?: string | null } | null;
  subject?: { appName?: string | null; appAbbr?: string | null } | null;
};

export type UserAssignmentForExerciseFragment = {
  id: string;
  scoreMax?: number | null;
  timeToSolve?: number | null;
  timeToLearn?: number | null;
  envelope?: string | null;
  assignment?: {
    id: string;
    isActive: boolean;
    successRate?: number | null;
    assignment?: {
      questionsText?: string | null;
      assignmentText?: string | null;
      transcriptCs?: string | null;
      transcriptEn?: string | null;
      assignmentImage?: string | null;
      assignmentImageThumbHash?: string | null;
      assignmentAudio?: string | null;
      printingAttachment?: string | null;
      isAnswerCaseSensitive?: boolean | null;
      AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
      questions: Array<{
        heading?: string | null;
        placeholder?: string | null;
        showAbilityScore?: boolean | null;
        options: Array<{ value?: string | null; additionalText?: string | null }>;
        selfEvaluation?: {
          general?: { text?: string | null; image?: string | null } | null;
          options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
        } | null;
        solutionAnalysis?: {
          text?: string | null;
          image?: string | null;
          writtenVideo?: string | null;
          explainerVideo?: string | null;
        } | null;
      }>;
      assignmentType: { type?: string | null };
    } | null;
    scoring?: {
      canTeacherEvaluate?: boolean | null;
      scoreMax?: number | null;
      timeToSolve?: number | null;
      scoringMethod: { scoringMethod?: string | null };
      selfEvaluation?: { selfEvaluation?: string | null } | null;
    } | null;
    analysis?: {
      hasSharedAnalysis?: boolean | null;
      sharedAnalysis?: {
        text?: string | null;
        image?: string | null;
        writtenVideo?: string | null;
        explainerVideo?: string | null;
      } | null;
    } | null;
    selfEvaluation?: {
      hasSharedSelfEvaluation: boolean;
      sharedSelfEvaluation?: {
        general?: { text?: string | null; image?: string | null } | null;
        options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
      } | null;
    } | null;
  } | null;
  theme?: { appName?: string | null } | null;
  subject?: { appName?: string | null } | null;
};

export type UserAssignmentForExerciseMinimumFragment = {
  id: string;
  assignment?: {
    isActive: boolean;
    assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
  } | null;
  subject?: { appName?: string | null } | null;
};

export type UserAssignmentForExerciseMinimumMhdFragment = {
  id: string;
  assignment?: { isActive: boolean } | null;
  subject?: { appName?: string | null } | null;
};

export type UserAssignmentForThemeFragment = {
  id: string;
  envelope?: string | null;
  assignment?: {
    id: string;
    isActive: boolean;
    assignment?: {
      assignmentText?: string | null;
      questionsText?: string | null;
      questions: Array<{ heading?: string | null }>;
    } | null;
    general?: {
      testOrder?: number | null;
      admissionTest: { name?: string | null; displayName?: string | null };
    } | null;
  } | null;
};

export type UserAssignmentPracticeFragment = {
  id: string;
  timeToSolve?: number | null;
  timeToLearn?: number | null;
  envelope?: string | null;
  assignment?: {
    isActive: boolean;
    assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
  } | null;
};

export type UserBookProgressFragment = {
  id: string;
  bookId: string;
  hasLearned: boolean;
  hasConsolidated: boolean;
  hasTested: boolean;
  flips: any;
};

export type UserSubjectFragment = {
  id: string;
  appAbbr?: string | null;
  appName?: string | null;
  abbreviation?: string | null;
  slug?: string | null;
  superTopics: Array<{ id: string }>;
};

export type UserThemeFragment = {
  hasAssignments: boolean;
  assignmentsRed: number;
  assignmentsGreen: number;
  assignmentsYellow: number;
  theme?: {
    id: string;
    appName?: string | null;
    name?: string | null;
    description?: string | null;
    subject?: string | null;
    avgTestPoints?: number | null;
  } | null;
};

export type UserTutoringAssignmentMinimumFragment = {
  finished: boolean;
  userAssignmentObject?: { envelope?: string | null; id: string } | null;
};

export type UserTutoringAssignmentPracticeFragment = {
  finished: boolean;
  userAssignmentObject?: { id: string } | null;
};

export type UserTutoringMinimumFragment = {
  id: string;
  theme: string;
  userAchievements: Array<string>;
  themeAssignments: Array<{
    finished: boolean;
    userAssignmentObject?: { envelope?: string | null; id: string } | null;
  }>;
  assignments: Array<{ finished: boolean; userAssignmentObject?: { envelope?: string | null; id: string } | null }>;
  videotips: Array<{ videoId: string }>;
};

export type UserTutoringPracticeFragment = {
  id: string;
  theme: string;
  userAchievements: Array<string>;
  themeAssignments: Array<{ finished: boolean; userAssignmentObject?: { id: string } | null }>;
  assignments: Array<{ finished: boolean; userAssignmentObject?: { id: string } | null }>;
};

export type UserTutoringPracticeByIdFragment = {
  id: string;
  theme: string;
  userAchievements: Array<string>;
  themeDetail?: {
    name?: string | null;
    appName?: string | null;
    video?: Array<{ videoId: string; previewImage?: string | null }> | null;
  } | null;
  themeAssignments: Array<{
    finished: boolean;
    userAssignmentObject?: {
      id: string;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      assignment?: {
        id: string;
        isActive: boolean;
        successRate?: number | null;
        assignment?: {
          questionsText?: string | null;
          assignmentText?: string | null;
          transcriptCs?: string | null;
          transcriptEn?: string | null;
          assignmentImage?: string | null;
          assignmentImageThumbHash?: string | null;
          assignmentAudio?: string | null;
          printingAttachment?: string | null;
          isAnswerCaseSensitive?: boolean | null;
          AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
          assignmentType: { type?: string | null };
          questions: Array<{
            heading?: string | null;
            placeholder?: string | null;
            showAbilityScore?: boolean | null;
            options: Array<{ value?: string | null; additionalText?: string | null }>;
            solutionAnalysis?: {
              text?: string | null;
              image?: string | null;
              writtenVideo?: string | null;
              explainerVideo?: string | null;
            } | null;
            selfEvaluation?: {
              general?: { text?: string | null; image?: string | null } | null;
              options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
            } | null;
          }>;
        } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
        scoring?: {
          scoreMax?: number | null;
          scoringMethod: { scoringMethod?: string | null };
          selfEvaluation?: { selfEvaluation?: string | null } | null;
        } | null;
        analysis?: {
          hasSharedAnalysis?: boolean | null;
          sharedAnalysis?: {
            text?: string | null;
            image?: string | null;
            writtenVideo?: string | null;
            explainerVideo?: string | null;
          } | null;
        } | null;
        selfEvaluation?: {
          hasSharedSelfEvaluation: boolean;
          sharedSelfEvaluation?: {
            general?: { text?: string | null; image?: string | null } | null;
            options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
          } | null;
        } | null;
      } | null;
      theme?: { appName?: string | null } | null;
      subject?: { appName?: string | null; appAbbr?: string | null } | null;
    } | null;
  }>;
  assignments: Array<{
    finished: boolean;
    userAssignmentObject?: {
      id: string;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      assignment?: {
        id: string;
        isActive: boolean;
        successRate?: number | null;
        assignment?: {
          questionsText?: string | null;
          assignmentText?: string | null;
          transcriptCs?: string | null;
          transcriptEn?: string | null;
          assignmentImage?: string | null;
          assignmentImageThumbHash?: string | null;
          assignmentAudio?: string | null;
          printingAttachment?: string | null;
          isAnswerCaseSensitive?: boolean | null;
          AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
          assignmentType: { type?: string | null };
          questions: Array<{
            heading?: string | null;
            placeholder?: string | null;
            showAbilityScore?: boolean | null;
            options: Array<{ value?: string | null; additionalText?: string | null }>;
            solutionAnalysis?: {
              text?: string | null;
              image?: string | null;
              writtenVideo?: string | null;
              explainerVideo?: string | null;
            } | null;
            selfEvaluation?: {
              general?: { text?: string | null; image?: string | null } | null;
              options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
            } | null;
          }>;
        } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
        scoring?: {
          scoreMax?: number | null;
          scoringMethod: { scoringMethod?: string | null };
          selfEvaluation?: { selfEvaluation?: string | null } | null;
        } | null;
        analysis?: {
          hasSharedAnalysis?: boolean | null;
          sharedAnalysis?: {
            text?: string | null;
            image?: string | null;
            writtenVideo?: string | null;
            explainerVideo?: string | null;
          } | null;
        } | null;
        selfEvaluation?: {
          hasSharedSelfEvaluation: boolean;
          sharedSelfEvaluation?: {
            general?: { text?: string | null; image?: string | null } | null;
            options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
          } | null;
        } | null;
      } | null;
      theme?: { appName?: string | null } | null;
      subject?: { appName?: string | null; appAbbr?: string | null } | null;
    } | null;
  }>;
};

export type WorstTopicsFragment = {
  abilityScoreAll?: number | null;
  topic?: { name?: string | null; id: string } | null;
};

export type BookExamAnswerConfirmMutationVariables = Exact<{
  uploadId: Scalars["String"]["input"];
}>;

export type BookExamAnswerConfirmMutation = { bookExamAnswerConfirm: boolean };

export type BookExamAnswerUploadUrlMutationVariables = Exact<{
  sessionId: Scalars["String"]["input"];
  questionId: Scalars["String"]["input"];
  contentType: Scalars["String"]["input"];
  fileExtension: Scalars["String"]["input"];
  durationMs: Scalars["Int"]["input"];
  fileSize: Scalars["Int"]["input"];
}>;

export type BookExamAnswerUploadUrlMutation = { bookExamAnswerUploadUrl: { uploadId: string; url: string } };

export type CheckAnswersMutationVariables = Exact<{
  assignmentId: Scalars["String"]["input"];
  timeToSolve: Scalars["Int"]["input"];
  userAnswers?: InputMaybe<Array<QuestionAutoInput> | QuestionAutoInput>;
  selfEvaluation?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CheckAnswersMutation = {
  answer: { scoreReal: number; correctAnswers?: Array<Array<string | null>> | null };
};

export type CheckTutoringAnswerMutationVariables = Exact<{
  tutoringId: Scalars["String"]["input"];
  userAssignmentId: Scalars["String"]["input"];
  timeToSolve: Scalars["Int"]["input"];
  userAnswers?: InputMaybe<Array<QuestionAutoInput> | QuestionAutoInput>;
  selfEvaluation?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CheckTutoringAnswerMutation = {
  tutoringAnswer: { scoreReal?: number | null; scoreMax?: number | null; questionResults?: Array<boolean> | null };
};

export type CreateUnrecognizedAnswerMutationVariables = Exact<{
  input: UnrecognizedAnswerInput;
}>;

export type CreateUnrecognizedAnswerMutation = { createUnrecognizedAnswer: { id: string } };

export type DeleteBlacklistItemMutationVariables = Exact<{
  blacklistItemId: Scalars["String"]["input"];
}>;

export type DeleteBlacklistItemMutation = { deleteBlacklistItem: { objectsDeleted: Array<string> } };

export type DeleteBookmarkMutationVariables = Exact<{
  bookmarkId: Scalars["String"]["input"];
}>;

export type DeleteBookmarkMutation = { deleteBookmark: { objectsDeleted: Array<string> } };

export type ExamAttemptDiscardMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
}>;

export type ExamAttemptDiscardMutation = { examAttemptDiscard: boolean };

export type ExamAttemptStartMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  settings: ExamSettingsInput;
}>;

export type ExamAttemptStartMutation = {
  examAttemptStart: {
    id: string;
    bookId: string;
    startedAt: string;
    finishedAt?: string | null;
    step: string;
    reachedCommission?: boolean | null;
    commissionBlock?: number | null;
    commissionQuestion?: number | null;
    ratings: any;
    speechRating?: string | null;
    speechRatings: any;
    blocks: Array<{ index: number; categoryId: string; questionIds: Array<string> }>;
    speechClips?: { filler?: string | null; slang?: string | null; reasoning: Array<string> } | null;
    settings: { durationMin: number; hasAmbience: boolean; isRecording: boolean };
    result?: {
      grade: number;
      totalPoints?: number | null;
      pointsToBetter?: number | null;
      algoVersion?: string | null;
      perCategory: Array<{ categoryId: string; level: string }>;
      sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
    } | null;
  };
};

export type ExamFinishMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ExamFinishMutation = {
  examFinish: {
    id: string;
    bookId: string;
    startedAt: string;
    finishedAt?: string | null;
    step: string;
    reachedCommission?: boolean | null;
    commissionBlock?: number | null;
    commissionQuestion?: number | null;
    ratings: any;
    speechRating?: string | null;
    speechRatings: any;
    blocks: Array<{ index: number; categoryId: string; questionIds: Array<string> }>;
    speechClips?: { filler?: string | null; slang?: string | null; reasoning: Array<string> } | null;
    settings: { durationMin: number; hasAmbience: boolean; isRecording: boolean };
    result?: {
      grade: number;
      totalPoints?: number | null;
      pointsToBetter?: number | null;
      algoVersion?: string | null;
      perCategory: Array<{ categoryId: string; level: string }>;
      sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
    } | null;
  };
};

export type ExamPositionSetMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  blockIndex: Scalars["Int"]["input"];
  questionIndex: Scalars["Int"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ExamPositionSetMutation = {
  examPositionSet: { id: string; commissionBlock?: number | null; commissionQuestion?: number | null };
};

export type ExamQuestionRateMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  questionId: Scalars["String"]["input"];
  rating: Scalars["String"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ExamQuestionRateMutation = {
  examQuestionRate: {
    id: string;
    bookId: string;
    startedAt: string;
    finishedAt?: string | null;
    step: string;
    reachedCommission?: boolean | null;
    commissionBlock?: number | null;
    commissionQuestion?: number | null;
    ratings: any;
    speechRating?: string | null;
    speechRatings: any;
    blocks: Array<{ index: number; categoryId: string; questionIds: Array<string> }>;
    speechClips?: { filler?: string | null; slang?: string | null; reasoning: Array<string> } | null;
    settings: { durationMin: number; hasAmbience: boolean; isRecording: boolean };
    result?: {
      grade: number;
      totalPoints?: number | null;
      pointsToBetter?: number | null;
      algoVersion?: string | null;
      perCategory: Array<{ categoryId: string; level: string }>;
      sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
    } | null;
  };
};

export type ExamRateSpeechMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  rating: Scalars["String"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
  criterion?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ExamRateSpeechMutation = {
  examRateSpeech: {
    id: string;
    bookId: string;
    startedAt: string;
    finishedAt?: string | null;
    step: string;
    reachedCommission?: boolean | null;
    commissionBlock?: number | null;
    commissionQuestion?: number | null;
    ratings: any;
    speechRating?: string | null;
    speechRatings: any;
    blocks: Array<{ index: number; categoryId: string; questionIds: Array<string> }>;
    speechClips?: { filler?: string | null; slang?: string | null; reasoning: Array<string> } | null;
    settings: { durationMin: number; hasAmbience: boolean; isRecording: boolean };
    result?: {
      grade: number;
      totalPoints?: number | null;
      pointsToBetter?: number | null;
      algoVersion?: string | null;
      perCategory: Array<{ categoryId: string; level: string }>;
      sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
    } | null;
  };
};

export type ExamSpeechClipsSetMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  clips: ExamSpeechClipsInput;
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ExamSpeechClipsSetMutation = {
  examSpeechClipsSet: {
    id: string;
    bookId: string;
    startedAt: string;
    finishedAt?: string | null;
    step: string;
    reachedCommission?: boolean | null;
    commissionBlock?: number | null;
    commissionQuestion?: number | null;
    ratings: any;
    speechRating?: string | null;
    speechRatings: any;
    blocks: Array<{ index: number; categoryId: string; questionIds: Array<string> }>;
    speechClips?: { filler?: string | null; slang?: string | null; reasoning: Array<string> } | null;
    settings: { durationMin: number; hasAmbience: boolean; isRecording: boolean };
    result?: {
      grade: number;
      totalPoints?: number | null;
      pointsToBetter?: number | null;
      algoVersion?: string | null;
      perCategory: Array<{ categoryId: string; level: string }>;
      sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
    } | null;
  };
};

export type ExamStepSetMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  step: Scalars["String"]["input"];
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ExamStepSetMutation = {
  examStepSet: {
    id: string;
    bookId: string;
    startedAt: string;
    finishedAt?: string | null;
    step: string;
    reachedCommission?: boolean | null;
    commissionBlock?: number | null;
    commissionQuestion?: number | null;
    ratings: any;
    speechRating?: string | null;
    speechRatings: any;
    blocks: Array<{ index: number; categoryId: string; questionIds: Array<string> }>;
    speechClips?: { filler?: string | null; slang?: string | null; reasoning: Array<string> } | null;
    settings: { durationMin: number; hasAmbience: boolean; isRecording: boolean };
    result?: {
      grade: number;
      totalPoints?: number | null;
      pointsToBetter?: number | null;
      algoVersion?: string | null;
      perCategory: Array<{ categoryId: string; level: string }>;
      sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
    } | null;
  };
};

export type FlipNonfictionCardMutationVariables = Exact<{
  cardId: Scalars["String"]["input"];
}>;

export type FlipNonfictionCardMutation = {
  nonfictionCardFlip: {
    hasLearned: boolean;
    hasConsolidated: boolean;
    flips: any;
    quizTotal: number;
    quizPassScore: number;
  };
};

export type FlipPracticeCardMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  cardId: Scalars["String"]["input"];
}>;

export type FlipPracticeCardMutation = {
  practiceCardFlip: {
    id: string;
    bookId: string;
    hasLearned: boolean;
    hasConsolidated: boolean;
    hasTested: boolean;
    flips: any;
  };
};

export type RateNonfictionQuizQuestionMutationVariables = Exact<{
  questionId: Scalars["String"]["input"];
  verdict: Scalars["String"]["input"];
}>;

export type RateNonfictionQuizQuestionMutation = {
  nonfictionQuizQuestionRate: {
    attempt: { id: string; startedAt: string; finishedAt?: string | null; verdicts: any };
    progress?: {
      hasLearned: boolean;
      hasConsolidated: boolean;
      flips: any;
      quizTotal: number;
      quizPassScore: number;
    } | null;
  };
};

export type RateQuizQuestionMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  questionId: Scalars["String"]["input"];
  verdict: Scalars["String"]["input"];
}>;

export type RateQuizQuestionMutation = {
  practiceQuizQuestionRate: { id: string; startedAt: string; finishedAt?: string | null; verdicts: any };
};

export type RemoveThemeFromBlackEnvelopeMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type RemoveThemeFromBlackEnvelopeMutation = { userThemeUpdate: { isBlindSpot: boolean } };

export type ResetOnboardingMutationVariables = Exact<{ [key: string]: never }>;

export type ResetOnboardingMutation = {
  updatePhone: { status: string };
  updateOnboarding: { introduced: boolean; finished: boolean };
};

export type SaveBlacklistItemMutationVariables = Exact<{
  assignmentId: Scalars["String"]["input"];
}>;

export type SaveBlacklistItemMutation = { setBlacklistItem: { id: string } };

export type SaveBookmarkMutationVariables = Exact<{
  assignmentId: Scalars["String"]["input"];
}>;

export type SaveBookmarkMutation = { setBookmark: { id: string } };

export type SendPhoneValidationCodeMutationVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type SendPhoneValidationCodeMutation = { validatePhone: { status: string } };

export type SessionCloseMutationVariables = Exact<{
  mood: Scalars["Int"]["input"];
  moodText: Scalars["String"]["input"];
  selfReflectionText: Scalars["String"]["input"];
  assignmentsClose: Array<AssignmentCloseInput> | AssignmentCloseInput;
}>;

export type SessionCloseMutation = { sessionClose: { finished: boolean } };

export type SessionCreateMutationVariables = Exact<{
  lengthPreference: Scalars["Int"]["input"];
  assignmentId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SessionCreateMutation = {
  sessionCreate: {
    id: string;
    alreadyStarted: boolean;
    lastSessionMood?: number | null;
    lastSessionMoodText?: string | null;
    lastSessionMoodSelfReflection?: string | null;
    userAssignments: Array<{
      envelope?: string | null;
      assignment?: {
        assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
      } | null;
      subject?: { appName?: string | null } | null;
    }>;
  };
};

export type SessionStartMutationVariables = Exact<{ [key: string]: never }>;

export type SessionStartMutation = {
  sessionStart: {
    id: string;
    lengthActual: number;
    alreadyStarted: boolean;
    userAssignments: Array<{
      id: string;
      scoreMax?: number | null;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      envelope?: string | null;
      assignment?: {
        id: string;
        isActive: boolean;
        successRate?: number | null;
        assignment?: {
          questionsText?: string | null;
          assignmentText?: string | null;
          transcriptCs?: string | null;
          transcriptEn?: string | null;
          assignmentImage?: string | null;
          assignmentImageThumbHash?: string | null;
          assignmentAudio?: string | null;
          printingAttachment?: string | null;
          isAnswerCaseSensitive?: boolean | null;
          AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
          questions: Array<{
            heading?: string | null;
            placeholder?: string | null;
            showAbilityScore?: boolean | null;
            options: Array<{ value?: string | null; additionalText?: string | null }>;
            selfEvaluation?: {
              general?: { text?: string | null; image?: string | null } | null;
              options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
            } | null;
            solutionAnalysis?: {
              text?: string | null;
              image?: string | null;
              writtenVideo?: string | null;
              explainerVideo?: string | null;
            } | null;
          }>;
          assignmentType: { type?: string | null };
        } | null;
        scoring?: {
          canTeacherEvaluate?: boolean | null;
          scoreMax?: number | null;
          timeToSolve?: number | null;
          scoringMethod: { scoringMethod?: string | null };
          selfEvaluation?: { selfEvaluation?: string | null } | null;
        } | null;
        analysis?: {
          hasSharedAnalysis?: boolean | null;
          sharedAnalysis?: {
            text?: string | null;
            image?: string | null;
            writtenVideo?: string | null;
            explainerVideo?: string | null;
          } | null;
        } | null;
        selfEvaluation?: {
          hasSharedSelfEvaluation: boolean;
          sharedSelfEvaluation?: {
            general?: { text?: string | null; image?: string | null } | null;
            options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
          } | null;
        } | null;
      } | null;
      theme?: { appName?: string | null } | null;
      subject?: { appName?: string | null } | null;
    }>;
  };
};

export type SetTimetableGenericMutationVariables = Exact<{
  from: Scalars["Date"]["input"];
  to: Scalars["Date"]["input"];
  timeTable: Array<StudyDayGenericInput> | StudyDayGenericInput;
}>;

export type SetTimetableGenericMutation = {
  setTimetableGeneric: { plan: Array<{ dayName: string; startAt?: any | null; duration?: number | null }> };
};

export type SetMasterclassVideoCompletedMutationVariables = Exact<{
  videoId: Scalars["String"]["input"];
  completed: Scalars["Boolean"]["input"];
}>;

export type SetMasterclassVideoCompletedMutation = { masterclassVideoCompleted: { viewed: any; completed: any } };

export type SetMasterclassVideoViewedMutationVariables = Exact<{
  videoId: Scalars["String"]["input"];
}>;

export type SetMasterclassVideoViewedMutation = { masterclassVideoViewed: { viewed: any; completed: any } };

export type SetNonfictionProgressMutationVariables = Exact<{
  input: NonfictionProgressInput;
}>;

export type SetNonfictionProgressMutation = {
  nonfictionProgressSet: {
    hasLearned: boolean;
    hasConsolidated: boolean;
    flips: any;
    quizTotal: number;
    quizPassScore: number;
  };
};

export type SetOnboardingFinishedMutationVariables = Exact<{ [key: string]: never }>;

export type SetOnboardingFinishedMutation = { updateOnboarding: { finished: boolean } };

export type SetOnboardingIntroducedMutationVariables = Exact<{ [key: string]: never }>;

export type SetOnboardingIntroducedMutation = { updateOnboarding: { introduced: boolean } };

export type SetTimetableMutationVariables = Exact<{
  timeTable: Array<StudyDayInput> | StudyDayInput;
}>;

export type SetTimetableMutation = {
  setTimetable: {
    dateStart?: any | null;
    dateEnd?: any | null;
    plan: Array<{ dayIndex?: number | null; startAt?: any | null; duration?: number | null }>;
  };
};

export type SetUserBookProgressMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
  input: UserBookProgressInput;
}>;

export type SetUserBookProgressMutation = {
  userBookProgressSet: {
    id: string;
    bookId: string;
    hasLearned: boolean;
    hasConsolidated: boolean;
    hasTested: boolean;
    flips: any;
  };
};

export type SetUserBooksMutationVariables = Exact<{
  bookIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SetUserBooksMutation = { userBooksSet: Array<{ id: string; bookId: string; createdAt?: string | null }> };

export type SetWelcomedMutationVariables = Exact<{ [key: string]: never }>;

export type SetWelcomedMutation = { updateOnboarding: { welcome: boolean } };

export type SolutionUploadConfirmMutationVariables = Exact<{
  solutionUploadId: Scalars["String"]["input"];
}>;

export type SolutionUploadConfirmMutation = { solutionUploadConfirm?: any | null };

export type SolutionUploadUrlMutationVariables = Exact<{
  userAssignmentId: Scalars["String"]["input"];
  contentType: Scalars["String"]["input"];
  fileExtension: Scalars["String"]["input"];
  fileSize: Scalars["Int"]["input"];
}>;

export type SolutionUploadUrlMutation = { solutionUploadUrl: { command: string; uploadId: string; url: string } };

export type StartNonfictionQuizAttemptMutationVariables = Exact<{ [key: string]: never }>;

export type StartNonfictionQuizAttemptMutation = {
  nonfictionQuizAttemptStart: { id: string; startedAt: string; finishedAt?: string | null; verdicts: any };
};

export type StartQuizAttemptMutationVariables = Exact<{
  bookId: Scalars["String"]["input"];
}>;

export type StartQuizAttemptMutation = {
  practiceQuizAttemptStart: { id: string; startedAt: string; finishedAt?: string | null; verdicts: any };
};

export type TutoringClaimEvaluationMutationVariables = Exact<{
  tutoringId: Scalars["String"]["input"];
  userAssignmentId: Scalars["String"]["input"];
  userAnswers: Array<Scalars["Boolean"]["input"]> | Scalars["Boolean"]["input"];
}>;

export type TutoringClaimEvaluationMutation = { tutoringClaimEvaluation: { tutoringId: string } };

export type TutoringResetMutationVariables = Exact<{
  tutoringId: Scalars["String"]["input"];
}>;

export type TutoringResetMutation = { tutoringReset: { message?: string | null } };

export type UpdateParentRewardsMutationVariables = Exact<{
  rewards: ParentWatchInput;
}>;

export type UpdateParentRewardsMutation = {
  parentWatchUpdate: {
    message?: string | null;
    rewards: Array<{ type: string; targetScore?: number | null; month?: number | null; text: string }>;
  };
};

export type UpdatePhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars["String"]["input"];
  smsEnabled: Scalars["Boolean"]["input"];
}>;

export type UpdatePhoneNumberMutation = { updatePhone: { status: string; datetimeLast?: string | null } };

export type UpdateSoundMutationVariables = Exact<{
  withSound: Scalars["Boolean"]["input"];
}>;

export type UpdateSoundMutation = { updateUser: { withSound?: boolean | null } };

export type UpdateUserPreferencesMutationVariables = Exact<{
  phoneNumber: Scalars["String"]["input"];
  preferredSubject: Scalars["String"]["input"];
  smsEnabled: Scalars["Boolean"]["input"];
}>;

export type UpdateUserPreferencesMutation = {
  updateUser: { preferredSubject?: string | null };
  updatePhone: { status: string; datetimeLast?: string | null };
};

export type UserLoginMutationVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type UserLoginMutation = { login: { status: string; accessToken?: string | null } };

export type ValidateAnswerMutationVariables = Exact<{
  userAssignmentId: Scalars["String"]["input"];
  questions: Array<Scalars["Boolean"]["input"]> | Scalars["Boolean"]["input"];
}>;

export type ValidateAnswerMutation = { claimEvaluation: { scoreReal: number } };

export type BookExamAnswersQueryVariables = Exact<{
  sessionId: Scalars["String"]["input"];
}>;

export type BookExamAnswersQuery = {
  bookExamAnswers: Array<{
    id: string;
    questionId: string;
    contentType: string;
    durationMs: number;
    createdAt: string;
    playbackUrl: string;
  }>;
};

export type CheckAchievementsQueryVariables = Exact<{ [key: string]: never }>;

export type CheckAchievementsQuery = {
  checkAchievements: {
    aggregate: Array<{ achievementType: string; countTotal: number; countNew?: number | null; dateLast?: any | null }>;
    achievementsNew: Array<{ type: string; dateAchieved: any; goal: string }>;
  };
};

export type CheckNewAssignmentsQueryVariables = Exact<{ [key: string]: never }>;

export type CheckNewAssignmentsQuery = {
  displayNewAssignmentAnnouncements: Array<{ testType: string; description: string; date?: any | null }>;
};

export type GetAllBlacklistItemsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllBlacklistItemsQuery = { blacklistItems: Array<{ id: string; userAssignment: { id: string } }> };

export type GetAllBlacklistItemsWithSubjectQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllBlacklistItemsWithSubjectQuery = {
  blacklistItems: Array<{ id: string; userAssignment: { id: string; subject?: { appName?: string | null } | null } }>;
};

export type GetAllBookmarksQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllBookmarksQuery = { bookmarks: Array<{ id: string; userAssignment: { id: string } }> };

export type GetAllBookmarksWithSubjectQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllBookmarksWithSubjectQuery = {
  bookmarks: Array<{ id: string; userAssignment: { id: string; subject?: { appName?: string | null } | null } }>;
};

export type GetAllTimetableGenericsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllTimetableGenericsQuery = { timetableGenericAll: Array<{ created: any }> };

export type GetAssignmentAnswersQueryVariables = Exact<{
  assignmentId: Scalars["String"]["input"];
}>;

export type GetAssignmentAnswersQuery = {
  assignments: Array<{ assignment?: { questions: Array<{ correctAnswers: Array<string | null> }> } | null }>;
};

export type GetAssignmentDetailForCmsQueryVariables = Exact<{
  assignmentId: Scalars["String"]["input"];
}>;

export type GetAssignmentDetailForCmsQuery = {
  assignments: Array<{
    id: string;
    isActive: boolean;
    assignment?: {
      questionsText?: string | null;
      assignmentText?: string | null;
      transcriptCs?: string | null;
      transcriptEn?: string | null;
      assignmentImage?: string | null;
      assignmentImageThumbHash?: string | null;
      assignmentAudio?: string | null;
      printingAttachment?: string | null;
      isAnswerCaseSensitive?: boolean | null;
      AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
      assignmentType: { type?: string | null };
      questions: Array<{
        heading?: string | null;
        placeholder?: string | null;
        showAbilityScore?: boolean | null;
        options: Array<{ value?: string | null; additionalText?: string | null }>;
        solutionAnalysis?: {
          text?: string | null;
          image?: string | null;
          writtenVideo?: string | null;
          explainerVideo?: string | null;
        } | null;
        selfEvaluation?: {
          general?: { text?: string | null; image?: string | null } | null;
          options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
        } | null;
      }>;
    } | null;
    general?: {
      testOrder?: number | null;
      admissionTest: { name?: string | null; displayName?: string | null };
    } | null;
    scoring?: {
      canTeacherEvaluate?: boolean | null;
      scoreMax?: number | null;
      scoringMethod: { scoringMethod?: string | null };
      selfEvaluation?: { selfEvaluation?: string | null } | null;
    } | null;
    analysis?: {
      hasSharedAnalysis?: boolean | null;
      sharedAnalysis?: {
        text?: string | null;
        image?: string | null;
        writtenVideo?: string | null;
        explainerVideo?: string | null;
      } | null;
    } | null;
    selfEvaluation?: {
      hasSharedSelfEvaluation: boolean;
      sharedSelfEvaluation?: {
        general?: { text?: string | null; image?: string | null } | null;
        options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
      } | null;
    } | null;
  }>;
};

export type GetAssignmentsEnvelopesQueryVariables = Exact<{
  assignments?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type GetAssignmentsEnvelopesQuery = {
  userAssignments: { items: Array<{ envelope?: string | null; id: string }> };
};

export type GetAssignmentsInThemeQueryVariables = Exact<{
  themeId: Scalars["String"]["input"];
}>;

export type GetAssignmentsInThemeQuery = { userAssignmentsCached: { items: Array<{ id: string }> } };

export type GetBlacklistItemsAndSubjectsQueryVariables = Exact<{ [key: string]: never }>;

export type GetBlacklistItemsAndSubjectsQuery = {
  blacklistItems: Array<{
    userAssignment: {
      id: string;
      envelope?: string | null;
      assignment?: {
        id: string;
        isActive: boolean;
        assignment?: {
          assignmentText?: string | null;
          questionsText?: string | null;
          questions: Array<{ heading?: string | null }>;
        } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
      subject?: { appName?: string | null } | null;
    };
  }>;
  subjects: Array<{ appName?: string | null }>;
};

export type GetBlacklistedPracticeAssignmentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetBlacklistedPracticeAssignmentsQuery = {
  blacklistItems: Array<{
    id: string;
    userAssignment: {
      id: string;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      envelope?: string | null;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
      } | null;
    };
  }>;
};

export type GetBlindSpotThemesQueryVariables = Exact<{ [key: string]: never }>;

export type GetBlindSpotThemesQuery = {
  blindSpotThemes: Array<{ id: string; theme?: { id: string; name?: string | null; appName?: string | null } | null }>;
};

export type GetBookCardsQueryVariables = Exact<{
  bookId: Scalars["String"]["input"];
}>;

export type GetBookCardsQuery = {
  bookCards: Array<{ id: string; categoryId?: string | null; question?: string | null; cardText?: string | null }>;
};

export type GetBookDetailQueryVariables = Exact<{
  idList?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type GetBookDetailQuery = {
  books: Array<{
    id: string;
    nameCz?: string | null;
    nameOriginal?: string | null;
    authorFullName?: string | null;
    hasDetail?: boolean | null;
    graduationReadingPeriodId?: string | null;
    graduationReadingTypeId?: string | null;
    summary?: string | null;
    emojis?: string | null;
    hasEnglishUsage?: boolean | null;
    englishUsage?: string | null;
    direction?: string | null;
    spacetime?: string | null;
    themes?: string | null;
    pagesCount?: string | null;
    readingLength?: string | null;
    firstPublicationYear?: string | null;
    mainPicture?: string | null;
    picture1?: string | null;
    picture2?: string | null;
    picture3?: string | null;
    picture4?: string | null;
    picture1Source?: string | null;
    picture2Source?: string | null;
    picture3Source?: string | null;
    picture4Source?: string | null;
    orderOnlineLink?: string | null;
    orderOnlineHasDiscount?: boolean | null;
    orderUsedLink?: string | null;
    orderUsedHasDiscount?: boolean | null;
    orderNewLink?: string | null;
    orderNewHasDiscount?: boolean | null;
    orderAudioLink?: string | null;
    orderAudioHasDiscount?: boolean | null;
    trailerUrl?: string | null;
    freeStreamingUrl?: string | null;
    paidStreamingUrl?: string | null;
    paidStreamingProvider?: string | null;
    bookDiff?: string | null;
    video?: string | null;
    podcastShort?: string | null;
    podcastLong?: string | null;
    cheatSheetShort?: string | null;
    cheatSheetLong?: string | null;
    authorCountry?: { id: string; name?: string | null; emoji?: string | null } | null;
    genre?: { id?: string | null; name?: string | null; description?: string | null } | null;
  }>;
  graduationReadingPeriods: Array<{ id: string; name?: string | null; shortcut?: string | null }>;
  graduationReadingTypes: Array<{
    id: string;
    name?: string | null;
    internalCode?: string | null;
    description?: string | null;
  }>;
};

export type GetBookListQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookListQuery = { books: Array<{ id: string; nameCz?: string | null }> };

export type GetBookPracticeContentQueryVariables = Exact<{
  bookId: Scalars["String"]["input"];
}>;

export type GetBookPracticeContentQuery = {
  bookCards: Array<{ id: string; categoryId?: string | null; question?: string | null; cardText?: string | null }>;
  qaCards: Array<{
    id: string;
    categoryId: string;
    question?: string | null;
    answer?: string | null;
    order?: number | null;
  }>;
  consolidationCategories: Array<{
    id: string;
    position?: number | null;
    name?: string | null;
    focus?: string | null;
    textOrange?: string | null;
    textRed?: string | null;
    textGreen?: string | null;
    isArtText?: boolean | null;
  }>;
};

export type GetBookmarkedPracticeAssignmentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookmarkedPracticeAssignmentsQuery = {
  bookmarks: Array<{
    id: string;
    userAssignment: {
      id: string;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      envelope?: string | null;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
      } | null;
    };
  }>;
};

export type GetBookmarksAndSubjectsQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookmarksAndSubjectsQuery = {
  bookmarks: Array<{
    userAssignment: {
      id: string;
      envelope?: string | null;
      assignment?: {
        id: string;
        isActive: boolean;
        assignment?: {
          assignmentText?: string | null;
          questionsText?: string | null;
          questions: Array<{ heading?: string | null }>;
        } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
      subject?: { appName?: string | null } | null;
    };
  }>;
  subjects: Array<{ appName?: string | null }>;
};

export type GetBookmarksCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookmarksCountQuery = { bookmarks: Array<{ id: string }> };

export type GetBooksSelectionOverviewQueryVariables = Exact<{
  idList?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type GetBooksSelectionOverviewQuery = {
  graduationReadingPeriods: Array<{
    id: string;
    name?: string | null;
    shortcut?: string | null;
    internalCode?: string | null;
    minBooks?: number | null;
  }>;
  graduationReadingTypes: Array<{
    id: string;
    name?: string | null;
    internalCode?: string | null;
    minBooks?: number | null;
  }>;
  books: Array<{
    id: string;
    nameCz?: string | null;
    authorFullName?: string | null;
    hasDetail?: boolean | null;
    graduationReadingPeriodId?: string | null;
    graduationReadingTypeId?: string | null;
    mainPicture?: string | null;
  }>;
};

export type GetConsolidationCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetConsolidationCategoriesQuery = {
  consolidationCategories: Array<{
    id: string;
    position?: number | null;
    name?: string | null;
    focus?: string | null;
    textOrange?: string | null;
    textRed?: string | null;
    textGreen?: string | null;
    isArtText?: boolean | null;
  }>;
};

export type GetAssignmentsInEnvelopeQueryVariables = Exact<{
  themeId: Scalars["String"]["input"];
  envelopeId: Scalars["String"]["input"];
}>;

export type GetAssignmentsInEnvelopeQuery = { userAssignmentsCached: { items: Array<{ id: string }> } };

export type GetCurrentGenericTimetableQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentGenericTimetableQuery = { timetableGenericCurrent: { created: any } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
  currentUser: {
    admissionsDeadline?: any | null;
    email?: string | null;
    name?: string | null;
    vocative?: string | null;
    grade?: string | null;
    fullAccess?: boolean | null;
    sex?: string | null;
    testsToUnlock?: number | null;
    testsToBuy?: number | null;
    preferredSubject?: string | null;
    withSound?: boolean | null;
    phoneNumber?: string | null;
    phoneValidationDatetimeLast?: string | null;
    phoneValidationPhoneNumber?: string | null;
    firstLogin?: any | null;
    sessionsAchieved?: number | null;
    phoneValidationStatus?: string | null;
    phoneValidationRequired: boolean;
    smsEnabled?: boolean | null;
    elixirOfLifeCount?: number | null;
    daysFulfillsPlan?: number | null;
    idExternalZona?: string | null;
    preferredSchools: Array<{ name?: string | null; pointsForAcceptance?: number | null }>;
    onboarding: { introduced: boolean; finished: boolean; welcome: boolean };
  };
  timetableGenericAll: Array<{ created: any }>;
};

export type GetDashboardDataQueryVariables = Exact<{
  timetableFrom: Scalars["Date"]["input"];
  timetableTo: Scalars["Date"]["input"];
}>;

export type GetDashboardDataQuery = {
  displayOutages: Array<{ startTime?: any | null; endTime?: any | null; text?: string | null }>;
  timetable: {
    timetable: Array<{
      dateStart?: any | null;
      dateEnd?: any | null;
      plan: Array<{
        date?: any | null;
        startAt?: any | null;
        duration?: number | null;
        durationReal?: number | null;
        sessionFinished?: boolean | null;
        status?: string | null;
      }>;
    }>;
  };
  testPresence: Array<{ dateTime: string }>;
  envelopesSummary: { green: number; yellow: number; red: number };
  lastAchievements: Array<{ type: string; dateAchieved: any; goal: string }>;
  checkAchievements: {
    aggregate: Array<{ achievementType: string; countTotal: number; countNew?: number | null; dateLast?: any | null }>;
    achievementsNew: Array<{ type: string; dateAchieved: any; goal: string }>;
  };
  blacklistItems: Array<{ id: string }>;
};

export type GetEnvelopeSubjectsThemesQueryVariables = Exact<{
  isRed: Scalars["Boolean"]["input"];
  isGreen: Scalars["Boolean"]["input"];
  isOrange: Scalars["Boolean"]["input"];
}>;

export type GetEnvelopeSubjectsThemesQuery = {
  subjects: Array<{ id: string; appAbbr?: string | null; appName?: string | null; isFavorite?: boolean | null }>;
  userSubjects: Array<{
    scoreAggregatePercent?: number | null;
    assignmentsGreen: number;
    assignmentsYellow: number;
    assignmentsRed: number;
    subject?: { id: string } | null;
  }>;
  userThemes: Array<{
    id: string;
    hasAssignments: boolean;
    assignmentsRed: number;
    assignmentsGreen: number;
    assignmentsYellow: number;
    theme?: {
      id: string;
      appName?: string | null;
      name?: string | null;
      description?: string | null;
      subject?: string | null;
      avgTestPoints?: number | null;
    } | null;
  }>;
  envelopesSummary: { green: number; yellow: number; red: number };
};

export type GetEnvelopeThemeAssignmentsQueryVariables = Exact<{
  themeId: Scalars["String"]["input"];
  envelopeId: Scalars["String"]["input"];
}>;

export type GetEnvelopeThemeAssignmentsQuery = {
  userAssignmentsCached: {
    items: Array<{
      id: string;
      envelope?: string | null;
      assignment?: {
        id: string;
        isActive: boolean;
        assignment?: {
          assignmentText?: string | null;
          questionsText?: string | null;
          questions: Array<{ heading?: string | null }>;
        } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
    }>;
  };
};

export type GetEnvelopeThemePracticeAssignmentsQueryVariables = Exact<{
  envelopeId: Scalars["String"]["input"];
  themeId: Scalars["String"]["input"];
}>;

export type GetEnvelopeThemePracticeAssignmentsQuery = {
  userAssignmentsCached: {
    items: Array<{
      id: string;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      envelope?: string | null;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
      } | null;
    }>;
  };
};

export type GetExamCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetExamCategoriesQuery = {
  examCategories: Array<{
    id: string;
    position?: number | null;
    name?: string | null;
    focus?: string | null;
    textOrange?: string | null;
    textRed?: string | null;
    isArtText?: boolean | null;
  }>;
};

export type GetExamContentQueryVariables = Exact<{
  bookId: Scalars["String"]["input"];
}>;

export type GetExamContentQuery = {
  examCategories: Array<{
    id: string;
    position?: number | null;
    name?: string | null;
    focus?: string | null;
    textOrange?: string | null;
    textRed?: string | null;
    isArtText?: boolean | null;
  }>;
  mockExamQuestions: Array<{
    id: string;
    categoryId: string;
    order?: number | null;
    question?: string | null;
    answer?: string | null;
  }>;
  probingQuestions: Array<{
    id: string;
    categoryId: string;
    order?: number | null;
    question?: string | null;
    answer?: string | null;
  }>;
  books: Array<{ id: string; nameCz?: string | null; authorFullName?: string | null; worksheetBlank?: string | null }>;
};

export type GetExamHistoryQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  bookId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetExamHistoryQuery = {
  examHistory: Array<{
    id: string;
    bookId: string;
    bookName: string;
    startedAt: string;
    finishedAt?: string | null;
    step: string;
    result?: {
      grade: number;
      perCategory: Array<{ categoryId: string; level: string }>;
      sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
    } | null;
  }>;
};

export type GetExamSessionQueryVariables = Exact<{
  bookId: Scalars["String"]["input"];
}>;

export type GetExamSessionQuery = {
  examSession?: {
    id: string;
    bookId: string;
    startedAt: string;
    finishedAt?: string | null;
    step: string;
    reachedCommission?: boolean | null;
    commissionBlock?: number | null;
    commissionQuestion?: number | null;
    ratings: any;
    speechRating?: string | null;
    speechRatings: any;
    blocks: Array<{ index: number; categoryId: string; questionIds: Array<string> }>;
    speechClips?: { filler?: string | null; slang?: string | null; reasoning: Array<string> } | null;
    settings: { durationMin: number; hasAmbience: boolean; isRecording: boolean };
    result?: {
      grade: number;
      totalPoints?: number | null;
      pointsToBetter?: number | null;
      algoVersion?: string | null;
      perCategory: Array<{ categoryId: string; level: string }>;
      sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
    } | null;
  } | null;
};

export type GetExamSessionByIdQueryVariables = Exact<{
  sessionId: Scalars["String"]["input"];
}>;

export type GetExamSessionByIdQuery = {
  examSessionById?: {
    id: string;
    bookId: string;
    startedAt: string;
    finishedAt?: string | null;
    step: string;
    reachedCommission?: boolean | null;
    commissionBlock?: number | null;
    commissionQuestion?: number | null;
    ratings: any;
    speechRating?: string | null;
    speechRatings: any;
    blocks: Array<{ index: number; categoryId: string; questionIds: Array<string> }>;
    speechClips?: { filler?: string | null; slang?: string | null; reasoning: Array<string> } | null;
    settings: { durationMin: number; hasAmbience: boolean; isRecording: boolean };
    result?: {
      grade: number;
      totalPoints?: number | null;
      pointsToBetter?: number | null;
      algoVersion?: string | null;
      perCategory: Array<{ categoryId: string; level: string }>;
      sections: Array<{ sectionId: string; score?: number | null; points?: number | null; level: string }>;
    } | null;
  } | null;
};

export type GetFaqQueryVariables = Exact<{ [key: string]: never }>;

export type GetFaqQuery = { faqAll: Array<{ title?: string | null; description?: string | null }> };

export type GetGraduationReadingOverviewQueryVariables = Exact<{ [key: string]: never }>;

export type GetGraduationReadingOverviewQuery = {
  graduationReadingPeriods: Array<{
    id: string;
    name?: string | null;
    shortcut?: string | null;
    internalCode?: string | null;
    minBooks?: number | null;
  }>;
  graduationReadingTypes: Array<{
    id: string;
    name?: string | null;
    internalCode?: string | null;
    minBooks?: number | null;
  }>;
  books: Array<{
    id: string;
    nameCz?: string | null;
    authorFullName?: string | null;
    hasDetail?: boolean | null;
    graduationReadingPeriodId?: string | null;
    graduationReadingTypeId?: string | null;
    mainPicture?: string | null;
    authorCountry?: { id: string; name?: string | null; emoji?: string | null } | null;
  }>;
};

export type GetHistoryAllQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetHistoryAllQuery = {
  userTutoringsAndSessions: Array<{
    dateTested: string;
    session?: {
      id: string;
      lastSessionMood?: number | null;
      lastSessionMoodText?: string | null;
      lastSessionMoodSelfReflection?: string | null;
      scoreMaxTotal?: number | null;
      scoreRealTotal?: number | null;
      envelopeMovements: Array<{ userAssigment: string; envelopeBefore: string; envelopeNow?: string | null }>;
      userAssignments: Array<{
        id: string;
        scoreReal?: number | null;
        scoreMax?: number | null;
        envelope?: string | null;
        theme?: { id: string } | null;
        assignment?: {
          isActive: boolean;
          assignment?: { assignmentText?: string | null } | null;
          general?: {
            testOrder?: number | null;
            admissionTest: { name?: string | null; displayName?: string | null };
          } | null;
        } | null;
      }>;
    } | null;
    tutoring?: {
      id: string;
      assignments: Array<{
        userAssignment?: string | null;
        finished: boolean;
        userAssignmentObject?: {
          id: string;
          envelope?: string | null;
          theme?: { id: string } | null;
          assignment?: {
            isActive: boolean;
            assignment?: { assignmentText?: string | null } | null;
            general?: {
              testOrder?: number | null;
              admissionTest: { name?: string | null; displayName?: string | null };
            } | null;
          } | null;
        } | null;
      }>;
      themeAssignments: Array<{
        userAssignment?: string | null;
        finished: boolean;
        userAssignmentObject?: {
          id: string;
          envelope?: string | null;
          theme?: { id: string } | null;
          assignment?: {
            isActive: boolean;
            assignment?: { assignmentText?: string | null } | null;
            general?: {
              testOrder?: number | null;
              admissionTest: { name?: string | null; displayName?: string | null };
            } | null;
          } | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type GetHistoryAssignmentQueryVariables = Exact<{
  assignmentId: Scalars["String"]["input"];
}>;

export type GetHistoryAssignmentQuery = {
  userTutoringsAndSessions: Array<{
    dateTested: string;
    session?: {
      envelopeMovements: Array<{ userAssigment: string; envelopeBefore: string; envelopeNow?: string | null }>;
    } | null;
  }>;
};

export type GetHistorySessionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetHistorySessionsQuery = {
  userTutoringsAndSessions: Array<{
    dateTested: string;
    session?: {
      id: string;
      envelopeMovements: Array<{ userAssigment: string; envelopeBefore: string; envelopeNow?: string | null }>;
      userAssignments: Array<{ id: string }>;
    } | null;
  }>;
};

export type GetHistoryTutoringsQueryVariables = Exact<{ [key: string]: never }>;

export type GetHistoryTutoringsQuery = {
  userTutoringsAndSessions: Array<{
    dateTested: string;
    tutoring?: {
      id: string;
      assignments: Array<{
        userAssignment?: string | null;
        finished: boolean;
        userAssignmentObject?: {
          id: string;
          envelope?: string | null;
          theme?: { id: string } | null;
          assignment?: {
            isActive: boolean;
            assignment?: { assignmentText?: string | null } | null;
            general?: {
              testOrder?: number | null;
              admissionTest: { name?: string | null; displayName?: string | null };
            } | null;
          } | null;
        } | null;
      }>;
      themeAssignments: Array<{
        userAssignment?: string | null;
        finished: boolean;
        userAssignmentObject?: {
          id: string;
          envelope?: string | null;
          theme?: { id: string } | null;
          assignment?: {
            isActive: boolean;
            assignment?: { assignmentText?: string | null } | null;
            general?: {
              testOrder?: number | null;
              admissionTest: { name?: string | null; displayName?: string | null };
            } | null;
          } | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type GetLearningAttemptsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
}>;

export type GetLearningAttemptsQuery = {
  learningAttempts: Array<{
    id: string;
    dateTested: string;
    session?: {
      id: string;
      lastSessionMood?: number | null;
      lastSessionMoodText?: string | null;
      lastSessionMoodSelfReflection?: string | null;
      scoreMaxTotal?: number | null;
      scoreRealTotal?: number | null;
      envelopeMovements: Array<{ userAssigment: string; envelopeBefore: string; envelopeNow?: string | null }>;
      userAssignments: Array<{
        id: string;
        scoreReal?: number | null;
        scoreMax?: number | null;
        envelope?: string | null;
        theme?: { id: string } | null;
        assignment?: {
          isActive: boolean;
          assignment?: { assignmentText?: string | null } | null;
          general?: {
            testOrder?: number | null;
            admissionTest: { name?: string | null; displayName?: string | null };
          } | null;
        } | null;
      }>;
    } | null;
    tutoringSnapshot?: {
      tutoringId: string;
      assignments: Array<{
        userAssignment?: string | null;
        finished: boolean;
        userAssignmentObject?: {
          id: string;
          envelope?: string | null;
          theme?: { id: string } | null;
          assignment?: {
            isActive: boolean;
            assignment?: { assignmentText?: string | null } | null;
            general?: {
              testOrder?: number | null;
              admissionTest: { name?: string | null; displayName?: string | null };
            } | null;
          } | null;
        } | null;
      }>;
      themeAssignments: Array<{
        userAssignment?: string | null;
        finished: boolean;
        userAssignmentObject?: {
          id: string;
          envelope?: string | null;
          theme?: { id: string } | null;
          assignment?: {
            isActive: boolean;
            assignment?: { assignmentText?: string | null } | null;
            general?: {
              testOrder?: number | null;
              admissionTest: { name?: string | null; displayName?: string | null };
            } | null;
          } | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type GetMasterclassPageQueryVariables = Exact<{ [key: string]: never }>;

export type GetMasterclassPageQuery = {
  masterclasses: Array<{
    id: string;
    title?: string | null;
    order?: number | null;
    length?: string | null;
    video?: string | null;
    description?: string | null;
    pdf?: string | null;
    pdfName?: string | null;
    pdfDescription?: string | null;
    deadline?: string | null;
    note?: string | null;
    previewImage?: string | null;
  }>;
  masterclassSettings?: {
    id: string;
    perex?: string | null;
    guideLabel?: string | null;
    guideName?: string | null;
    guidePhoto?: string | null;
    guideBio?: string | null;
    infoBox?: string | null;
  } | null;
  masterclassProgress: { viewed: any; completed: any };
};

export type GetMySelectionOverviewQueryVariables = Exact<{ [key: string]: never }>;

export type GetMySelectionOverviewQuery = {
  graduationReadingPeriods: Array<{
    id: string;
    name?: string | null;
    shortcut?: string | null;
    internalCode?: string | null;
    minBooks?: number | null;
  }>;
  graduationReadingTypes: Array<{
    id: string;
    name?: string | null;
    internalCode?: string | null;
    minBooks?: number | null;
  }>;
  userSelectedBooks: Array<{
    id: string;
    nameCz?: string | null;
    authorFullName?: string | null;
    hasDetail?: boolean | null;
    graduationReadingPeriodId?: string | null;
    graduationReadingTypeId?: string | null;
    mainPicture?: string | null;
  }>;
};

export type GetNonfictionContentQueryVariables = Exact<{ [key: string]: never }>;

export type GetNonfictionContentQuery = {
  nonfictionText?: {
    id: string;
    video?: string | null;
    coverArt?: string | null;
    cheatSheet?: string | null;
    cheatSheetName?: string | null;
    cheatSheetNote?: string | null;
  } | null;
  nonfictionCategories: Array<{ id: string; position?: number | null; name?: string | null; heading?: string | null }>;
  nonfictionCards: Array<{
    id: string;
    categoryId: string;
    position?: number | null;
    question?: string | null;
    cardText?: string | null;
  }>;
  nonfictionQaCards: Array<{
    id: string;
    categoryId: string;
    position?: number | null;
    question?: string | null;
    answer?: string | null;
  }>;
};

export type GetNonfictionProgressQueryVariables = Exact<{ [key: string]: never }>;

export type GetNonfictionProgressQuery = {
  nonfictionProgress: {
    hasLearned: boolean;
    hasConsolidated: boolean;
    flips: any;
    quizTotal: number;
    quizPassScore: number;
  };
  nonfictionQuizAttempt?: { id: string; startedAt: string; finishedAt?: string | null; verdicts: any } | null;
};

export type GetOnboardingAssignmentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOnboardingAssignmentsQuery = {
  userAssignments: {
    items: Array<{
      id: string;
      scoreMax?: number | null;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      envelope?: string | null;
      assignment?: {
        id: string;
        isActive: boolean;
        successRate?: number | null;
        assignment?: {
          questionsText?: string | null;
          assignmentText?: string | null;
          transcriptCs?: string | null;
          transcriptEn?: string | null;
          assignmentImage?: string | null;
          assignmentImageThumbHash?: string | null;
          assignmentAudio?: string | null;
          printingAttachment?: string | null;
          isAnswerCaseSensitive?: boolean | null;
          AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
          questions: Array<{
            heading?: string | null;
            placeholder?: string | null;
            showAbilityScore?: boolean | null;
            options: Array<{ value?: string | null; additionalText?: string | null }>;
            selfEvaluation?: {
              general?: { text?: string | null; image?: string | null } | null;
              options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
            } | null;
            solutionAnalysis?: {
              text?: string | null;
              image?: string | null;
              writtenVideo?: string | null;
              explainerVideo?: string | null;
            } | null;
          }>;
          assignmentType: { type?: string | null };
        } | null;
        scoring?: {
          canTeacherEvaluate?: boolean | null;
          scoreMax?: number | null;
          timeToSolve?: number | null;
          scoringMethod: { scoringMethod?: string | null };
          selfEvaluation?: { selfEvaluation?: string | null } | null;
        } | null;
        analysis?: {
          hasSharedAnalysis?: boolean | null;
          sharedAnalysis?: {
            text?: string | null;
            image?: string | null;
            writtenVideo?: string | null;
            explainerVideo?: string | null;
          } | null;
        } | null;
        selfEvaluation?: {
          hasSharedSelfEvaluation: boolean;
          sharedSelfEvaluation?: {
            general?: { text?: string | null; image?: string | null } | null;
            options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
          } | null;
        } | null;
      } | null;
      theme?: { appName?: string | null } | null;
      subject?: { appName?: string | null } | null;
    }>;
  };
};

export type GetOnboardingStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetOnboardingStatusQuery = { onboarding: { finished: boolean } };

export type GetParentRewardsQueryVariables = Exact<{ [key: string]: never }>;

export type GetParentRewardsQuery = {
  parentWatch: {
    message?: string | null;
    rewards: Array<{ type: string; targetScore?: number | null; month?: number | null; text: string }>;
    user: { name?: string | null; admissionsDeadline?: any | null };
  };
};

export type GetPracticeEnvelopeQueryVariables = Exact<{
  envelopeId: Scalars["String"]["input"];
}>;

export type GetPracticeEnvelopeQuery = {
  trainingEnvelope: Array<{
    id: string;
    timeToSolve?: number | null;
    timeToLearn?: number | null;
    envelope?: string | null;
    assignment?: {
      isActive: boolean;
      assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
    } | null;
  }>;
};

export type GetPracticeMhdQueryVariables = Exact<{
  length: Scalars["Int"]["input"];
}>;

export type GetPracticeMhdQuery = {
  trainingMhd: {
    userAssignments: Array<{
      id: string;
      assignment?: { isActive: boolean } | null;
      subject?: { appName?: string | null } | null;
    }>;
  };
};

export type GetPracticeMixQueryVariables = Exact<{
  length: Scalars["Int"]["input"];
}>;

export type GetPracticeMixQuery = {
  training: {
    userAssignments: Array<{
      id: string;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
      } | null;
      subject?: { appName?: string | null } | null;
    }>;
  };
};

export type GetPracticeQuizAttemptQueryVariables = Exact<{
  bookId: Scalars["String"]["input"];
}>;

export type GetPracticeQuizAttemptQuery = {
  practiceQuizAttempt?: { id: string; startedAt: string; finishedAt?: string | null; verdicts: any } | null;
};

export type GetQaCardsQueryVariables = Exact<{
  bookId: Scalars["String"]["input"];
}>;

export type GetQaCardsQuery = {
  qaCards: Array<{
    id: string;
    categoryId: string;
    question?: string | null;
    answer?: string | null;
    order?: number | null;
  }>;
};

export type GetSessionResultsQueryVariables = Exact<{
  dateFrom: Scalars["Date"]["input"];
}>;

export type GetSessionResultsQuery = {
  userSessionReview: Array<{ dateTested: any; scoreMaxTotal?: number | null; scoreRealTotal: number }>;
};

export type GetStatisticsDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetStatisticsDataQuery = {
  checkAchievements: {
    achievements: Array<{ type: string; dateAchieved: any; goal: string }>;
    aggregate: Array<{ achievementType: string; countTotal: number; countNew?: number | null; dateLast?: any | null }>;
  };
  parentWatch: {
    message?: string | null;
    rewards: Array<{ targetScore?: number | null; month?: number | null; text: string }>;
  };
};

export type GetStreakQueryVariables = Exact<{
  streakFrom: Scalars["Date"]["input"];
  streakTo: Scalars["Date"]["input"];
}>;

export type GetStreakQuery = { timetable: { daysFulfillsPlan: number } };

export type GetSubjectsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubjectsQuery = {
  subjects: Array<{
    appAbbr?: string | null;
    appName?: string | null;
    isFavorite?: boolean | null;
    abbreviation?: string | null;
    slug?: string | null;
  }>;
};

export type GetSubjectsThemesQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubjectsThemesQuery = {
  subjectsCached: Array<{ id: string; appAbbr?: string | null; appName?: string | null; isFavorite?: boolean | null }>;
  bookmarksCached: Array<{ id: string }>;
  userSubjectsCached: Array<{
    scoreAggregatePercent?: number | null;
    assignmentsRed: number;
    assignmentsGreen: number;
    assignmentsYellow: number;
    subject?: { id: string } | null;
  }>;
  userThemes: Array<{
    id: string;
    hasAssignments: boolean;
    assignmentsRed: number;
    assignmentsGreen: number;
    assignmentsYellow: number;
    theme?: {
      id: string;
      appName?: string | null;
      name?: string | null;
      description?: string | null;
      subject?: string | null;
      avgTestPoints?: number | null;
    } | null;
  }>;
};

export type GetTestPresencesQueryVariables = Exact<{ [key: string]: never }>;

export type GetTestPresencesQuery = {
  testPresence: Array<{
    dateTime: string;
    scoreMath?: number | null;
    scoreCzech?: number | null;
    absolved?: boolean | null;
    form?: string | null;
  }>;
};

export type GetThemeQueryVariables = Exact<{
  themeId: Scalars["String"]["input"];
}>;

export type GetThemeQuery = {
  themes: Array<{
    name?: string | null;
    appName?: string | null;
    subject?: string | null;
    video?: Array<{ videoId: string; previewImage?: string | null }> | null;
  }>;
};

export type GetThemeAssignmentsQueryVariables = Exact<{
  themeId: Scalars["String"]["input"];
}>;

export type GetThemeAssignmentsQuery = {
  userAssignmentsCached: {
    items: Array<{
      id: string;
      envelope?: string | null;
      assignment?: {
        id: string;
        isActive: boolean;
        assignment?: {
          assignmentText?: string | null;
          questionsText?: string | null;
          questions: Array<{ heading?: string | null }>;
        } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
    }>;
  };
};

export type GetThemePracticeAssignmentsQueryVariables = Exact<{
  themeId: Scalars["String"]["input"];
}>;

export type GetThemePracticeAssignmentsQuery = {
  userAssignmentsCached: {
    items: Array<{
      id: string;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      envelope?: string | null;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentAudio?: string | null; printingAttachment?: string | null } | null;
      } | null;
    }>;
  };
};

export type GetTimetableQueryVariables = Exact<{
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
}>;

export type GetTimetableQuery = {
  timetable: {
    timetable: Array<{
      dateStart?: any | null;
      dateEnd?: any | null;
      plan: Array<{
        date?: any | null;
        startAt?: any | null;
        duration?: number | null;
        durationReal?: number | null;
        sessionFinished?: boolean | null;
        status?: string | null;
      }>;
    }>;
  };
  testPresence: Array<{ dateTime: string }>;
};

export type GetTimetableGenericQueryVariables = Exact<{ [key: string]: never }>;

export type GetTimetableGenericQuery = {
  timetableGenericCurrent: { plan: Array<{ dayName: string; startAt?: any | null; duration?: number | null }> };
};

export type GetTutoringListQueryVariables = Exact<{ [key: string]: never }>;

export type GetTutoringListQuery = { userTutoringAll: Array<{ id: string; theme: string }> };

export type GetTutoringPracticeQueryVariables = Exact<{ [key: string]: never }>;

export type GetTutoringPracticeQuery = {
  userTutoringAll: Array<{
    id: string;
    theme: string;
    userAchievements: Array<string>;
    themeAssignments: Array<{ finished: boolean; userAssignmentObject?: { id: string } | null }>;
    assignments: Array<{ finished: boolean; userAssignmentObject?: { id: string } | null }>;
  }>;
};

export type GetTutoringPracticeByIdQueryVariables = Exact<{
  tutoringId: Scalars["String"]["input"];
}>;

export type GetTutoringPracticeByIdQuery = {
  userTutoringById: {
    id: string;
    theme: string;
    userAchievements: Array<string>;
    themeDetail?: {
      name?: string | null;
      appName?: string | null;
      video?: Array<{ videoId: string; previewImage?: string | null }> | null;
    } | null;
    themeAssignments: Array<{
      finished: boolean;
      userAssignmentObject?: {
        id: string;
        timeToSolve?: number | null;
        timeToLearn?: number | null;
        assignment?: {
          id: string;
          isActive: boolean;
          successRate?: number | null;
          assignment?: {
            questionsText?: string | null;
            assignmentText?: string | null;
            transcriptCs?: string | null;
            transcriptEn?: string | null;
            assignmentImage?: string | null;
            assignmentImageThumbHash?: string | null;
            assignmentAudio?: string | null;
            printingAttachment?: string | null;
            isAnswerCaseSensitive?: boolean | null;
            AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
            assignmentType: { type?: string | null };
            questions: Array<{
              heading?: string | null;
              placeholder?: string | null;
              showAbilityScore?: boolean | null;
              options: Array<{ value?: string | null; additionalText?: string | null }>;
              solutionAnalysis?: {
                text?: string | null;
                image?: string | null;
                writtenVideo?: string | null;
                explainerVideo?: string | null;
              } | null;
              selfEvaluation?: {
                general?: { text?: string | null; image?: string | null } | null;
                options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
              } | null;
            }>;
          } | null;
          general?: {
            testOrder?: number | null;
            admissionTest: { name?: string | null; displayName?: string | null };
          } | null;
          scoring?: {
            scoreMax?: number | null;
            scoringMethod: { scoringMethod?: string | null };
            selfEvaluation?: { selfEvaluation?: string | null } | null;
          } | null;
          analysis?: {
            hasSharedAnalysis?: boolean | null;
            sharedAnalysis?: {
              text?: string | null;
              image?: string | null;
              writtenVideo?: string | null;
              explainerVideo?: string | null;
            } | null;
          } | null;
          selfEvaluation?: {
            hasSharedSelfEvaluation: boolean;
            sharedSelfEvaluation?: {
              general?: { text?: string | null; image?: string | null } | null;
              options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
            } | null;
          } | null;
        } | null;
        theme?: { appName?: string | null } | null;
        subject?: { appName?: string | null; appAbbr?: string | null } | null;
      } | null;
    }>;
    assignments: Array<{
      finished: boolean;
      userAssignmentObject?: {
        id: string;
        timeToSolve?: number | null;
        timeToLearn?: number | null;
        assignment?: {
          id: string;
          isActive: boolean;
          successRate?: number | null;
          assignment?: {
            questionsText?: string | null;
            assignmentText?: string | null;
            transcriptCs?: string | null;
            transcriptEn?: string | null;
            assignmentImage?: string | null;
            assignmentImageThumbHash?: string | null;
            assignmentAudio?: string | null;
            printingAttachment?: string | null;
            isAnswerCaseSensitive?: boolean | null;
            AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
            assignmentType: { type?: string | null };
            questions: Array<{
              heading?: string | null;
              placeholder?: string | null;
              showAbilityScore?: boolean | null;
              options: Array<{ value?: string | null; additionalText?: string | null }>;
              solutionAnalysis?: {
                text?: string | null;
                image?: string | null;
                writtenVideo?: string | null;
                explainerVideo?: string | null;
              } | null;
              selfEvaluation?: {
                general?: { text?: string | null; image?: string | null } | null;
                options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
              } | null;
            }>;
          } | null;
          general?: {
            testOrder?: number | null;
            admissionTest: { name?: string | null; displayName?: string | null };
          } | null;
          scoring?: {
            scoreMax?: number | null;
            scoringMethod: { scoringMethod?: string | null };
            selfEvaluation?: { selfEvaluation?: string | null } | null;
          } | null;
          analysis?: {
            hasSharedAnalysis?: boolean | null;
            sharedAnalysis?: {
              text?: string | null;
              image?: string | null;
              writtenVideo?: string | null;
              explainerVideo?: string | null;
            } | null;
          } | null;
          selfEvaluation?: {
            hasSharedSelfEvaluation: boolean;
            sharedSelfEvaluation?: {
              general?: { text?: string | null; image?: string | null } | null;
              options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
            } | null;
          } | null;
        } | null;
        theme?: { appName?: string | null } | null;
        subject?: { appName?: string | null; appAbbr?: string | null } | null;
      } | null;
    }>;
  };
};

export type GetTutoringThemesMinimumQueryVariables = Exact<{ [key: string]: never }>;

export type GetTutoringThemesMinimumQuery = {
  userTutoringAll: Array<{
    id: string;
    theme: string;
    userAchievements: Array<string>;
    themeAssignments: Array<{
      finished: boolean;
      userAssignmentObject?: { envelope?: string | null; id: string } | null;
    }>;
    assignments: Array<{ finished: boolean; userAssignmentObject?: { envelope?: string | null; id: string } | null }>;
    videotips: Array<{ videoId: string }>;
  }>;
};

export type GetUnrecognizedAnswersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetUnrecognizedAnswersQuery = {
  unrecognizedAnswers: {
    totalCount: number;
    acceptedCount: number;
    rejectedCount: number;
    items: Array<{
      id: string;
      correctAnswer?: string | null;
      date?: any | null;
      questionNumber?: number | null;
      studentAnswer?: string | null;
      checked?: boolean | null;
      wasCorrect?: boolean | null;
      assignmentId?: string | null;
      userAssignmentId?: string | null;
      testName?: string | null;
      testOrder?: number | null;
    }>;
  };
};

export type GetUserAssignmentQueryVariables = Exact<{
  assignmentId: Scalars["String"]["input"];
}>;

export type GetUserAssignmentQuery = {
  userAssignments: {
    items: Array<{
      id: string;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      assignment?: {
        id: string;
        isActive: boolean;
        successRate?: number | null;
        assignment?: {
          questionsText?: string | null;
          assignmentText?: string | null;
          transcriptCs?: string | null;
          transcriptEn?: string | null;
          assignmentImage?: string | null;
          assignmentImageThumbHash?: string | null;
          assignmentAudio?: string | null;
          printingAttachment?: string | null;
          isAnswerCaseSensitive?: boolean | null;
          AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
          assignmentType: { type?: string | null };
          questions: Array<{
            heading?: string | null;
            placeholder?: string | null;
            showAbilityScore?: boolean | null;
            options: Array<{ value?: string | null; additionalText?: string | null }>;
            solutionAnalysis?: {
              text?: string | null;
              image?: string | null;
              writtenVideo?: string | null;
              explainerVideo?: string | null;
            } | null;
            selfEvaluation?: {
              general?: { text?: string | null; image?: string | null } | null;
              options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
            } | null;
          }>;
        } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
        scoring?: {
          scoreMax?: number | null;
          scoringMethod: { scoringMethod?: string | null };
          selfEvaluation?: { selfEvaluation?: string | null } | null;
        } | null;
        analysis?: {
          hasSharedAnalysis?: boolean | null;
          sharedAnalysis?: {
            text?: string | null;
            image?: string | null;
            writtenVideo?: string | null;
            explainerVideo?: string | null;
          } | null;
        } | null;
        selfEvaluation?: {
          hasSharedSelfEvaluation: boolean;
          sharedSelfEvaluation?: {
            general?: { text?: string | null; image?: string | null } | null;
            options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
          } | null;
        } | null;
      } | null;
      theme?: { appName?: string | null } | null;
      subject?: { appName?: string | null; appAbbr?: string | null } | null;
    }>;
  };
};

export type GetAssignmentsHistoryMinimumQueryVariables = Exact<{
  assignmentIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetAssignmentsHistoryMinimumQuery = {
  userAssignments: {
    items: Array<{
      id: string;
      envelope?: string | null;
      theme?: { id: string } | null;
      assignment?: {
        isActive: boolean;
        assignment?: { assignmentText?: string | null } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
    }>;
  };
};

export type GetUserAssignmentPaginatedQueryVariables = Exact<{
  assignmentIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetUserAssignmentPaginatedQuery = {
  userAssignments: {
    items: Array<{
      id: string;
      timeToSolve?: number | null;
      timeToLearn?: number | null;
      assignment?: {
        id: string;
        isActive: boolean;
        successRate?: number | null;
        assignment?: {
          questionsText?: string | null;
          assignmentText?: string | null;
          transcriptCs?: string | null;
          transcriptEn?: string | null;
          assignmentImage?: string | null;
          assignmentImageThumbHash?: string | null;
          assignmentAudio?: string | null;
          printingAttachment?: string | null;
          isAnswerCaseSensitive?: boolean | null;
          AssignmentImageDimensions?: { width?: number | null; height?: number | null } | null;
          assignmentType: { type?: string | null };
          questions: Array<{
            heading?: string | null;
            placeholder?: string | null;
            showAbilityScore?: boolean | null;
            options: Array<{ value?: string | null; additionalText?: string | null }>;
            solutionAnalysis?: {
              text?: string | null;
              image?: string | null;
              writtenVideo?: string | null;
              explainerVideo?: string | null;
            } | null;
            selfEvaluation?: {
              general?: { text?: string | null; image?: string | null } | null;
              options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
            } | null;
          }>;
        } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
        scoring?: {
          scoreMax?: number | null;
          scoringMethod: { scoringMethod?: string | null };
          selfEvaluation?: { selfEvaluation?: string | null } | null;
        } | null;
        analysis?: {
          hasSharedAnalysis?: boolean | null;
          sharedAnalysis?: {
            text?: string | null;
            image?: string | null;
            writtenVideo?: string | null;
            explainerVideo?: string | null;
          } | null;
        } | null;
        selfEvaluation?: {
          hasSharedSelfEvaluation: boolean;
          sharedSelfEvaluation?: {
            general?: { text?: string | null; image?: string | null } | null;
            options: Array<{ text?: string | null; image?: string | null; scoreReal?: number | null }>;
          } | null;
        } | null;
      } | null;
      theme?: { appName?: string | null } | null;
      subject?: { appName?: string | null; appAbbr?: string | null } | null;
    }>;
  };
};

export type GetAssignmentsTutoringMinimumQueryVariables = Exact<{
  assignmentIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetAssignmentsTutoringMinimumQuery = {
  userAssignments: {
    items: Array<{
      id: string;
      envelope?: string | null;
      theme?: { id: string } | null;
      assignment?: { isActive: boolean } | null;
    }>;
  };
};

export type GetUserBookProgressQueryVariables = Exact<{
  bookId: Scalars["String"]["input"];
}>;

export type GetUserBookProgressQuery = {
  userBookProgress?: {
    id: string;
    bookId: string;
    hasLearned: boolean;
    hasConsolidated: boolean;
    hasTested: boolean;
    flips: any;
  } | null;
};

export type GetUserBookProgressAllQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserBookProgressAllQuery = {
  userBookProgressAll: Array<{
    id: string;
    bookId: string;
    hasLearned: boolean;
    hasConsolidated: boolean;
    hasTested: boolean;
    grade?: number | null;
  }>;
};

export type GetUserBooksQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserBooksQuery = { userBooks: Array<{ id: string; bookId: string; createdAt?: string | null }> };

export type GetUserSubjectsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserSubjectsQuery = {
  userSubjects: Array<{
    subject?: {
      id: string;
      appAbbr?: string | null;
      appName?: string | null;
      abbreviation?: string | null;
      slug?: string | null;
      superTopics: Array<{ id: string }>;
    } | null;
  }>;
};

export type GetUserThemeByIdQueryVariables = Exact<{
  userThemeId: Scalars["String"]["input"];
}>;

export type GetUserThemeByIdQuery = {
  userTheme: {
    hasAssignments: boolean;
    assignmentsRed: number;
    assignmentsGreen: number;
    assignmentsYellow: number;
    theme?: {
      id: string;
      appName?: string | null;
      name?: string | null;
      description?: string | null;
      subject?: string | null;
      avgTestPoints?: number | null;
    } | null;
  };
};

export type GetUserThemesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserThemesQuery = {
  userThemes: Array<{
    hasAssignments: boolean;
    assignmentsRed: number;
    assignmentsGreen: number;
    assignmentsYellow: number;
    theme?: {
      id: string;
      appName?: string | null;
      name?: string | null;
      description?: string | null;
      subject?: string | null;
      avgTestPoints?: number | null;
    } | null;
  }>;
};

export type GetVideoTipsQueryVariables = Exact<{ [key: string]: never }>;

export type GetVideoTipsQuery = {
  videotips: Array<{
    title?: string | null;
    url?: string | null;
    previewImage?: string | null;
    videotipCategory?: { name?: string | null; appName?: string | null; grade?: string | null } | null;
  }>;
};

export type GetWeeklyChallengesQueryVariables = Exact<{ [key: string]: never }>;

export type GetWeeklyChallengesQuery = { weeklyChallenges: Array<{ theme: string }> };

export type SearchAssignmentsQueryVariables = Exact<{
  search: Scalars["String"]["input"];
}>;

export type SearchAssignmentsQuery = {
  userAssignmentsFulltext: {
    totalCount: number;
    items: Array<{
      id: string;
      envelope?: string | null;
      assignment?: {
        id: string;
        isActive: boolean;
        assignment?: {
          assignmentText?: string | null;
          questionsText?: string | null;
          questions: Array<{ heading?: string | null }>;
        } | null;
        general?: {
          testOrder?: number | null;
          admissionTest: { name?: string | null; displayName?: string | null };
        } | null;
      } | null;
    }>;
  };
};

export type StampedFileUrlQueryVariables = Exact<{
  path: Scalars["String"]["input"];
  fileName?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type StampedFileUrlQuery = { stampedFileUrl: string };

export const HistorySessionFragmentDoc = `
    fragment historySession on SessionType {
  id
  lastSessionMood
  lastSessionMoodText
  lastSessionMoodSelfReflection
  envelopeMovements {
    userAssigment
    envelopeBefore
    envelopeNow
  }
  scoreMaxTotal
  scoreRealTotal
  userAssignments {
    id
    scoreReal
    scoreMax
    theme {
      id
    }
    envelope
    assignment {
      isActive
      assignment {
        assignmentText
      }
      general {
        admissionTest {
          name
          displayName
        }
        testOrder
      }
    }
  }
}
    `;
export const HistorySessionMinimalFragmentDoc = `
    fragment historySessionMinimal on SessionType {
  id
  envelopeMovements {
    userAssigment
    envelopeBefore
    envelopeNow
  }
  userAssignments {
    id
  }
}
    `;
export const HistoryTutoringFragmentDoc = `
    fragment historyTutoring on TutoringType {
  id
  assignments {
    userAssignment
    finished
    userAssignmentObject {
      id
      theme {
        id
      }
      envelope
      assignment {
        isActive
        assignment {
          assignmentText
        }
        general {
          admissionTest {
            name
            displayName
          }
          testOrder
        }
      }
    }
  }
  themeAssignments {
    userAssignment
    finished
    userAssignmentObject {
      id
      theme {
        id
      }
      envelope
      assignment {
        isActive
        assignment {
          assignmentText
        }
        general {
          admissionTest {
            name
            displayName
          }
          testOrder
        }
      }
    }
  }
}
    `;
export const HistoryTutoringSnapshotFragmentDoc = `
    fragment historyTutoringSnapshot on TutoringSnapshotType {
  tutoringId
  assignments {
    userAssignment
    finished
    userAssignmentObject {
      id
      theme {
        id
      }
      envelope
      assignment {
        isActive
        assignment {
          assignmentText
        }
        general {
          admissionTest {
            name
            displayName
          }
          testOrder
        }
      }
    }
  }
  themeAssignments {
    userAssignment
    finished
    userAssignmentObject {
      id
      theme {
        id
      }
      envelope
      assignment {
        isActive
        assignment {
          assignmentText
        }
        general {
          admissionTest {
            name
            displayName
          }
          testOrder
        }
      }
    }
  }
}
    `;
export const SelfEvaluationFragmentDoc = `
    fragment selfEvaluation on CommonSelfEvaluationType {
  general {
    text
    image
  }
  options {
    text
    image
    scoreReal
  }
}
    `;
export const AssignmentDetailFragmentDoc = `
    fragment assignmentDetail on AssignmentType {
  id
  isActive
  assignment {
    questionsText
    assignmentText
    transcriptCs
    transcriptEn
    assignmentImage
    assignmentImageThumbHash
    AssignmentImageDimensions {
      width
      height
    }
    assignmentAudio
    printingAttachment
    isAnswerCaseSensitive
    assignmentType {
      type
    }
    questions {
      heading
      placeholder
      options {
        value
        additionalText
      }
      showAbilityScore
      solutionAnalysis {
        text
        image
        writtenVideo
        explainerVideo
      }
      selfEvaluation {
        ...selfEvaluation
      }
    }
  }
  general {
    testOrder
    admissionTest {
      name
      displayName
    }
  }
  scoring {
    canTeacherEvaluate
    scoringMethod {
      scoringMethod
    }
    selfEvaluation {
      selfEvaluation
    }
    scoreMax
  }
  analysis {
    hasSharedAnalysis
    sharedAnalysis {
      text
      image
      writtenVideo
      explainerVideo
    }
  }
  selfEvaluation {
    hasSharedSelfEvaluation
    sharedSelfEvaluation {
      ...selfEvaluation
    }
  }
}
    ${SelfEvaluationFragmentDoc}`;
export const AssignmentDetailForOverviewFragmentDoc = `
    fragment assignmentDetailForOverview on AssignmentType {
  id
  isActive
  assignment {
    assignmentText
    questionsText
    questions {
      heading
    }
  }
  general {
    testOrder
    admissionTest {
      name
      displayName
    }
  }
}
    `;
export const AssignmentForBlacklistFragmentDoc = `
    fragment assignmentForBlacklist on BlacklistItemType {
  userAssignment {
    id
    assignment {
      ...assignmentDetailForOverview
    }
    envelope
    subject {
      appName
    }
  }
}
    ${AssignmentDetailForOverviewFragmentDoc}`;
export const AssignmentForBookmarkFragmentDoc = `
    fragment assignmentForBookmark on BookmarkType {
  userAssignment {
    id
    assignment {
      ...assignmentDetailForOverview
    }
    envelope
    subject {
      appName
    }
  }
}
    ${AssignmentDetailForOverviewFragmentDoc}`;
export const AssignmentHistoryMinimumFragmentDoc = `
    fragment assignmentHistoryMinimum on UserAssignmentType {
  id
  theme {
    id
  }
  envelope
  assignment {
    isActive
    assignment {
      assignmentText
    }
    general {
      admissionTest {
        name
        displayName
      }
      testOrder
    }
  }
}
    `;
export const AssignmentSuperTopicHierarchyFragmentDoc = `
    fragment assignmentSuperTopicHierarchy on UserAssignmentType {
  superTopic {
    id
  }
  subject {
    id
  }
}
    `;
export const AssignmentTutoringMinimumFragmentDoc = `
    fragment assignmentTutoringMinimum on UserAssignmentType {
  id
  theme {
    id
  }
  envelope
  assignment {
    isActive
  }
}
    `;
export const BadgeFragmentDoc = `
    fragment badge on UserAchievementType {
  type
  dateAchieved
  goal
}
    `;
export const BlindSpotThemeFragmentDoc = `
    fragment blindSpotTheme on UserThemeType {
  id
  theme {
    id
    name
    appName
  }
}
    `;
export const CheckAchievementsFragmentDoc = `
    fragment checkAchievements on AchievementsType {
  aggregate {
    achievementType
    countTotal
    countNew
    dateLast
  }
  achievementsNew {
    type
    dateAchieved
    goal
  }
}
    `;
export const EnvelopeSummaryFragmentDoc = `
    fragment envelopeSummary on EnvelopesSummaryType {
  green
  yellow
  red
}
    `;
export const ExamSessionFragmentDoc = `
    fragment examSession on ExamSessionType {
  id
  bookId
  startedAt
  finishedAt
  step
  reachedCommission
  commissionBlock
  commissionQuestion
  blocks {
    index
    categoryId
    questionIds
  }
  ratings
  speechRating
  speechRatings
  speechClips {
    filler
    slang
    reasoning
  }
  settings {
    durationMin
    hasAmbience
    isRecording
  }
  result {
    grade
    perCategory {
      categoryId
      level
    }
    totalPoints
    pointsToBetter
    algoVersion
    sections {
      sectionId
      score
      points
      level
    }
  }
}
    `;
export const LastAchievementFragmentDoc = `
    fragment lastAchievement on UserAchievementType {
  type
  dateAchieved
  goal
}
    `;
export const MasterclassProgressFragmentDoc = `
    fragment masterclassProgress on MasterclassProgressType {
  viewed
  completed
}
    `;
export const NonfictionProgressFragmentDoc = `
    fragment nonfictionProgress on NonfictionProgressType {
  hasLearned
  hasConsolidated
  flips
  quizTotal
  quizPassScore
}
    `;
export const NonfictionQuizAttemptFragmentDoc = `
    fragment nonfictionQuizAttempt on NonfictionQuizAttemptType {
  id
  startedAt
  finishedAt
  verdicts
}
    `;
export const OutageFragmentDoc = `
    fragment outage on OutageType {
  startTime
  endTime
  text
}
    `;
export const PracticeQuizAttemptFragmentDoc = `
    fragment practiceQuizAttempt on PracticeQuizAttemptType {
  id
  startedAt
  finishedAt
  verdicts
}
    `;
export const StudyDayFragmentDoc = `
    fragment studyDay on StudyDayType {
  date
  startAt
  duration
  durationReal
  sessionFinished
  status
}
    `;
export const ThemeFragmentDoc = `
    fragment theme on ThemeType {
  name
  appName
  subject
  video {
    videoId
    previewImage
  }
}
    `;
export const AssignmentExerciseFragmentDoc = `
    fragment assignmentExercise on AssignmentType {
  id
  isActive
  successRate
  assignment {
    questionsText
    assignmentText
    transcriptCs
    transcriptEn
    assignmentImage
    assignmentImageThumbHash
    AssignmentImageDimensions {
      width
      height
    }
    assignmentAudio
    printingAttachment
    questions {
      heading
      placeholder
      options {
        value
        additionalText
      }
      showAbilityScore
      selfEvaluation {
        ...selfEvaluation
      }
      solutionAnalysis {
        text
        image
        writtenVideo
        explainerVideo
      }
    }
    isAnswerCaseSensitive
    assignmentType {
      type
    }
  }
  scoring {
    canTeacherEvaluate
    scoreMax
    timeToSolve
    scoringMethod {
      scoringMethod
    }
    selfEvaluation {
      selfEvaluation
    }
  }
  analysis {
    hasSharedAnalysis
    sharedAnalysis {
      text
      image
      writtenVideo
      explainerVideo
    }
  }
  selfEvaluation {
    hasSharedSelfEvaluation
    sharedSelfEvaluation {
      ...selfEvaluation
    }
  }
}
    ${SelfEvaluationFragmentDoc}`;
export const UserAssignmentForExerciseFragmentDoc = `
    fragment userAssignmentForExercise on UserAssignmentType {
  id
  scoreMax
  timeToSolve
  timeToLearn
  assignment {
    ...assignmentExercise
  }
  theme {
    appName
  }
  subject {
    appName
  }
  envelope
}
    ${AssignmentExerciseFragmentDoc}`;
export const AssignmentPracticeMinimumFragmentDoc = `
    fragment assignmentPracticeMinimum on AssignmentType {
  isActive
  assignment {
    assignmentAudio
    printingAttachment
  }
}
    `;
export const UserAssignmentForExerciseMinimumFragmentDoc = `
    fragment userAssignmentForExerciseMinimum on UserAssignmentType {
  id
  assignment {
    ...assignmentPracticeMinimum
  }
  subject {
    appName
  }
}
    ${AssignmentPracticeMinimumFragmentDoc}`;
export const AssignmentPracticeMinimumMhdFragmentDoc = `
    fragment assignmentPracticeMinimumMhd on AssignmentType {
  isActive
}
    `;
export const UserAssignmentForExerciseMinimumMhdFragmentDoc = `
    fragment userAssignmentForExerciseMinimumMhd on UserAssignmentType {
  id
  assignment {
    ...assignmentPracticeMinimumMhd
  }
  subject {
    appName
  }
}
    ${AssignmentPracticeMinimumMhdFragmentDoc}`;
export const AssignmentForThemeFragmentDoc = `
    fragment assignmentForTheme on AssignmentType {
  id
  isActive
  assignment {
    assignmentText
    questionsText
    questions {
      heading
    }
  }
  general {
    testOrder
    admissionTest {
      name
      displayName
    }
  }
}
    `;
export const UserAssignmentForThemeFragmentDoc = `
    fragment userAssignmentForTheme on UserAssignmentType {
  id
  assignment {
    ...assignmentForTheme
  }
  envelope
}
    ${AssignmentForThemeFragmentDoc}`;
export const UserAssignmentPracticeFragmentDoc = `
    fragment userAssignmentPractice on UserAssignmentType {
  id
  timeToSolve
  timeToLearn
  assignment {
    ...assignmentPracticeMinimum
  }
  envelope
}
    ${AssignmentPracticeMinimumFragmentDoc}`;
export const UserBookProgressFragmentDoc = `
    fragment userBookProgress on UserBookProgressType {
  id
  bookId
  hasLearned
  hasConsolidated
  hasTested
  flips
}
    `;
export const UserSubjectFragmentDoc = `
    fragment userSubject on SubjectType {
  id
  appAbbr
  appName
  abbreviation
  slug
  superTopics {
    id
  }
}
    `;
export const UserThemeFragmentDoc = `
    fragment userTheme on UserThemeType {
  theme {
    id
    appName
    name
    description
    subject
    avgTestPoints
  }
  hasAssignments
  assignmentsRed
  assignmentsGreen
  assignmentsYellow
}
    `;
export const UserTutoringAssignmentMinimumFragmentDoc = `
    fragment userTutoringAssignmentMinimum on TutoringUserAssignmentNested {
  userAssignmentObject {
    envelope
    id
  }
  finished
}
    `;
export const UserTutoringMinimumFragmentDoc = `
    fragment userTutoringMinimum on TutoringType {
  id
  theme
  themeAssignments {
    ...userTutoringAssignmentMinimum
  }
  assignments {
    ...userTutoringAssignmentMinimum
  }
  videotips {
    videoId
  }
  userAchievements
}
    ${UserTutoringAssignmentMinimumFragmentDoc}`;
export const UserTutoringAssignmentPracticeFragmentDoc = `
    fragment userTutoringAssignmentPractice on TutoringUserAssignmentNested {
  userAssignmentObject {
    id
  }
  finished
}
    `;
export const UserTutoringPracticeFragmentDoc = `
    fragment userTutoringPractice on TutoringType {
  id
  theme
  themeAssignments {
    ...userTutoringAssignmentPractice
  }
  assignments {
    ...userTutoringAssignmentPractice
  }
  userAchievements
}
    ${UserTutoringAssignmentPracticeFragmentDoc}`;
export const AssignmentPracticeFragmentDoc = `
    fragment assignmentPractice on AssignmentType {
  id
  isActive
  successRate
  assignment {
    questionsText
    assignmentText
    transcriptCs
    transcriptEn
    assignmentImage
    assignmentImageThumbHash
    AssignmentImageDimensions {
      width
      height
    }
    assignmentAudio
    printingAttachment
    isAnswerCaseSensitive
    assignmentType {
      type
    }
    questions {
      heading
      placeholder
      options {
        value
        additionalText
      }
      showAbilityScore
      solutionAnalysis {
        text
        image
        writtenVideo
        explainerVideo
      }
      selfEvaluation {
        ...selfEvaluation
      }
    }
  }
  general {
    testOrder
    admissionTest {
      name
      displayName
    }
  }
  scoring {
    scoreMax
    scoringMethod {
      scoringMethod
    }
    selfEvaluation {
      selfEvaluation
    }
  }
  analysis {
    hasSharedAnalysis
    sharedAnalysis {
      text
      image
      writtenVideo
      explainerVideo
    }
  }
  selfEvaluation {
    hasSharedSelfEvaluation
    sharedSelfEvaluation {
      ...selfEvaluation
    }
  }
}
    ${SelfEvaluationFragmentDoc}`;
export const UserAssignmentDetailFragmentDoc = `
    fragment userAssignmentDetail on UserAssignmentType {
  id
  timeToSolve
  timeToLearn
  assignment {
    ...assignmentPractice
  }
  theme {
    appName
  }
  subject {
    appName
    appAbbr
  }
}
    ${AssignmentPracticeFragmentDoc}`;
export const UserTutoringPracticeByIdFragmentDoc = `
    fragment userTutoringPracticeById on TutoringType {
  id
  theme
  userAchievements
  themeDetail {
    name
    appName
    video {
      videoId
      previewImage
    }
  }
  themeAssignments {
    finished
    userAssignmentObject {
      ...userAssignmentDetail
    }
  }
  assignments {
    finished
    userAssignmentObject {
      ...userAssignmentDetail
    }
  }
}
    ${UserAssignmentDetailFragmentDoc}`;
export const WorstTopicsFragmentDoc = `
    fragment worstTopics on UserTopicType {
  topic {
    name
    id
  }
  abilityScoreAll
}
    `;
export const BookExamAnswerConfirmDocument = `
    mutation bookExamAnswerConfirm($uploadId: String!) {
  bookExamAnswerConfirm(input: {uploadId: $uploadId})
}
    `;
export const BookExamAnswerUploadUrlDocument = `
    mutation bookExamAnswerUploadUrl($sessionId: String!, $questionId: String!, $contentType: String!, $fileExtension: String!, $durationMs: Int!, $fileSize: Int!) {
  bookExamAnswerUploadUrl(
    input: {sessionId: $sessionId, questionId: $questionId, contentType: $contentType, fileExtension: $fileExtension, durationMs: $durationMs, fileSize: $fileSize}
  ) {
    uploadId
    url
  }
}
    `;
export const CheckAnswersDocument = `
    mutation checkAnswers($assignmentId: String!, $timeToSolve: Int!, $userAnswers: [QuestionAutoInput!], $selfEvaluation: Int) {
  answer(
    input: {userAssignmentId: $assignmentId, timeSolveReal: $timeToSolve, autoEval: $userAnswers, selfEval: $selfEvaluation}
  ) {
    scoreReal
    correctAnswers
  }
}
    `;
export const CheckTutoringAnswerDocument = `
    mutation checkTutoringAnswer($tutoringId: String!, $userAssignmentId: String!, $timeToSolve: Int!, $userAnswers: [QuestionAutoInput!], $selfEvaluation: Int) {
  tutoringAnswer(
    input: {tutoringId: $tutoringId, userAssignmentId: $userAssignmentId, timeSolveReal: $timeToSolve, autoEval: $userAnswers, selfEval: $selfEvaluation}
  ) {
    scoreReal
    scoreMax
    questionResults
  }
}
    `;
export const CreateUnrecognizedAnswerDocument = `
    mutation createUnrecognizedAnswer($input: UnrecognizedAnswerInput!) {
  createUnrecognizedAnswer(input: $input) {
    id
  }
}
    `;
export const DeleteBlacklistItemDocument = `
    mutation deleteBlacklistItem($blacklistItemId: String!) {
  deleteBlacklistItem(id: $blacklistItemId) {
    objectsDeleted
  }
}
    `;
export const DeleteBookmarkDocument = `
    mutation deleteBookmark($bookmarkId: String!) {
  deleteBookmark(id: $bookmarkId) {
    objectsDeleted
  }
}
    `;
export const ExamAttemptDiscardDocument = `
    mutation examAttemptDiscard($bookId: String!, $sessionId: String!) {
  examAttemptDiscard(bookId: $bookId, sessionId: $sessionId)
}
    `;
export const ExamAttemptStartDocument = `
    mutation examAttemptStart($bookId: String!, $settings: ExamSettingsInput!) {
  examAttemptStart(bookId: $bookId, settings: $settings) {
    ...examSession
  }
}
    ${ExamSessionFragmentDoc}`;
export const ExamFinishDocument = `
    mutation examFinish($bookId: String!, $sessionId: String) {
  examFinish(bookId: $bookId, sessionId: $sessionId) {
    ...examSession
  }
}
    ${ExamSessionFragmentDoc}`;
export const ExamPositionSetDocument = `
    mutation examPositionSet($bookId: String!, $blockIndex: Int!, $questionIndex: Int!, $sessionId: String) {
  examPositionSet(
    bookId: $bookId
    blockIndex: $blockIndex
    questionIndex: $questionIndex
    sessionId: $sessionId
  ) {
    id
    commissionBlock
    commissionQuestion
  }
}
    `;
export const ExamQuestionRateDocument = `
    mutation examQuestionRate($bookId: String!, $questionId: String!, $rating: String!, $sessionId: String) {
  examQuestionRate(
    bookId: $bookId
    questionId: $questionId
    rating: $rating
    sessionId: $sessionId
  ) {
    ...examSession
  }
}
    ${ExamSessionFragmentDoc}`;
export const ExamRateSpeechDocument = `
    mutation examRateSpeech($bookId: String!, $rating: String!, $sessionId: String, $criterion: String) {
  examRateSpeech(
    bookId: $bookId
    rating: $rating
    sessionId: $sessionId
    criterion: $criterion
  ) {
    ...examSession
  }
}
    ${ExamSessionFragmentDoc}`;
export const ExamSpeechClipsSetDocument = `
    mutation examSpeechClipsSet($bookId: String!, $clips: ExamSpeechClipsInput!, $sessionId: String) {
  examSpeechClipsSet(bookId: $bookId, clips: $clips, sessionId: $sessionId) {
    ...examSession
  }
}
    ${ExamSessionFragmentDoc}`;
export const ExamStepSetDocument = `
    mutation examStepSet($bookId: String!, $step: String!, $sessionId: String) {
  examStepSet(bookId: $bookId, step: $step, sessionId: $sessionId) {
    ...examSession
  }
}
    ${ExamSessionFragmentDoc}`;
export const FlipNonfictionCardDocument = `
    mutation flipNonfictionCard($cardId: String!) {
  nonfictionCardFlip(cardId: $cardId) {
    ...nonfictionProgress
  }
}
    ${NonfictionProgressFragmentDoc}`;
export const FlipPracticeCardDocument = `
    mutation flipPracticeCard($bookId: String!, $cardId: String!) {
  practiceCardFlip(bookId: $bookId, cardId: $cardId) {
    ...userBookProgress
  }
}
    ${UserBookProgressFragmentDoc}`;
export const RateNonfictionQuizQuestionDocument = `
    mutation rateNonfictionQuizQuestion($questionId: String!, $verdict: String!) {
  nonfictionQuizQuestionRate(questionId: $questionId, verdict: $verdict) {
    attempt {
      ...nonfictionQuizAttempt
    }
    progress {
      ...nonfictionProgress
    }
  }
}
    ${NonfictionQuizAttemptFragmentDoc}
${NonfictionProgressFragmentDoc}`;
export const RateQuizQuestionDocument = `
    mutation rateQuizQuestion($bookId: String!, $questionId: String!, $verdict: String!) {
  practiceQuizQuestionRate(
    bookId: $bookId
    questionId: $questionId
    verdict: $verdict
  ) {
    ...practiceQuizAttempt
  }
}
    ${PracticeQuizAttemptFragmentDoc}`;
export const RemoveThemeFromBlackEnvelopeDocument = `
    mutation removeThemeFromBlackEnvelope($id: String!) {
  userThemeUpdate(id: $id, input: {isBlindSpot: false}) {
    isBlindSpot
  }
}
    `;
export const ResetOnboardingDocument = `
    mutation resetOnboarding {
  updatePhone(input: {phoneNumber: "", smsEnabled: false}) {
    status
  }
  updateOnboarding(input: {introduced: false, finished: false, welcome: false}) {
    introduced
    finished
  }
}
    `;
export const SaveBlacklistItemDocument = `
    mutation saveBlacklistItem($assignmentId: String!) {
  setBlacklistItem(input: {userAssignmentId: $assignmentId}) {
    id
  }
}
    `;
export const SaveBookmarkDocument = `
    mutation saveBookmark($assignmentId: String!) {
  setBookmark(input: {userAssignmentId: $assignmentId}) {
    id
  }
}
    `;
export const SendPhoneValidationCodeDocument = `
    mutation sendPhoneValidationCode($code: String!) {
  validatePhone(input: {validationCode: $code}) {
    status
  }
}
    `;
export const SessionCloseDocument = `
    mutation sessionClose($mood: Int!, $moodText: String!, $selfReflectionText: String!, $assignmentsClose: [AssignmentCloseInput!]!) {
  sessionClose(
    input: {mood: $mood, moodText: $moodText, moodSelfReflection: $selfReflectionText, assignmentsClose: $assignmentsClose}
  ) {
    finished
  }
}
    `;
export const SessionCreateDocument = `
    mutation sessionCreate($lengthPreference: Int!, $assignmentId: String) {
  sessionCreate(lengthPreference: $lengthPreference, assignmentId: $assignmentId) {
    id
    alreadyStarted
    userAssignments {
      assignment {
        assignment {
          assignmentAudio
          printingAttachment
        }
      }
      envelope
      subject {
        appName
      }
    }
    lastSessionMood
    lastSessionMoodText
    lastSessionMoodSelfReflection
  }
}
    `;
export const SessionStartDocument = `
    mutation sessionStart {
  sessionStart {
    id
    lengthActual
    alreadyStarted
    userAssignments {
      ...userAssignmentForExercise
    }
  }
}
    ${UserAssignmentForExerciseFragmentDoc}`;
export const SetTimetableGenericDocument = `
    mutation setTimetableGeneric($from: Date!, $to: Date!, $timeTable: [StudyDayGenericInput!]!) {
  setTimetableGeneric(input: {validFrom: $from, validTo: $to, plan: $timeTable}) {
    plan {
      dayName
      startAt
      duration
    }
  }
}
    `;
export const SetMasterclassVideoCompletedDocument = `
    mutation setMasterclassVideoCompleted($videoId: String!, $completed: Boolean!) {
  masterclassVideoCompleted(videoId: $videoId, completed: $completed) {
    ...masterclassProgress
  }
}
    ${MasterclassProgressFragmentDoc}`;
export const SetMasterclassVideoViewedDocument = `
    mutation setMasterclassVideoViewed($videoId: String!) {
  masterclassVideoViewed(videoId: $videoId) {
    ...masterclassProgress
  }
}
    ${MasterclassProgressFragmentDoc}`;
export const SetNonfictionProgressDocument = `
    mutation setNonfictionProgress($input: NonfictionProgressInput!) {
  nonfictionProgressSet(input: $input) {
    ...nonfictionProgress
  }
}
    ${NonfictionProgressFragmentDoc}`;
export const SetOnboardingFinishedDocument = `
    mutation setOnboardingFinished {
  updateOnboarding(input: {finished: true}) {
    finished
  }
}
    `;
export const SetOnboardingIntroducedDocument = `
    mutation setOnboardingIntroduced {
  updateOnboarding(input: {introduced: true}) {
    introduced
  }
}
    `;
export const SetTimetableDocument = `
    mutation setTimetable($timeTable: [StudyDayInput!]!) {
  setTimetable(input: {plan: $timeTable}) {
    dateStart
    dateEnd
    plan {
      dayIndex
      startAt
      duration
    }
  }
}
    `;
export const SetUserBookProgressDocument = `
    mutation setUserBookProgress($bookId: String!, $input: UserBookProgressInput!) {
  userBookProgressSet(bookId: $bookId, input: $input) {
    ...userBookProgress
  }
}
    ${UserBookProgressFragmentDoc}`;
export const SetUserBooksDocument = `
    mutation setUserBooks($bookIds: [String!]!) {
  userBooksSet(input: {bookIds: $bookIds}) {
    id
    bookId
    createdAt
  }
}
    `;
export const SetWelcomedDocument = `
    mutation setWelcomed {
  updateOnboarding(input: {welcome: true}) {
    welcome
  }
}
    `;
export const SolutionUploadConfirmDocument = `
    mutation solutionUploadConfirm($solutionUploadId: String!) {
  solutionUploadConfirm(input: {solutionUploadId: $solutionUploadId})
}
    `;
export const SolutionUploadUrlDocument = `
    mutation solutionUploadUrl($userAssignmentId: String!, $contentType: String!, $fileExtension: String!, $fileSize: Int!) {
  solutionUploadUrl(
    input: {contentType: $contentType, fileExtension: $fileExtension, fileSize: $fileSize, userAssignmentId: $userAssignmentId}
  ) {
    command
    uploadId
    url
  }
}
    `;
export const StartNonfictionQuizAttemptDocument = `
    mutation startNonfictionQuizAttempt {
  nonfictionQuizAttemptStart {
    ...nonfictionQuizAttempt
  }
}
    ${NonfictionQuizAttemptFragmentDoc}`;
export const StartQuizAttemptDocument = `
    mutation startQuizAttempt($bookId: String!) {
  practiceQuizAttemptStart(bookId: $bookId) {
    ...practiceQuizAttempt
  }
}
    ${PracticeQuizAttemptFragmentDoc}`;
export const TutoringClaimEvaluationDocument = `
    mutation tutoringClaimEvaluation($tutoringId: String!, $userAssignmentId: String!, $userAnswers: [Boolean!]!) {
  tutoringClaimEvaluation(
    claimInput: {tutoringId: $tutoringId, userAssignmentId: $userAssignmentId, questions: $userAnswers}
  ) {
    tutoringId
  }
}
    `;
export const TutoringResetDocument = `
    mutation tutoringReset($tutoringId: String!) {
  tutoringReset(input: {tutoringId: $tutoringId}) {
    message
  }
}
    `;
export const UpdateParentRewardsDocument = `
    mutation updateParentRewards($rewards: ParentWatchInput!) {
  parentWatchUpdate(inputRewards: $rewards) {
    message
    rewards {
      type
      targetScore
      month
      text
    }
  }
}
    `;
export const UpdatePhoneNumberDocument = `
    mutation updatePhoneNumber($phoneNumber: String!, $smsEnabled: Boolean!) {
  updatePhone(input: {phoneNumber: $phoneNumber, smsEnabled: $smsEnabled}) {
    status
    datetimeLast
  }
}
    `;
export const UpdateSoundDocument = `
    mutation updateSound($withSound: Boolean!) {
  updateUser(input: {withSound: $withSound}) {
    withSound
  }
}
    `;
export const UpdateUserPreferencesDocument = `
    mutation updateUserPreferences($phoneNumber: String!, $preferredSubject: String!, $smsEnabled: Boolean!) {
  updateUser(input: {preferredSubject: $preferredSubject}) {
    preferredSubject
  }
  updatePhone(input: {phoneNumber: $phoneNumber, smsEnabled: $smsEnabled}) {
    status
    datetimeLast
  }
}
    `;
export const UserLoginDocument = `
    mutation userLogin($token: String!) {
  login(loginInput: {handshake: $token}) {
    status
    accessToken
  }
}
    `;
export const ValidateAnswerDocument = `
    mutation validateAnswer($userAssignmentId: String!, $questions: [Boolean!]!) {
  claimEvaluation(
    claimInput: {userAssignmentId: $userAssignmentId, questions: $questions}
  ) {
    scoreReal
  }
}
    `;
export const BookExamAnswersDocument = `
    query bookExamAnswers($sessionId: String!) {
  bookExamAnswers(sessionId: $sessionId) {
    id
    questionId
    contentType
    durationMs
    createdAt
    playbackUrl
  }
}
    `;
export const CheckAchievementsDocument = `
    query checkAchievements {
  checkAchievements(check: true) {
    ...checkAchievements
  }
}
    ${CheckAchievementsFragmentDoc}`;
export const CheckNewAssignmentsDocument = `
    query checkNewAssignments {
  displayNewAssignmentAnnouncements {
    testType
    description
    date
  }
}
    `;
export const GetAllBlacklistItemsDocument = `
    query getAllBlacklistItems {
  blacklistItems {
    id
    userAssignment {
      id
    }
  }
}
    `;
export const GetAllBlacklistItemsWithSubjectDocument = `
    query getAllBlacklistItemsWithSubject {
  blacklistItems {
    id
    userAssignment {
      id
      subject {
        appName
      }
    }
  }
}
    `;
export const GetAllBookmarksDocument = `
    query getAllBookmarks {
  bookmarks {
    id
    userAssignment {
      id
    }
  }
}
    `;
export const GetAllBookmarksWithSubjectDocument = `
    query getAllBookmarksWithSubject {
  bookmarks {
    id
    userAssignment {
      id
      subject {
        appName
      }
    }
  }
}
    `;
export const GetAllTimetableGenericsDocument = `
    query getAllTimetableGenerics {
  timetableGenericAll {
    created
  }
}
    `;
export const GetAssignmentAnswersDocument = `
    query getAssignmentAnswers($assignmentId: String!) {
  assignments(idList: [$assignmentId]) {
    assignment {
      questions {
        correctAnswers
      }
    }
  }
}
    `;
export const GetAssignmentDetailForCmsDocument = `
    query getAssignmentDetailForCms($assignmentId: String!) {
  assignments(idList: [$assignmentId]) {
    ...assignmentDetail
  }
}
    ${AssignmentDetailFragmentDoc}`;
export const GetAssignmentsEnvelopesDocument = `
    query getAssignmentsEnvelopes($assignments: [String!]) {
  userAssignments(filterInput: {idList: $assignments, limit: 30}) {
    items {
      envelope
      id
    }
  }
}
    `;
export const GetAssignmentsInThemeDocument = `
    query getAssignmentsInTheme($themeId: String!) {
  userAssignmentsCached(filterInput: {themeId: $themeId, noPagination: true}) {
    items {
      id
    }
  }
}
    `;
export const GetBlacklistItemsAndSubjectsDocument = `
    query getBlacklistItemsAndSubjects {
  blacklistItems {
    ...assignmentForBlacklist
  }
  subjects {
    appName
  }
}
    ${AssignmentForBlacklistFragmentDoc}`;
export const GetBlacklistedPracticeAssignmentsDocument = `
    query getBlacklistedPracticeAssignments {
  blacklistItems {
    id
    userAssignment {
      ...userAssignmentPractice
    }
  }
}
    ${UserAssignmentPracticeFragmentDoc}`;
export const GetBlindSpotThemesDocument = `
    query getBlindSpotThemes {
  blindSpotThemes {
    ...blindSpotTheme
  }
}
    ${BlindSpotThemeFragmentDoc}`;
export const GetBookCardsDocument = `
    query getBookCards($bookId: String!) {
  bookCards(bookId: $bookId) {
    id
    categoryId
    question
    cardText
  }
}
    `;
export const GetBookDetailDocument = `
    query getBookDetail($idList: [String!]) {
  books(idList: $idList) {
    id
    nameCz
    nameOriginal
    authorFullName
    hasDetail
    authorCountry {
      id
      name
      emoji
    }
    graduationReadingPeriodId
    graduationReadingTypeId
    summary
    emojis
    hasEnglishUsage
    englishUsage
    genre {
      id
      name
      description
    }
    direction
    spacetime
    themes
    pagesCount
    readingLength
    firstPublicationYear
    mainPicture
    picture1
    picture2
    picture3
    picture4
    picture1Source
    picture2Source
    picture3Source
    picture4Source
    orderOnlineLink
    orderOnlineHasDiscount
    orderUsedLink
    orderUsedHasDiscount
    orderNewLink
    orderNewHasDiscount
    orderAudioLink
    orderAudioHasDiscount
    trailerUrl
    freeStreamingUrl
    paidStreamingUrl
    paidStreamingProvider
    bookDiff
    video
    podcastShort
    podcastLong
    cheatSheetShort
    cheatSheetLong
  }
  graduationReadingPeriods {
    id
    name
    shortcut
  }
  graduationReadingTypes {
    id
    name
    internalCode
    description
  }
}
    `;
export const GetBookListDocument = `
    query getBookList {
  books {
    id
    nameCz
  }
}
    `;
export const GetBookPracticeContentDocument = `
    query getBookPracticeContent($bookId: String!) {
  bookCards(bookId: $bookId) {
    id
    categoryId
    question
    cardText
  }
  qaCards(bookId: $bookId) {
    id
    categoryId
    question
    answer
    order
  }
  consolidationCategories {
    id
    position
    name
    focus
    textOrange
    textRed
    textGreen
    isArtText
  }
}
    `;
export const GetBookmarkedPracticeAssignmentsDocument = `
    query getBookmarkedPracticeAssignments {
  bookmarks {
    id
    userAssignment {
      ...userAssignmentPractice
    }
  }
}
    ${UserAssignmentPracticeFragmentDoc}`;
export const GetBookmarksAndSubjectsDocument = `
    query getBookmarksAndSubjects {
  bookmarks {
    ...assignmentForBookmark
  }
  subjects {
    appName
  }
}
    ${AssignmentForBookmarkFragmentDoc}`;
export const GetBookmarksCountDocument = `
    query getBookmarksCount {
  bookmarks {
    id
  }
}
    `;
export const GetBooksSelectionOverviewDocument = `
    query getBooksSelectionOverview($idList: [String!]) {
  graduationReadingPeriods {
    id
    name
    shortcut
    internalCode
    minBooks
  }
  graduationReadingTypes {
    id
    name
    internalCode
    minBooks
  }
  books(idList: $idList) {
    id
    nameCz
    authorFullName
    hasDetail
    graduationReadingPeriodId
    graduationReadingTypeId
    mainPicture
  }
}
    `;
export const GetConsolidationCategoriesDocument = `
    query getConsolidationCategories {
  consolidationCategories {
    id
    position
    name
    focus
    textOrange
    textRed
    textGreen
    isArtText
  }
}
    `;
export const GetAssignmentsInEnvelopeDocument = `
    query getAssignmentsInEnvelope($themeId: String!, $envelopeId: String!) {
  userAssignmentsCached(
    filterInput: {themeId: $themeId, envelope: $envelopeId, noPagination: true}
  ) {
    items {
      id
    }
  }
}
    `;
export const GetCurrentGenericTimetableDocument = `
    query getCurrentGenericTimetable {
  timetableGenericCurrent {
    created
  }
}
    `;
export const GetCurrentUserDocument = `
    query getCurrentUser {
  currentUser {
    admissionsDeadline
    email
    name
    vocative
    grade
    fullAccess
    sex
    testsToUnlock
    testsToBuy
    preferredSubject
    withSound
    phoneNumber
    phoneValidationDatetimeLast
    phoneValidationPhoneNumber
    preferredSchools {
      name
      pointsForAcceptance
    }
    onboarding {
      introduced
      finished
      welcome
    }
    firstLogin
    sessionsAchieved
    phoneValidationStatus
    phoneValidationRequired
    smsEnabled
    elixirOfLifeCount
    daysFulfillsPlan
    idExternalZona
  }
  timetableGenericAll {
    created
  }
}
    `;
export const GetDashboardDataDocument = `
    query getDashboardData($timetableFrom: Date!, $timetableTo: Date!) {
  displayOutages {
    ...outage
  }
  timetable(dateFrom: $timetableFrom, dateTo: $timetableTo) {
    timetable {
      dateStart
      dateEnd
      plan {
        ...studyDay
      }
    }
  }
  testPresence(refresh: true) {
    dateTime
  }
  envelopesSummary {
    ...envelopeSummary
  }
  lastAchievements(count: 4) {
    ...lastAchievement
  }
  checkAchievements(check: true) {
    ...checkAchievements
  }
  blacklistItems {
    id
  }
}
    ${OutageFragmentDoc}
${StudyDayFragmentDoc}
${EnvelopeSummaryFragmentDoc}
${LastAchievementFragmentDoc}
${CheckAchievementsFragmentDoc}`;
export const GetEnvelopeSubjectsThemesDocument = `
    query getEnvelopeSubjectsThemes($isRed: Boolean!, $isGreen: Boolean!, $isOrange: Boolean!) {
  subjects {
    id
    appAbbr
    appName
    isFavorite
  }
  userSubjects {
    scoreAggregatePercent
    subject {
      id
    }
  }
  userThemes {
    id
    ...userTheme
  }
  userSubjects @include(if: $isGreen) {
    assignmentsGreen
  }
  userSubjects @include(if: $isOrange) {
    assignmentsYellow
  }
  userSubjects @include(if: $isRed) {
    assignmentsRed
  }
  envelopesSummary {
    green
    yellow
    red
  }
}
    ${UserThemeFragmentDoc}`;
export const GetEnvelopeThemeAssignmentsDocument = `
    query getEnvelopeThemeAssignments($themeId: String!, $envelopeId: String!) {
  userAssignmentsCached(
    filterInput: {envelope: $envelopeId, themeId: $themeId, noPagination: true}
  ) {
    items {
      ...userAssignmentForTheme
    }
  }
}
    ${UserAssignmentForThemeFragmentDoc}`;
export const GetEnvelopeThemePracticeAssignmentsDocument = `
    query getEnvelopeThemePracticeAssignments($envelopeId: String!, $themeId: String!) {
  userAssignmentsCached(
    filterInput: {envelope: $envelopeId, themeId: $themeId, noPagination: true}
  ) {
    items {
      ...userAssignmentPractice
    }
  }
}
    ${UserAssignmentPracticeFragmentDoc}`;
export const GetExamCategoriesDocument = `
    query getExamCategories {
  examCategories {
    id
    position
    name
    focus
    textOrange
    textRed
    isArtText
  }
}
    `;
export const GetExamContentDocument = `
    query getExamContent($bookId: String!) {
  examCategories {
    id
    position
    name
    focus
    textOrange
    textRed
    isArtText
  }
  mockExamQuestions(bookId: $bookId) {
    id
    categoryId
    order
    question
    answer
  }
  probingQuestions(bookId: $bookId) {
    id
    categoryId
    order
    question
    answer
  }
  books(idList: [$bookId]) {
    id
    nameCz
    authorFullName
    worksheetBlank
  }
}
    `;
export const GetExamHistoryDocument = `
    query getExamHistory($limit: Int!, $offset: Int!, $bookId: String) {
  examHistory(limit: $limit, offset: $offset, bookId: $bookId) {
    id
    bookId
    bookName
    startedAt
    finishedAt
    step
    result {
      grade
      perCategory {
        categoryId
        level
      }
      sections {
        sectionId
        score
        points
        level
      }
    }
  }
}
    `;
export const GetExamSessionDocument = `
    query getExamSession($bookId: String!) {
  examSession(bookId: $bookId) {
    ...examSession
  }
}
    ${ExamSessionFragmentDoc}`;
export const GetExamSessionByIdDocument = `
    query getExamSessionById($sessionId: String!) {
  examSessionById(sessionId: $sessionId) {
    ...examSession
  }
}
    ${ExamSessionFragmentDoc}`;
export const GetFaqDocument = `
    query getFaq {
  faqAll {
    title
    description
  }
}
    `;
export const GetGraduationReadingOverviewDocument = `
    query getGraduationReadingOverview {
  graduationReadingPeriods {
    id
    name
    shortcut
    internalCode
    minBooks
  }
  graduationReadingTypes {
    id
    name
    internalCode
    minBooks
  }
  books {
    id
    nameCz
    authorFullName
    hasDetail
    authorCountry {
      id
      name
      emoji
    }
    graduationReadingPeriodId
    graduationReadingTypeId
    mainPicture
  }
}
    `;
export const GetHistoryAllDocument = `
    query getHistoryAll($limit: Int, $offset: Int) {
  userTutoringsAndSessions(limit: $limit, offset: $offset) {
    dateTested
    session {
      ...historySession
    }
    tutoring {
      ...historyTutoring
    }
  }
}
    ${HistorySessionFragmentDoc}
${HistoryTutoringFragmentDoc}`;
export const GetHistoryAssignmentDocument = `
    query getHistoryAssignment($assignmentId: String!) {
  userTutoringsAndSessions(assignmentId: $assignmentId) {
    dateTested
    session {
      envelopeMovements {
        userAssigment
        envelopeBefore
        envelopeNow
      }
    }
  }
}
    `;
export const GetHistorySessionsDocument = `
    query getHistorySessions {
  userTutoringsAndSessions {
    dateTested
    session {
      ...historySessionMinimal
    }
  }
}
    ${HistorySessionMinimalFragmentDoc}`;
export const GetHistoryTutoringsDocument = `
    query getHistoryTutorings {
  userTutoringsAndSessions {
    dateTested
    tutoring {
      ...historyTutoring
    }
  }
}
    ${HistoryTutoringFragmentDoc}`;
export const GetLearningAttemptsDocument = `
    query getLearningAttempts($limit: Int!, $offset: Int!) {
  learningAttempts(limit: $limit, offset: $offset) {
    id
    dateTested
    session {
      ...historySession
    }
    tutoringSnapshot {
      ...historyTutoringSnapshot
    }
  }
}
    ${HistorySessionFragmentDoc}
${HistoryTutoringSnapshotFragmentDoc}`;
export const GetMasterclassPageDocument = `
    query getMasterclassPage {
  masterclasses {
    id
    title
    order
    length
    video
    description
    pdf
    pdfName
    pdfDescription
    deadline
    note
    previewImage
  }
  masterclassSettings {
    id
    perex
    guideLabel
    guideName
    guidePhoto
    guideBio
    infoBox
  }
  masterclassProgress {
    ...masterclassProgress
  }
}
    ${MasterclassProgressFragmentDoc}`;
export const GetMySelectionOverviewDocument = `
    query getMySelectionOverview {
  graduationReadingPeriods {
    id
    name
    shortcut
    internalCode
    minBooks
  }
  graduationReadingTypes {
    id
    name
    internalCode
    minBooks
  }
  userSelectedBooks {
    id
    nameCz
    authorFullName
    hasDetail
    graduationReadingPeriodId
    graduationReadingTypeId
    mainPicture
  }
}
    `;
export const GetNonfictionContentDocument = `
    query getNonfictionContent {
  nonfictionText {
    id
    video
    coverArt
    cheatSheet
    cheatSheetName
    cheatSheetNote
  }
  nonfictionCategories {
    id
    position
    name
    heading
  }
  nonfictionCards {
    id
    categoryId
    position
    question
    cardText
  }
  nonfictionQaCards {
    id
    categoryId
    position
    question
    answer
  }
}
    `;
export const GetNonfictionProgressDocument = `
    query getNonfictionProgress {
  nonfictionProgress {
    ...nonfictionProgress
  }
  nonfictionQuizAttempt {
    ...nonfictionQuizAttempt
  }
}
    ${NonfictionProgressFragmentDoc}
${NonfictionQuizAttemptFragmentDoc}`;
export const GetOnboardingAssignmentsDocument = `
    query getOnboardingAssignments {
  userAssignments(filterInput: {isOnboarding: true}) {
    items {
      ...userAssignmentForExercise
    }
  }
}
    ${UserAssignmentForExerciseFragmentDoc}`;
export const GetOnboardingStatusDocument = `
    query getOnboardingStatus {
  onboarding {
    finished
  }
}
    `;
export const GetParentRewardsDocument = `
    query getParentRewards {
  parentWatch {
    message
    rewards {
      type
      targetScore
      month
      text
    }
    user {
      name
      admissionsDeadline
    }
  }
}
    `;
export const GetPracticeEnvelopeDocument = `
    query getPracticeEnvelope($envelopeId: String!) {
  trainingEnvelope(envelope: $envelopeId) {
    ...userAssignmentPractice
  }
}
    ${UserAssignmentPracticeFragmentDoc}`;
export const GetPracticeMhdDocument = `
    query getPracticeMhd($length: Int!) {
  trainingMhd(lengthPreference: $length) {
    userAssignments {
      ...userAssignmentForExerciseMinimumMhd
    }
  }
}
    ${UserAssignmentForExerciseMinimumMhdFragmentDoc}`;
export const GetPracticeMixDocument = `
    query getPracticeMix($length: Int!) {
  training(lengthPreference: $length) {
    userAssignments {
      ...userAssignmentForExerciseMinimum
    }
  }
}
    ${UserAssignmentForExerciseMinimumFragmentDoc}`;
export const GetPracticeQuizAttemptDocument = `
    query getPracticeQuizAttempt($bookId: String!) {
  practiceQuizAttempt(bookId: $bookId) {
    ...practiceQuizAttempt
  }
}
    ${PracticeQuizAttemptFragmentDoc}`;
export const GetQaCardsDocument = `
    query getQaCards($bookId: String!) {
  qaCards(bookId: $bookId) {
    id
    categoryId
    question
    answer
    order
  }
}
    `;
export const GetSessionResultsDocument = `
    query getSessionResults($dateFrom: Date!) {
  userSessionReview(dateFrom: $dateFrom) {
    dateTested
    scoreMaxTotal
    scoreRealTotal
  }
}
    `;
export const GetStatisticsDataDocument = `
    query getStatisticsData {
  checkAchievements {
    achievements {
      ...badge
    }
    aggregate {
      achievementType
      countTotal
      countNew
      dateLast
    }
  }
  parentWatch {
    message
    rewards {
      targetScore
      month
      text
    }
  }
}
    ${BadgeFragmentDoc}`;
export const GetStreakDocument = `
    query getStreak($streakFrom: Date!, $streakTo: Date!) {
  timetable(dateFrom: $streakFrom, dateTo: $streakTo) {
    daysFulfillsPlan
  }
}
    `;
export const GetSubjectsDocument = `
    query getSubjects {
  subjects {
    appAbbr
    appName
    isFavorite
    abbreviation
    slug
  }
}
    `;
export const GetSubjectsThemesDocument = `
    query getSubjectsThemes {
  subjectsCached {
    id
    appAbbr
    appName
    isFavorite
  }
  bookmarksCached {
    id
  }
  userSubjectsCached {
    scoreAggregatePercent
    assignmentsRed
    assignmentsGreen
    assignmentsYellow
    subject {
      id
    }
  }
  userThemes {
    id
    ...userTheme
  }
}
    ${UserThemeFragmentDoc}`;
export const GetTestPresencesDocument = `
    query getTestPresences {
  testPresence {
    dateTime
    scoreMath
    scoreCzech
    absolved
    form
  }
}
    `;
export const GetThemeDocument = `
    query getTheme($themeId: String!) {
  themes(idList: [$themeId]) {
    ...theme
  }
}
    ${ThemeFragmentDoc}`;
export const GetThemeAssignmentsDocument = `
    query getThemeAssignments($themeId: String!) {
  userAssignmentsCached(filterInput: {themeId: $themeId, noPagination: true}) {
    items {
      ...userAssignmentForTheme
    }
  }
}
    ${UserAssignmentForThemeFragmentDoc}`;
export const GetThemePracticeAssignmentsDocument = `
    query getThemePracticeAssignments($themeId: String!) {
  userAssignmentsCached(filterInput: {themeId: $themeId, noPagination: true}) {
    items {
      ...userAssignmentPractice
    }
  }
}
    ${UserAssignmentPracticeFragmentDoc}`;
export const GetTimetableDocument = `
    query getTimetable($dateFrom: Date!, $dateTo: Date!) {
  timetable(dateFrom: $dateFrom, dateTo: $dateTo) {
    timetable {
      dateStart
      dateEnd
      plan {
        ...studyDay
      }
    }
  }
  testPresence(refresh: false) {
    dateTime
  }
}
    ${StudyDayFragmentDoc}`;
export const GetTimetableGenericDocument = `
    query getTimetableGeneric {
  timetableGenericCurrent {
    plan {
      dayName
      startAt
      duration
    }
  }
}
    `;
export const GetTutoringListDocument = `
    query getTutoringList {
  userTutoringAll {
    id
    theme
  }
}
    `;
export const GetTutoringPracticeDocument = `
    query getTutoringPractice {
  userTutoringAll {
    ...userTutoringPractice
  }
}
    ${UserTutoringPracticeFragmentDoc}`;
export const GetTutoringPracticeByIdDocument = `
    query getTutoringPracticeById($tutoringId: String!) {
  userTutoringById(tutoringId: $tutoringId) {
    ...userTutoringPracticeById
  }
}
    ${UserTutoringPracticeByIdFragmentDoc}`;
export const GetTutoringThemesMinimumDocument = `
    query getTutoringThemesMinimum {
  userTutoringAll {
    ...userTutoringMinimum
  }
}
    ${UserTutoringMinimumFragmentDoc}`;
export const GetUnrecognizedAnswersDocument = `
    query getUnrecognizedAnswers($limit: Int, $offset: Int) {
  unrecognizedAnswers(filterInput: {limit: $limit, offset: $offset}) {
    items {
      id
      correctAnswer
      date
      questionNumber
      studentAnswer
      checked
      wasCorrect
      assignmentId
      userAssignmentId
      testName
      testOrder
    }
    totalCount
    acceptedCount
    rejectedCount
  }
}
    `;
export const GetUserAssignmentDocument = `
    query getUserAssignment($assignmentId: String!) {
  userAssignments(filterInput: {idList: [$assignmentId]}) {
    items {
      ...userAssignmentDetail
    }
  }
}
    ${UserAssignmentDetailFragmentDoc}`;
export const GetAssignmentsHistoryMinimumDocument = `
    query getAssignmentsHistoryMinimum($assignmentIds: [String!]!) {
  userAssignments(filterInput: {idList: $assignmentIds, limit: 30}) {
    items {
      ...assignmentHistoryMinimum
    }
  }
}
    ${AssignmentHistoryMinimumFragmentDoc}`;
export const GetUserAssignmentPaginatedDocument = `
    query getUserAssignmentPaginated($assignmentIds: [String!]!) {
  userAssignments(filterInput: {idList: $assignmentIds, limit: 30}) {
    items {
      ...userAssignmentDetail
    }
  }
}
    ${UserAssignmentDetailFragmentDoc}`;
export const GetAssignmentsTutoringMinimumDocument = `
    query getAssignmentsTutoringMinimum($assignmentIds: [String!]!) {
  userAssignments(filterInput: {idList: $assignmentIds, limit: 30}) {
    items {
      ...assignmentTutoringMinimum
    }
  }
}
    ${AssignmentTutoringMinimumFragmentDoc}`;
export const GetUserBookProgressDocument = `
    query getUserBookProgress($bookId: String!) {
  userBookProgress(bookId: $bookId) {
    ...userBookProgress
  }
}
    ${UserBookProgressFragmentDoc}`;
export const GetUserBookProgressAllDocument = `
    query getUserBookProgressAll {
  userBookProgressAll {
    id
    bookId
    hasLearned
    hasConsolidated
    hasTested
    grade
  }
}
    `;
export const GetUserBooksDocument = `
    query getUserBooks {
  userBooks {
    id
    bookId
    createdAt
  }
}
    `;
export const GetUserSubjectsDocument = `
    query getUserSubjects {
  userSubjects {
    subject {
      ...userSubject
    }
  }
}
    ${UserSubjectFragmentDoc}`;
export const GetUserThemeByIdDocument = `
    query getUserThemeById($userThemeId: String!) {
  userTheme(id: $userThemeId) {
    ...userTheme
  }
}
    ${UserThemeFragmentDoc}`;
export const GetUserThemesDocument = `
    query getUserThemes {
  userThemes {
    ...userTheme
  }
}
    ${UserThemeFragmentDoc}`;
export const GetVideoTipsDocument = `
    query getVideoTips {
  videotips(idList: null) {
    title
    url
    videotipCategory {
      name
      appName
      grade
    }
    previewImage
  }
}
    `;
export const GetWeeklyChallengesDocument = `
    query getWeeklyChallenges {
  weeklyChallenges {
    theme
  }
}
    `;
export const SearchAssignmentsDocument = `
    query searchAssignments($search: String!) {
  userAssignmentsFulltext(fulltextInput: {fulltext: $search}) {
    items {
      id
      ...userAssignmentForTheme
    }
    totalCount
  }
}
    ${UserAssignmentForThemeFragmentDoc}`;
export const StampedFileUrlDocument = `
    query stampedFileUrl($path: String!, $fileName: String) {
  stampedFileUrl(path: $path, fileName: $fileName)
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    bookExamAnswerConfirm: build.mutation<BookExamAnswerConfirmMutation, BookExamAnswerConfirmMutationVariables>({
      query: variables => ({ document: BookExamAnswerConfirmDocument, variables }),
    }),
    bookExamAnswerUploadUrl: build.mutation<BookExamAnswerUploadUrlMutation, BookExamAnswerUploadUrlMutationVariables>({
      query: variables => ({ document: BookExamAnswerUploadUrlDocument, variables }),
    }),
    checkAnswers: build.mutation<CheckAnswersMutation, CheckAnswersMutationVariables>({
      query: variables => ({ document: CheckAnswersDocument, variables }),
    }),
    checkTutoringAnswer: build.mutation<CheckTutoringAnswerMutation, CheckTutoringAnswerMutationVariables>({
      query: variables => ({ document: CheckTutoringAnswerDocument, variables }),
    }),
    createUnrecognizedAnswer: build.mutation<
      CreateUnrecognizedAnswerMutation,
      CreateUnrecognizedAnswerMutationVariables
    >({
      query: variables => ({ document: CreateUnrecognizedAnswerDocument, variables }),
    }),
    deleteBlacklistItem: build.mutation<DeleteBlacklistItemMutation, DeleteBlacklistItemMutationVariables>({
      query: variables => ({ document: DeleteBlacklistItemDocument, variables }),
    }),
    deleteBookmark: build.mutation<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>({
      query: variables => ({ document: DeleteBookmarkDocument, variables }),
    }),
    examAttemptDiscard: build.mutation<ExamAttemptDiscardMutation, ExamAttemptDiscardMutationVariables>({
      query: variables => ({ document: ExamAttemptDiscardDocument, variables }),
    }),
    examAttemptStart: build.mutation<ExamAttemptStartMutation, ExamAttemptStartMutationVariables>({
      query: variables => ({ document: ExamAttemptStartDocument, variables }),
    }),
    examFinish: build.mutation<ExamFinishMutation, ExamFinishMutationVariables>({
      query: variables => ({ document: ExamFinishDocument, variables }),
    }),
    examPositionSet: build.mutation<ExamPositionSetMutation, ExamPositionSetMutationVariables>({
      query: variables => ({ document: ExamPositionSetDocument, variables }),
    }),
    examQuestionRate: build.mutation<ExamQuestionRateMutation, ExamQuestionRateMutationVariables>({
      query: variables => ({ document: ExamQuestionRateDocument, variables }),
    }),
    examRateSpeech: build.mutation<ExamRateSpeechMutation, ExamRateSpeechMutationVariables>({
      query: variables => ({ document: ExamRateSpeechDocument, variables }),
    }),
    examSpeechClipsSet: build.mutation<ExamSpeechClipsSetMutation, ExamSpeechClipsSetMutationVariables>({
      query: variables => ({ document: ExamSpeechClipsSetDocument, variables }),
    }),
    examStepSet: build.mutation<ExamStepSetMutation, ExamStepSetMutationVariables>({
      query: variables => ({ document: ExamStepSetDocument, variables }),
    }),
    flipNonfictionCard: build.mutation<FlipNonfictionCardMutation, FlipNonfictionCardMutationVariables>({
      query: variables => ({ document: FlipNonfictionCardDocument, variables }),
    }),
    flipPracticeCard: build.mutation<FlipPracticeCardMutation, FlipPracticeCardMutationVariables>({
      query: variables => ({ document: FlipPracticeCardDocument, variables }),
    }),
    rateNonfictionQuizQuestion: build.mutation<
      RateNonfictionQuizQuestionMutation,
      RateNonfictionQuizQuestionMutationVariables
    >({
      query: variables => ({ document: RateNonfictionQuizQuestionDocument, variables }),
    }),
    rateQuizQuestion: build.mutation<RateQuizQuestionMutation, RateQuizQuestionMutationVariables>({
      query: variables => ({ document: RateQuizQuestionDocument, variables }),
    }),
    removeThemeFromBlackEnvelope: build.mutation<
      RemoveThemeFromBlackEnvelopeMutation,
      RemoveThemeFromBlackEnvelopeMutationVariables
    >({
      query: variables => ({ document: RemoveThemeFromBlackEnvelopeDocument, variables }),
    }),
    resetOnboarding: build.mutation<ResetOnboardingMutation, ResetOnboardingMutationVariables | void>({
      query: variables => ({ document: ResetOnboardingDocument, variables }),
    }),
    saveBlacklistItem: build.mutation<SaveBlacklistItemMutation, SaveBlacklistItemMutationVariables>({
      query: variables => ({ document: SaveBlacklistItemDocument, variables }),
    }),
    saveBookmark: build.mutation<SaveBookmarkMutation, SaveBookmarkMutationVariables>({
      query: variables => ({ document: SaveBookmarkDocument, variables }),
    }),
    sendPhoneValidationCode: build.mutation<SendPhoneValidationCodeMutation, SendPhoneValidationCodeMutationVariables>({
      query: variables => ({ document: SendPhoneValidationCodeDocument, variables }),
    }),
    sessionClose: build.mutation<SessionCloseMutation, SessionCloseMutationVariables>({
      query: variables => ({ document: SessionCloseDocument, variables }),
    }),
    sessionCreate: build.mutation<SessionCreateMutation, SessionCreateMutationVariables>({
      query: variables => ({ document: SessionCreateDocument, variables }),
    }),
    sessionStart: build.mutation<SessionStartMutation, SessionStartMutationVariables | void>({
      query: variables => ({ document: SessionStartDocument, variables }),
    }),
    setTimetableGeneric: build.mutation<SetTimetableGenericMutation, SetTimetableGenericMutationVariables>({
      query: variables => ({ document: SetTimetableGenericDocument, variables }),
    }),
    setMasterclassVideoCompleted: build.mutation<
      SetMasterclassVideoCompletedMutation,
      SetMasterclassVideoCompletedMutationVariables
    >({
      query: variables => ({ document: SetMasterclassVideoCompletedDocument, variables }),
    }),
    setMasterclassVideoViewed: build.mutation<
      SetMasterclassVideoViewedMutation,
      SetMasterclassVideoViewedMutationVariables
    >({
      query: variables => ({ document: SetMasterclassVideoViewedDocument, variables }),
    }),
    setNonfictionProgress: build.mutation<SetNonfictionProgressMutation, SetNonfictionProgressMutationVariables>({
      query: variables => ({ document: SetNonfictionProgressDocument, variables }),
    }),
    setOnboardingFinished: build.mutation<SetOnboardingFinishedMutation, SetOnboardingFinishedMutationVariables | void>(
      {
        query: variables => ({ document: SetOnboardingFinishedDocument, variables }),
      },
    ),
    setOnboardingIntroduced: build.mutation<
      SetOnboardingIntroducedMutation,
      SetOnboardingIntroducedMutationVariables | void
    >({
      query: variables => ({ document: SetOnboardingIntroducedDocument, variables }),
    }),
    setTimetable: build.mutation<SetTimetableMutation, SetTimetableMutationVariables>({
      query: variables => ({ document: SetTimetableDocument, variables }),
    }),
    setUserBookProgress: build.mutation<SetUserBookProgressMutation, SetUserBookProgressMutationVariables>({
      query: variables => ({ document: SetUserBookProgressDocument, variables }),
    }),
    setUserBooks: build.mutation<SetUserBooksMutation, SetUserBooksMutationVariables>({
      query: variables => ({ document: SetUserBooksDocument, variables }),
    }),
    setWelcomed: build.mutation<SetWelcomedMutation, SetWelcomedMutationVariables | void>({
      query: variables => ({ document: SetWelcomedDocument, variables }),
    }),
    solutionUploadConfirm: build.mutation<SolutionUploadConfirmMutation, SolutionUploadConfirmMutationVariables>({
      query: variables => ({ document: SolutionUploadConfirmDocument, variables }),
    }),
    solutionUploadUrl: build.mutation<SolutionUploadUrlMutation, SolutionUploadUrlMutationVariables>({
      query: variables => ({ document: SolutionUploadUrlDocument, variables }),
    }),
    startNonfictionQuizAttempt: build.mutation<
      StartNonfictionQuizAttemptMutation,
      StartNonfictionQuizAttemptMutationVariables | void
    >({
      query: variables => ({ document: StartNonfictionQuizAttemptDocument, variables }),
    }),
    startQuizAttempt: build.mutation<StartQuizAttemptMutation, StartQuizAttemptMutationVariables>({
      query: variables => ({ document: StartQuizAttemptDocument, variables }),
    }),
    tutoringClaimEvaluation: build.mutation<TutoringClaimEvaluationMutation, TutoringClaimEvaluationMutationVariables>({
      query: variables => ({ document: TutoringClaimEvaluationDocument, variables }),
    }),
    tutoringReset: build.mutation<TutoringResetMutation, TutoringResetMutationVariables>({
      query: variables => ({ document: TutoringResetDocument, variables }),
    }),
    updateParentRewards: build.mutation<UpdateParentRewardsMutation, UpdateParentRewardsMutationVariables>({
      query: variables => ({ document: UpdateParentRewardsDocument, variables }),
    }),
    updatePhoneNumber: build.mutation<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>({
      query: variables => ({ document: UpdatePhoneNumberDocument, variables }),
    }),
    updateSound: build.mutation<UpdateSoundMutation, UpdateSoundMutationVariables>({
      query: variables => ({ document: UpdateSoundDocument, variables }),
    }),
    updateUserPreferences: build.mutation<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>({
      query: variables => ({ document: UpdateUserPreferencesDocument, variables }),
    }),
    userLogin: build.mutation<UserLoginMutation, UserLoginMutationVariables>({
      query: variables => ({ document: UserLoginDocument, variables }),
    }),
    validateAnswer: build.mutation<ValidateAnswerMutation, ValidateAnswerMutationVariables>({
      query: variables => ({ document: ValidateAnswerDocument, variables }),
    }),
    bookExamAnswers: build.query<BookExamAnswersQuery, BookExamAnswersQueryVariables>({
      query: variables => ({ document: BookExamAnswersDocument, variables }),
    }),
    checkAchievements: build.query<CheckAchievementsQuery, CheckAchievementsQueryVariables | void>({
      query: variables => ({ document: CheckAchievementsDocument, variables }),
    }),
    checkNewAssignments: build.query<CheckNewAssignmentsQuery, CheckNewAssignmentsQueryVariables | void>({
      query: variables => ({ document: CheckNewAssignmentsDocument, variables }),
    }),
    getAllBlacklistItems: build.query<GetAllBlacklistItemsQuery, GetAllBlacklistItemsQueryVariables | void>({
      query: variables => ({ document: GetAllBlacklistItemsDocument, variables }),
    }),
    getAllBlacklistItemsWithSubject: build.query<
      GetAllBlacklistItemsWithSubjectQuery,
      GetAllBlacklistItemsWithSubjectQueryVariables | void
    >({
      query: variables => ({ document: GetAllBlacklistItemsWithSubjectDocument, variables }),
    }),
    getAllBookmarks: build.query<GetAllBookmarksQuery, GetAllBookmarksQueryVariables | void>({
      query: variables => ({ document: GetAllBookmarksDocument, variables }),
    }),
    getAllBookmarksWithSubject: build.query<
      GetAllBookmarksWithSubjectQuery,
      GetAllBookmarksWithSubjectQueryVariables | void
    >({
      query: variables => ({ document: GetAllBookmarksWithSubjectDocument, variables }),
    }),
    getAllTimetableGenerics: build.query<GetAllTimetableGenericsQuery, GetAllTimetableGenericsQueryVariables | void>({
      query: variables => ({ document: GetAllTimetableGenericsDocument, variables }),
    }),
    getAssignmentAnswers: build.query<GetAssignmentAnswersQuery, GetAssignmentAnswersQueryVariables>({
      query: variables => ({ document: GetAssignmentAnswersDocument, variables }),
    }),
    getAssignmentDetailForCms: build.query<GetAssignmentDetailForCmsQuery, GetAssignmentDetailForCmsQueryVariables>({
      query: variables => ({ document: GetAssignmentDetailForCmsDocument, variables }),
    }),
    getAssignmentsEnvelopes: build.query<GetAssignmentsEnvelopesQuery, GetAssignmentsEnvelopesQueryVariables | void>({
      query: variables => ({ document: GetAssignmentsEnvelopesDocument, variables }),
    }),
    getAssignmentsInTheme: build.query<GetAssignmentsInThemeQuery, GetAssignmentsInThemeQueryVariables>({
      query: variables => ({ document: GetAssignmentsInThemeDocument, variables }),
    }),
    getBlacklistItemsAndSubjects: build.query<
      GetBlacklistItemsAndSubjectsQuery,
      GetBlacklistItemsAndSubjectsQueryVariables | void
    >({
      query: variables => ({ document: GetBlacklistItemsAndSubjectsDocument, variables }),
    }),
    getBlacklistedPracticeAssignments: build.query<
      GetBlacklistedPracticeAssignmentsQuery,
      GetBlacklistedPracticeAssignmentsQueryVariables | void
    >({
      query: variables => ({ document: GetBlacklistedPracticeAssignmentsDocument, variables }),
    }),
    getBlindSpotThemes: build.query<GetBlindSpotThemesQuery, GetBlindSpotThemesQueryVariables | void>({
      query: variables => ({ document: GetBlindSpotThemesDocument, variables }),
    }),
    getBookCards: build.query<GetBookCardsQuery, GetBookCardsQueryVariables>({
      query: variables => ({ document: GetBookCardsDocument, variables }),
    }),
    getBookDetail: build.query<GetBookDetailQuery, GetBookDetailQueryVariables | void>({
      query: variables => ({ document: GetBookDetailDocument, variables }),
    }),
    getBookList: build.query<GetBookListQuery, GetBookListQueryVariables | void>({
      query: variables => ({ document: GetBookListDocument, variables }),
    }),
    getBookPracticeContent: build.query<GetBookPracticeContentQuery, GetBookPracticeContentQueryVariables>({
      query: variables => ({ document: GetBookPracticeContentDocument, variables }),
    }),
    getBookmarkedPracticeAssignments: build.query<
      GetBookmarkedPracticeAssignmentsQuery,
      GetBookmarkedPracticeAssignmentsQueryVariables | void
    >({
      query: variables => ({ document: GetBookmarkedPracticeAssignmentsDocument, variables }),
    }),
    getBookmarksAndSubjects: build.query<GetBookmarksAndSubjectsQuery, GetBookmarksAndSubjectsQueryVariables | void>({
      query: variables => ({ document: GetBookmarksAndSubjectsDocument, variables }),
    }),
    getBookmarksCount: build.query<GetBookmarksCountQuery, GetBookmarksCountQueryVariables | void>({
      query: variables => ({ document: GetBookmarksCountDocument, variables }),
    }),
    getBooksSelectionOverview: build.query<
      GetBooksSelectionOverviewQuery,
      GetBooksSelectionOverviewQueryVariables | void
    >({
      query: variables => ({ document: GetBooksSelectionOverviewDocument, variables }),
    }),
    getConsolidationCategories: build.query<
      GetConsolidationCategoriesQuery,
      GetConsolidationCategoriesQueryVariables | void
    >({
      query: variables => ({ document: GetConsolidationCategoriesDocument, variables }),
    }),
    getAssignmentsInEnvelope: build.query<GetAssignmentsInEnvelopeQuery, GetAssignmentsInEnvelopeQueryVariables>({
      query: variables => ({ document: GetAssignmentsInEnvelopeDocument, variables }),
    }),
    getCurrentGenericTimetable: build.query<
      GetCurrentGenericTimetableQuery,
      GetCurrentGenericTimetableQueryVariables | void
    >({
      query: variables => ({ document: GetCurrentGenericTimetableDocument, variables }),
    }),
    getCurrentUser: build.query<GetCurrentUserQuery, GetCurrentUserQueryVariables | void>({
      query: variables => ({ document: GetCurrentUserDocument, variables }),
    }),
    getDashboardData: build.query<GetDashboardDataQuery, GetDashboardDataQueryVariables>({
      query: variables => ({ document: GetDashboardDataDocument, variables }),
    }),
    getEnvelopeSubjectsThemes: build.query<GetEnvelopeSubjectsThemesQuery, GetEnvelopeSubjectsThemesQueryVariables>({
      query: variables => ({ document: GetEnvelopeSubjectsThemesDocument, variables }),
    }),
    getEnvelopeThemeAssignments: build.query<
      GetEnvelopeThemeAssignmentsQuery,
      GetEnvelopeThemeAssignmentsQueryVariables
    >({
      query: variables => ({ document: GetEnvelopeThemeAssignmentsDocument, variables }),
    }),
    getEnvelopeThemePracticeAssignments: build.query<
      GetEnvelopeThemePracticeAssignmentsQuery,
      GetEnvelopeThemePracticeAssignmentsQueryVariables
    >({
      query: variables => ({ document: GetEnvelopeThemePracticeAssignmentsDocument, variables }),
    }),
    getExamCategories: build.query<GetExamCategoriesQuery, GetExamCategoriesQueryVariables | void>({
      query: variables => ({ document: GetExamCategoriesDocument, variables }),
    }),
    getExamContent: build.query<GetExamContentQuery, GetExamContentQueryVariables>({
      query: variables => ({ document: GetExamContentDocument, variables }),
    }),
    getExamHistory: build.query<GetExamHistoryQuery, GetExamHistoryQueryVariables>({
      query: variables => ({ document: GetExamHistoryDocument, variables }),
    }),
    getExamSession: build.query<GetExamSessionQuery, GetExamSessionQueryVariables>({
      query: variables => ({ document: GetExamSessionDocument, variables }),
    }),
    getExamSessionById: build.query<GetExamSessionByIdQuery, GetExamSessionByIdQueryVariables>({
      query: variables => ({ document: GetExamSessionByIdDocument, variables }),
    }),
    getFaq: build.query<GetFaqQuery, GetFaqQueryVariables | void>({
      query: variables => ({ document: GetFaqDocument, variables }),
    }),
    getGraduationReadingOverview: build.query<
      GetGraduationReadingOverviewQuery,
      GetGraduationReadingOverviewQueryVariables | void
    >({
      query: variables => ({ document: GetGraduationReadingOverviewDocument, variables }),
    }),
    getHistoryAll: build.query<GetHistoryAllQuery, GetHistoryAllQueryVariables | void>({
      query: variables => ({ document: GetHistoryAllDocument, variables }),
    }),
    getHistoryAssignment: build.query<GetHistoryAssignmentQuery, GetHistoryAssignmentQueryVariables>({
      query: variables => ({ document: GetHistoryAssignmentDocument, variables }),
    }),
    getHistorySessions: build.query<GetHistorySessionsQuery, GetHistorySessionsQueryVariables | void>({
      query: variables => ({ document: GetHistorySessionsDocument, variables }),
    }),
    getHistoryTutorings: build.query<GetHistoryTutoringsQuery, GetHistoryTutoringsQueryVariables | void>({
      query: variables => ({ document: GetHistoryTutoringsDocument, variables }),
    }),
    getLearningAttempts: build.query<GetLearningAttemptsQuery, GetLearningAttemptsQueryVariables>({
      query: variables => ({ document: GetLearningAttemptsDocument, variables }),
    }),
    getMasterclassPage: build.query<GetMasterclassPageQuery, GetMasterclassPageQueryVariables | void>({
      query: variables => ({ document: GetMasterclassPageDocument, variables }),
    }),
    getMySelectionOverview: build.query<GetMySelectionOverviewQuery, GetMySelectionOverviewQueryVariables | void>({
      query: variables => ({ document: GetMySelectionOverviewDocument, variables }),
    }),
    getNonfictionContent: build.query<GetNonfictionContentQuery, GetNonfictionContentQueryVariables | void>({
      query: variables => ({ document: GetNonfictionContentDocument, variables }),
    }),
    getNonfictionProgress: build.query<GetNonfictionProgressQuery, GetNonfictionProgressQueryVariables | void>({
      query: variables => ({ document: GetNonfictionProgressDocument, variables }),
    }),
    getOnboardingAssignments: build.query<GetOnboardingAssignmentsQuery, GetOnboardingAssignmentsQueryVariables | void>(
      {
        query: variables => ({ document: GetOnboardingAssignmentsDocument, variables }),
      },
    ),
    getOnboardingStatus: build.query<GetOnboardingStatusQuery, GetOnboardingStatusQueryVariables | void>({
      query: variables => ({ document: GetOnboardingStatusDocument, variables }),
    }),
    getParentRewards: build.query<GetParentRewardsQuery, GetParentRewardsQueryVariables | void>({
      query: variables => ({ document: GetParentRewardsDocument, variables }),
    }),
    getPracticeEnvelope: build.query<GetPracticeEnvelopeQuery, GetPracticeEnvelopeQueryVariables>({
      query: variables => ({ document: GetPracticeEnvelopeDocument, variables }),
    }),
    getPracticeMhd: build.query<GetPracticeMhdQuery, GetPracticeMhdQueryVariables>({
      query: variables => ({ document: GetPracticeMhdDocument, variables }),
    }),
    getPracticeMix: build.query<GetPracticeMixQuery, GetPracticeMixQueryVariables>({
      query: variables => ({ document: GetPracticeMixDocument, variables }),
    }),
    getPracticeQuizAttempt: build.query<GetPracticeQuizAttemptQuery, GetPracticeQuizAttemptQueryVariables>({
      query: variables => ({ document: GetPracticeQuizAttemptDocument, variables }),
    }),
    getQaCards: build.query<GetQaCardsQuery, GetQaCardsQueryVariables>({
      query: variables => ({ document: GetQaCardsDocument, variables }),
    }),
    getSessionResults: build.query<GetSessionResultsQuery, GetSessionResultsQueryVariables>({
      query: variables => ({ document: GetSessionResultsDocument, variables }),
    }),
    getStatisticsData: build.query<GetStatisticsDataQuery, GetStatisticsDataQueryVariables | void>({
      query: variables => ({ document: GetStatisticsDataDocument, variables }),
    }),
    getStreak: build.query<GetStreakQuery, GetStreakQueryVariables>({
      query: variables => ({ document: GetStreakDocument, variables }),
    }),
    getSubjects: build.query<GetSubjectsQuery, GetSubjectsQueryVariables | void>({
      query: variables => ({ document: GetSubjectsDocument, variables }),
    }),
    getSubjectsThemes: build.query<GetSubjectsThemesQuery, GetSubjectsThemesQueryVariables | void>({
      query: variables => ({ document: GetSubjectsThemesDocument, variables }),
    }),
    getTestPresences: build.query<GetTestPresencesQuery, GetTestPresencesQueryVariables | void>({
      query: variables => ({ document: GetTestPresencesDocument, variables }),
    }),
    getTheme: build.query<GetThemeQuery, GetThemeQueryVariables>({
      query: variables => ({ document: GetThemeDocument, variables }),
    }),
    getThemeAssignments: build.query<GetThemeAssignmentsQuery, GetThemeAssignmentsQueryVariables>({
      query: variables => ({ document: GetThemeAssignmentsDocument, variables }),
    }),
    getThemePracticeAssignments: build.query<
      GetThemePracticeAssignmentsQuery,
      GetThemePracticeAssignmentsQueryVariables
    >({
      query: variables => ({ document: GetThemePracticeAssignmentsDocument, variables }),
    }),
    getTimetable: build.query<GetTimetableQuery, GetTimetableQueryVariables>({
      query: variables => ({ document: GetTimetableDocument, variables }),
    }),
    getTimetableGeneric: build.query<GetTimetableGenericQuery, GetTimetableGenericQueryVariables | void>({
      query: variables => ({ document: GetTimetableGenericDocument, variables }),
    }),
    getTutoringList: build.query<GetTutoringListQuery, GetTutoringListQueryVariables | void>({
      query: variables => ({ document: GetTutoringListDocument, variables }),
    }),
    getTutoringPractice: build.query<GetTutoringPracticeQuery, GetTutoringPracticeQueryVariables | void>({
      query: variables => ({ document: GetTutoringPracticeDocument, variables }),
    }),
    getTutoringPracticeById: build.query<GetTutoringPracticeByIdQuery, GetTutoringPracticeByIdQueryVariables>({
      query: variables => ({ document: GetTutoringPracticeByIdDocument, variables }),
    }),
    getTutoringThemesMinimum: build.query<GetTutoringThemesMinimumQuery, GetTutoringThemesMinimumQueryVariables | void>(
      {
        query: variables => ({ document: GetTutoringThemesMinimumDocument, variables }),
      },
    ),
    getUnrecognizedAnswers: build.query<GetUnrecognizedAnswersQuery, GetUnrecognizedAnswersQueryVariables | void>({
      query: variables => ({ document: GetUnrecognizedAnswersDocument, variables }),
    }),
    getUserAssignment: build.query<GetUserAssignmentQuery, GetUserAssignmentQueryVariables>({
      query: variables => ({ document: GetUserAssignmentDocument, variables }),
    }),
    getAssignmentsHistoryMinimum: build.query<
      GetAssignmentsHistoryMinimumQuery,
      GetAssignmentsHistoryMinimumQueryVariables
    >({
      query: variables => ({ document: GetAssignmentsHistoryMinimumDocument, variables }),
    }),
    getUserAssignmentPaginated: build.query<GetUserAssignmentPaginatedQuery, GetUserAssignmentPaginatedQueryVariables>({
      query: variables => ({ document: GetUserAssignmentPaginatedDocument, variables }),
    }),
    getAssignmentsTutoringMinimum: build.query<
      GetAssignmentsTutoringMinimumQuery,
      GetAssignmentsTutoringMinimumQueryVariables
    >({
      query: variables => ({ document: GetAssignmentsTutoringMinimumDocument, variables }),
    }),
    getUserBookProgress: build.query<GetUserBookProgressQuery, GetUserBookProgressQueryVariables>({
      query: variables => ({ document: GetUserBookProgressDocument, variables }),
    }),
    getUserBookProgressAll: build.query<GetUserBookProgressAllQuery, GetUserBookProgressAllQueryVariables | void>({
      query: variables => ({ document: GetUserBookProgressAllDocument, variables }),
    }),
    getUserBooks: build.query<GetUserBooksQuery, GetUserBooksQueryVariables | void>({
      query: variables => ({ document: GetUserBooksDocument, variables }),
    }),
    getUserSubjects: build.query<GetUserSubjectsQuery, GetUserSubjectsQueryVariables | void>({
      query: variables => ({ document: GetUserSubjectsDocument, variables }),
    }),
    getUserThemeById: build.query<GetUserThemeByIdQuery, GetUserThemeByIdQueryVariables>({
      query: variables => ({ document: GetUserThemeByIdDocument, variables }),
    }),
    getUserThemes: build.query<GetUserThemesQuery, GetUserThemesQueryVariables | void>({
      query: variables => ({ document: GetUserThemesDocument, variables }),
    }),
    getVideoTips: build.query<GetVideoTipsQuery, GetVideoTipsQueryVariables | void>({
      query: variables => ({ document: GetVideoTipsDocument, variables }),
    }),
    getWeeklyChallenges: build.query<GetWeeklyChallengesQuery, GetWeeklyChallengesQueryVariables | void>({
      query: variables => ({ document: GetWeeklyChallengesDocument, variables }),
    }),
    searchAssignments: build.query<SearchAssignmentsQuery, SearchAssignmentsQueryVariables>({
      query: variables => ({ document: SearchAssignmentsDocument, variables }),
    }),
    stampedFileUrl: build.query<StampedFileUrlQuery, StampedFileUrlQueryVariables>({
      query: variables => ({ document: StampedFileUrlDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useBookExamAnswerConfirmMutation,
  useBookExamAnswerUploadUrlMutation,
  useCheckAnswersMutation,
  useCheckTutoringAnswerMutation,
  useCreateUnrecognizedAnswerMutation,
  useDeleteBlacklistItemMutation,
  useDeleteBookmarkMutation,
  useExamAttemptDiscardMutation,
  useExamAttemptStartMutation,
  useExamFinishMutation,
  useExamPositionSetMutation,
  useExamQuestionRateMutation,
  useExamRateSpeechMutation,
  useExamSpeechClipsSetMutation,
  useExamStepSetMutation,
  useFlipNonfictionCardMutation,
  useFlipPracticeCardMutation,
  useRateNonfictionQuizQuestionMutation,
  useRateQuizQuestionMutation,
  useRemoveThemeFromBlackEnvelopeMutation,
  useResetOnboardingMutation,
  useSaveBlacklistItemMutation,
  useSaveBookmarkMutation,
  useSendPhoneValidationCodeMutation,
  useSessionCloseMutation,
  useSessionCreateMutation,
  useSessionStartMutation,
  useSetTimetableGenericMutation,
  useSetMasterclassVideoCompletedMutation,
  useSetMasterclassVideoViewedMutation,
  useSetNonfictionProgressMutation,
  useSetOnboardingFinishedMutation,
  useSetOnboardingIntroducedMutation,
  useSetTimetableMutation,
  useSetUserBookProgressMutation,
  useSetUserBooksMutation,
  useSetWelcomedMutation,
  useSolutionUploadConfirmMutation,
  useSolutionUploadUrlMutation,
  useStartNonfictionQuizAttemptMutation,
  useStartQuizAttemptMutation,
  useTutoringClaimEvaluationMutation,
  useTutoringResetMutation,
  useUpdateParentRewardsMutation,
  useUpdatePhoneNumberMutation,
  useUpdateSoundMutation,
  useUpdateUserPreferencesMutation,
  useUserLoginMutation,
  useValidateAnswerMutation,
  useBookExamAnswersQuery,
  useLazyBookExamAnswersQuery,
  useCheckAchievementsQuery,
  useLazyCheckAchievementsQuery,
  useCheckNewAssignmentsQuery,
  useLazyCheckNewAssignmentsQuery,
  useGetAllBlacklistItemsQuery,
  useLazyGetAllBlacklistItemsQuery,
  useGetAllBlacklistItemsWithSubjectQuery,
  useLazyGetAllBlacklistItemsWithSubjectQuery,
  useGetAllBookmarksQuery,
  useLazyGetAllBookmarksQuery,
  useGetAllBookmarksWithSubjectQuery,
  useLazyGetAllBookmarksWithSubjectQuery,
  useGetAllTimetableGenericsQuery,
  useLazyGetAllTimetableGenericsQuery,
  useGetAssignmentAnswersQuery,
  useLazyGetAssignmentAnswersQuery,
  useGetAssignmentDetailForCmsQuery,
  useLazyGetAssignmentDetailForCmsQuery,
  useGetAssignmentsEnvelopesQuery,
  useLazyGetAssignmentsEnvelopesQuery,
  useGetAssignmentsInThemeQuery,
  useLazyGetAssignmentsInThemeQuery,
  useGetBlacklistItemsAndSubjectsQuery,
  useLazyGetBlacklistItemsAndSubjectsQuery,
  useGetBlacklistedPracticeAssignmentsQuery,
  useLazyGetBlacklistedPracticeAssignmentsQuery,
  useGetBlindSpotThemesQuery,
  useLazyGetBlindSpotThemesQuery,
  useGetBookCardsQuery,
  useLazyGetBookCardsQuery,
  useGetBookDetailQuery,
  useLazyGetBookDetailQuery,
  useGetBookListQuery,
  useLazyGetBookListQuery,
  useGetBookPracticeContentQuery,
  useLazyGetBookPracticeContentQuery,
  useGetBookmarkedPracticeAssignmentsQuery,
  useLazyGetBookmarkedPracticeAssignmentsQuery,
  useGetBookmarksAndSubjectsQuery,
  useLazyGetBookmarksAndSubjectsQuery,
  useGetBookmarksCountQuery,
  useLazyGetBookmarksCountQuery,
  useGetBooksSelectionOverviewQuery,
  useLazyGetBooksSelectionOverviewQuery,
  useGetConsolidationCategoriesQuery,
  useLazyGetConsolidationCategoriesQuery,
  useGetAssignmentsInEnvelopeQuery,
  useLazyGetAssignmentsInEnvelopeQuery,
  useGetCurrentGenericTimetableQuery,
  useLazyGetCurrentGenericTimetableQuery,
  useGetCurrentUserQuery,
  useLazyGetCurrentUserQuery,
  useGetDashboardDataQuery,
  useLazyGetDashboardDataQuery,
  useGetEnvelopeSubjectsThemesQuery,
  useLazyGetEnvelopeSubjectsThemesQuery,
  useGetEnvelopeThemeAssignmentsQuery,
  useLazyGetEnvelopeThemeAssignmentsQuery,
  useGetEnvelopeThemePracticeAssignmentsQuery,
  useLazyGetEnvelopeThemePracticeAssignmentsQuery,
  useGetExamCategoriesQuery,
  useLazyGetExamCategoriesQuery,
  useGetExamContentQuery,
  useLazyGetExamContentQuery,
  useGetExamHistoryQuery,
  useLazyGetExamHistoryQuery,
  useGetExamSessionQuery,
  useLazyGetExamSessionQuery,
  useGetExamSessionByIdQuery,
  useLazyGetExamSessionByIdQuery,
  useGetFaqQuery,
  useLazyGetFaqQuery,
  useGetGraduationReadingOverviewQuery,
  useLazyGetGraduationReadingOverviewQuery,
  useGetHistoryAllQuery,
  useLazyGetHistoryAllQuery,
  useGetHistoryAssignmentQuery,
  useLazyGetHistoryAssignmentQuery,
  useGetHistorySessionsQuery,
  useLazyGetHistorySessionsQuery,
  useGetHistoryTutoringsQuery,
  useLazyGetHistoryTutoringsQuery,
  useGetLearningAttemptsQuery,
  useLazyGetLearningAttemptsQuery,
  useGetMasterclassPageQuery,
  useLazyGetMasterclassPageQuery,
  useGetMySelectionOverviewQuery,
  useLazyGetMySelectionOverviewQuery,
  useGetNonfictionContentQuery,
  useLazyGetNonfictionContentQuery,
  useGetNonfictionProgressQuery,
  useLazyGetNonfictionProgressQuery,
  useGetOnboardingAssignmentsQuery,
  useLazyGetOnboardingAssignmentsQuery,
  useGetOnboardingStatusQuery,
  useLazyGetOnboardingStatusQuery,
  useGetParentRewardsQuery,
  useLazyGetParentRewardsQuery,
  useGetPracticeEnvelopeQuery,
  useLazyGetPracticeEnvelopeQuery,
  useGetPracticeMhdQuery,
  useLazyGetPracticeMhdQuery,
  useGetPracticeMixQuery,
  useLazyGetPracticeMixQuery,
  useGetPracticeQuizAttemptQuery,
  useLazyGetPracticeQuizAttemptQuery,
  useGetQaCardsQuery,
  useLazyGetQaCardsQuery,
  useGetSessionResultsQuery,
  useLazyGetSessionResultsQuery,
  useGetStatisticsDataQuery,
  useLazyGetStatisticsDataQuery,
  useGetStreakQuery,
  useLazyGetStreakQuery,
  useGetSubjectsQuery,
  useLazyGetSubjectsQuery,
  useGetSubjectsThemesQuery,
  useLazyGetSubjectsThemesQuery,
  useGetTestPresencesQuery,
  useLazyGetTestPresencesQuery,
  useGetThemeQuery,
  useLazyGetThemeQuery,
  useGetThemeAssignmentsQuery,
  useLazyGetThemeAssignmentsQuery,
  useGetThemePracticeAssignmentsQuery,
  useLazyGetThemePracticeAssignmentsQuery,
  useGetTimetableQuery,
  useLazyGetTimetableQuery,
  useGetTimetableGenericQuery,
  useLazyGetTimetableGenericQuery,
  useGetTutoringListQuery,
  useLazyGetTutoringListQuery,
  useGetTutoringPracticeQuery,
  useLazyGetTutoringPracticeQuery,
  useGetTutoringPracticeByIdQuery,
  useLazyGetTutoringPracticeByIdQuery,
  useGetTutoringThemesMinimumQuery,
  useLazyGetTutoringThemesMinimumQuery,
  useGetUnrecognizedAnswersQuery,
  useLazyGetUnrecognizedAnswersQuery,
  useGetUserAssignmentQuery,
  useLazyGetUserAssignmentQuery,
  useGetAssignmentsHistoryMinimumQuery,
  useLazyGetAssignmentsHistoryMinimumQuery,
  useGetUserAssignmentPaginatedQuery,
  useLazyGetUserAssignmentPaginatedQuery,
  useGetAssignmentsTutoringMinimumQuery,
  useLazyGetAssignmentsTutoringMinimumQuery,
  useGetUserBookProgressQuery,
  useLazyGetUserBookProgressQuery,
  useGetUserBookProgressAllQuery,
  useLazyGetUserBookProgressAllQuery,
  useGetUserBooksQuery,
  useLazyGetUserBooksQuery,
  useGetUserSubjectsQuery,
  useLazyGetUserSubjectsQuery,
  useGetUserThemeByIdQuery,
  useLazyGetUserThemeByIdQuery,
  useGetUserThemesQuery,
  useLazyGetUserThemesQuery,
  useGetVideoTipsQuery,
  useLazyGetVideoTipsQuery,
  useGetWeeklyChallengesQuery,
  useLazyGetWeeklyChallengesQuery,
  useSearchAssignmentsQuery,
  useLazySearchAssignmentsQuery,
  useStampedFileUrlQuery,
  useLazyStampedFileUrlQuery,
} = injectedRtkApi;
